;(function() {
/*! AdService 2
 *
 *  @version 2.7.4
 *
 *  @author Marcus Klumpp
 *  @see Wiki:TAM/AdService2
 */

var securedSymbol = typeof Symbol === 'function' ? Symbol('secured') : '_'+parseInt((''+Math.random()).substr(2)).toString(16);


/**
 * @namespace AdService
 */

var precalls = window.AdService instanceof Array ? window.AdService.slice() : [];
window.AdService = new function() {
    var self = this,
        win  = window,
        doc  = win.document,
        loc  = win.location,
    _;
    (function() {
        self._global = {};

            self._runOutsourceable = function(method, thisContext, args) {
            var func = self._global[method];
            for (var i=3, l=arguments.length; i<l; i++) {
                if (arguments[i]._global && arguments[i]._global[method]) {
                    func = arguments[i]._global[method];
                    break;
                }
            }
            if (typeof func !== 'function') {
                self.log.error('Outsourceable function', method, 'is not defined.');
            }
            return func ? func.apply(func.thisContext || thisContext, args) : undefined;
        };
    }).apply(this);
        var Const = {
            REQUEST_METHOD: {
                SCRIPT_SRC: 'SCRIPT_SRC',
                AJAX: 'AJAX',
                NONFRIENDLY_IFRAME: 'NONFRIENDLY_IFRAME',
                FRIENDLY_IFRAME: 'FRIENDLY_IFRAME',
            _:0},
            REQUEST_TYPE: {
                SYNC: 'SYNC',
                ASYNC: 'ASYNC',
            _:0},
            AJAX_DATA_TYPE: {
                JSON: 'JSON',
                XML: 'MARKUP',
                HTML: 'STRING',
                TEXT: 'STRING',
            _:0},
            OVERRIDE_PARAM_PREFIX: '_ad.',
            LOGLEVEL_PARAM_PREFIX: '_ad_loglevel.',
            MESSAGE_TYPE: {
                CALL: 'CALL',
                ANSWER: 'ANSWER',
                DEMAND_REDO: 'DEMAND_REDO',
            _:0},
        _:0};
        self.Const = Const;

    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(elt ) {
            var len = this.length >>> 0,
                from = Number(arguments[1]) || 0;
            from = (from < 0)
                 ? Math.ceil(from)
                 : Math.floor(from);
            if (from < 0) {
                from += len;
            }
            for (; from < len; from++) {
                if (from in this && this[from] === elt) {
                    return from;
                }
            }
            return -1;
        };
    }
    Function.prototype.bind = (function() {}).bind || function(b) {
        if (typeof this !== 'function') {
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
        }
        function c() {}
        var a = [].slice,
            f = a.call(arguments, 1),
            e = this,
            d = function() {
                return e.apply(this instanceof c ? this : b || win, f.concat(a.call(arguments)));
            };
        c.prototype = this.prototype;
        d.prototype = new c();
        return d;
    };
    if (typeof Object.create !== 'function') {
        Object.create = function(o, props) {
            function F() {}
            F.prototype = o;
            if (typeof(props) === 'object') {
                for (prop in props) {
                    if (props.hasOwnProperty((prop))) {
                        F[prop] = props[prop];
                    }
                }
            }
            return new F();
        };
    }
    (function(root) {
        if (!root.CSS) { root.CSS = {}; }
        var CSS = root.CSS;
        if (CSS.escape) { return; }

            var InvalidCharacterError = function(message) {
            this.message = message;
        };
        InvalidCharacterError.prototype = new Error;
        InvalidCharacterError.prototype.name = 'InvalidCharacterError';

        CSS.escape = function(value) {
            var string = String(value);
            var length = string.length;
            var index = -1;
            var codeUnit;
            var result = '';
            var firstCodeUnit = string.charCodeAt(0);
            while (++index < length) {
                codeUnit = string.charCodeAt(index);

                if (codeUnit == 0x0000) {
                    throw new InvalidCharacterError(
                        'Invalid character: the input contains U+0000.'
                    );
                }

                    if (
                    (codeUnit >= 0x0001 && codeUnit <= 0x001F) || codeUnit == 0x007F ||
                    (index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) ||
                    (
                        index == 1 &&
                        codeUnit >= 0x0030 && codeUnit <= 0x0039 &&
                        firstCodeUnit == 0x002D
                    )
                ) {
                    result += '\\' + codeUnit.toString(16) + ' ';
                    continue;
                }

                    if (
                    index == 0 &&
                    length == 1 &&
                    codeUnit == 0x002D
                ) {
                    result += '\\' + string.charAt(index);
                    continue;
                }

                if (
                    codeUnit >= 0x0080 ||
                    codeUnit == 0x002D ||
                    codeUnit == 0x005F ||
                    codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
                    codeUnit >= 0x0041 && codeUnit <= 0x005A ||
                    codeUnit >= 0x0061 && codeUnit <= 0x007A
                ) {
                    result += string.charAt(index);
                    continue;
                }

                result += '\\' + string.charAt(index);

                }
            return result;
        };
    }).apply(self, [win]);
    (function(root) {
        if (!root.Promise) {
            var setTimeoutFunc = root.setTimeout;
            function noop() {}

            var asap = (typeof setImmediate === 'function' && setImmediate) || function(fn) { setTimeoutFunc(fn, 1); };

            function bind(fn, thisArg) {
                return function() {
                    fn.apply(thisArg, arguments);
                }
            }

                var isArray = Array.isArray || function(value) { return Object.prototype.toString.call(value) === "[object Array]" };

                function Promise(fn) {
                if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
                if (typeof fn !== 'function') throw new TypeError('not a function');
                this._state = 0;
                this._value = undefined;
                this._deferreds = [];
                doResolve(fn, this);
            }

                function handle(self, deferred) {
                while (self._state === 3) {
                    self = self._value;
                }
                if (self._state === 0) {
                    self._deferreds.push(deferred);
                    return;
                }
                asap(function() {
                    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected
                    if (cb === null) {
                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
                        return;
                    }
                    var ret;
                    try {
                        ret = cb(self._value);
                    } catch (e) {
                        reject(deferred.promise, e);
                        return;
                    }
                    resolve(deferred.promise, ret);
                });
            }

                function resolve(self, newValue) {
                try {
                    if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
                    if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
                        var then = newValue.then;
                        if (newValue instanceof Promise) {
                            self._state = 3;
                            self._value = newValue;
                            finale(self);
                            return;
                        } else if (typeof then === 'function') {
                            doResolve(bind(then, newValue), self);
                            return;
                        }
                    }
                    self._state = 1;
                    self._value = newValue;
                    finale(self);
                } catch (e) {
                    reject(self, e);
                }
            }

                function reject(self, newValue) {
                self._state = 2;
                self._value = newValue;
                finale(self);
            }

                function finale(self) {
                for (var i=0, len=self._deferreds.length; i<len; i++) {
                    handle(self, self._deferreds[i]);
                }
                self._deferreds = null;
            }

                function Handler(onFulfilled, onRejected, promise){
                this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
                this.onRejected = typeof onRejected === 'function' ? onRejected : null;
                this.promise = promise;
            }


            function doResolve(fn, self) {
                var done = false;
                try {
                    fn(function(value) {
                        if (done) { return; }
                        done = true;
                        resolve(self, value);
                    }, function(reason) {
                        if (done) { return; }
                        done = true;
                        reject(self, reason);
                    })
                } catch (ex) {
                    if (done) { return; }
                    done = true;
                    reject(self, ex);
                }
            }

                Promise.prototype['catch'] = function(onRejected) {
                return this.then(null, onRejected);
            };

                Promise.prototype.then = function(onFulfilled, onRejected) {
                var prom = new Promise(noop);
                handle(this, new Handler(onFulfilled, onRejected, prom));
                return prom;
            };

                Promise.all = function() {
                var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
                return new Promise(function(resolve, reject) {
                    if (args.length === 0) return resolve([]);
                    var remaining = args.length;
                    function res(i, val) {
                        try {
                            if (val && (typeof val === 'object' || typeof val === 'function')) {
                                var then = val.then;
                                if (typeof then === 'function') {
                                    then.call(val, function(val) { res(i, val) }, reject);
                                    return;
                                }
                            }
                            args[i] = val;
                            if (--remaining === 0) {
                                resolve(args);
                            }
                        } catch (ex) {
                            reject(ex);
                        }
                    }
                    for (var i=0, len=args.length; i<len; i++) {
                        res(i, args[i]);
                    }
                });
            };

                Promise.resolve = function(value) {
                if (value && typeof value === 'object' && value.constructor === Promise) {
                    return value;
                }
                return new Promise(function(resolve) {
                    resolve(value);
                });
            };

                Promise.reject = function(value) {
                return new Promise(function(resolve, reject) {
                    reject(value);
                });
            };

                Promise.race = function(values) {
                return new Promise(function(resolve, reject) {
                    for (var i=0, len=values.length; i<len; i++) {
                        values[i].then(resolve, reject);
                    }
                });
            };

                /**
             * Set the immediate function to execute callbacks
             * @param fn {function} Function to execute
             * @private
             */
            Promise._setImmediateFn = function _setImmediateFn(fn) {
                asap = fn;
            };
            root.Promise = Promise;
        }
    }).apply(self, [win]);
    (function() {
        if (typeof window.CustomEvent === 'function') { return; }
        function CustomEvent (event, params) {
            params = params || {bubbles: false, cancelable: false, detail: undefined};
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }).apply(self);

        var Version = function(obj) {
            this.parse.apply(this, arguments);
        };
        Version.LEVEL_UNKNOWN = null;
        Version.LEVEL_DEV = 'dev';
        Version.LEVEL_ALPHA = 'alpha';
        Version.LEVEL_BETA = 'beta';
        Version.LEVEL_RC = 'rc';
        Version.LEVEL_FINAL = '';
        Version.levels = [Version.LEVEL_DEV, Version.LEVEL_ALPHA, Version.LEVEL_BETA, Version.LEVEL_RC, Version.LEVEL_FINAL];
        Version.prototype.parse = function(obj) {
            if (typeof obj !== 'object') {
                if (typeof obj === 'string') {
                    var p1 = obj.split('-');
                    var p2 = p1[0].split('.');
                    obj = {
                        major: p2[0],
                        minor: p2[1],
                        revision: p2[2],
                        level: p1[1]
                    };
                } else if (typeof obj === 'number') {
                    obj = {
                        major: parseInt(obj, 10),
                        minor: parseInt((''+obj+'.0').substr((''+obj+'.').indexOf('.')+1), 10)
                    };
                } else {
                    obj = {
                        major: arguments[0],
                        minor: arguments[1],
                        revision: arguments[2],
                        level: arguments[3]
                    };
                }
            }
            this._data = obj;
            this.major = parseInt(obj.major, 10) || 0;
            this.minor = parseInt(obj.minor, 10) || 0;
            this.revision = parseInt(obj.revision, 10) || 0;
            this.level = (''+(obj.level || '')).toLowerCase();
            if (obj.hasOwnProperty('build')) { this.build = obj.build; }
            this.majorminor = parseFloat(this.major + '.' + this.minor, 10);
            if (Version.levels.indexOf(this.level) < 0) {
                this.level = Version.LEVEL_UNKNOWN;
            }
        };
        Version._compareOrder = ['major', 'minor', 'revision', 'level'];
        Version.prototype._compare = function(that, lt, gt, eq) {
            that = new Version(that);
            for (var i=0, l=Version._compareOrder.length; i<l; i++) {
                if (Version._compareOrder[i] === 'level') {
                    var ixThis = Version.levels.indexOf(this.level) + 1;
                    var ixThat = Version.levels.indexOf(that.level) + 1;
                    if (!(ixThis*ixThat)) { return eq; }
                    if (ixThis > ixThat)  { return gt; }
                    if (ixThis < ixThat)  { return lt; }
                    return eq;
                }
                if (this[Version._compareOrder[i]] > that[Version._compareOrder[i]]) return gt;
                if (this[Version._compareOrder[i]] < that[Version._compareOrder[i]]) return lt;
            }
            return eq;
        };
        Version.prototype.eq = function(that) {
            return this._compare(that, false, false, true);
        };
        Version.prototype.ne = function(that) {
            return this._compare(that, true, true, false);
        };
        Version.prototype.gt = function(that) {
            return this._compare(that, false, true, false);
        };
        Version.prototype.gte = function(that) {
            return this._compare(that, false, true, true);
        };
        Version.prototype.lt = function(that) {
            return this._compare(that, true, false, false);
        };
        Version.prototype.lte = function(that) {
            return this._compare(that, true, false, true);
        };
        Version.prototype.toString = function() {
            var version = [this.major, this.minor, this.revision].join('.');
            if (this.level) {
                version += '-' + this.level;
            }
            return version;
        };
    (function() {
        var version = '2.7.4'.split('.');
        self.version = new Version({major: version[0], minor: version[1], revision: version[2], level: Version.LEVEL_FINAL});
    }).apply(self);

    (function() {
    }).apply(self);
    (function() {
        var _console,
            _coreLevels = {'false':true},
            _levels = {
                raw: false,
                debug: true,
                info: true,
                warn: true,
                error: true,
            _:0};
        for (var i in _levels) {
            if (!_levels.hasOwnProperty(i) || i==='_') { continue; }
            _coreLevels[i] = true;
        }
        function prependToArguments(args) {
            var result = Array.prototype.slice.call(args);
            result.unshift.apply(result, Array.prototype.slice.call(arguments, 1));
            return result;
        }
        function appendToArguments(args) {
            var result = Array.prototype.slice.call(args);
            result.push.apply(result, Array.prototype.slice.call(arguments, 1));
            return result;
        }
        function pad(value, len) {
            value = ''+value;
            len = len || 2;
            while (value.length < len) {
                value = '0' + value;
            }
            return value;
        }
        function now() {
            var now = new Date();
            return      pad(now.getHours())
                + ':' + pad(now.getMinutes())
                + ':' + pad(now.getSeconds())
                + '.' + pad(now.getMilliseconds(), 3);
        }

                self.log = function() {
            self.log.debug.apply(self, arguments);
        };
        self.log._output = function() {
            if (!arguments[0].doit) { return; }
            var log = prependToArguments(Array.prototype.slice.call(arguments, 1), '['+(arguments[0].force?'!':'')+'AdService:'+arguments[0].title+']' + (arguments[0].omitTime ? '' : ' '+now())),
                method = _console[arguments[0].method || arguments[0].title] || _console.log;
            if ('apply' in method) {
                method.apply(_console, log);
            } else {
                method(log.join(' '));
            }
        };
        self.log.consoleDebug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.debug && self._debugMode, title:'raw', method:'debug'}));
        };
        self.log.debug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.debug && self._debugMode, title:'debug', method:'log'}));
        };
        self.log.info = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.info && self._debugMode, title:'info'}));
        };
        self.log.warn = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.warn && self._debugMode, title:'warn'}));
        };
        self.log.error = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.error && self._debugMode, title:'error'}));
        };
        self.log.level = function(level) {
            self.log._output.apply(self, prependToArguments(Array.prototype.slice.call(arguments, 1), {doit:_levels[level] && self._debugMode, title:level}));
        };
        self.log.force = function() {
            self.log.forceDebug.apply(self, arguments);
        };
        self.log.remind = function() {
            self.log._output.apply(self, appendToArguments(prependToArguments(arguments, {doit:true, title:'TODO', method:'warn'}, '[REMINDER]'), '\n'+(''+(new Error()).stack).split('\n').slice(2).join('\n')));
        };
        self.log.deprecated = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'deprecated', method:'warn', omitTime:true}));
        };
        self.log.nyi = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'interface', method:'error'}, 'NOT YET IMPLEMENTED:'));
        };
        self.log.forceConsoleDebug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true,title: 'raw', force:true}));
        };
        self.log.forceDebug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'debug', force:true}));
        };
        self.log.forceInfo = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'info', force:true}));
        };
        self.log.forceWarn = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'warn', force:true}));
        };
        self.log.forceError = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'error', force:true}));
        };
        self.log.forceLevel = function(level) {
            self.log._output.apply(self, prependToArguments(Array.prototype.slice.call(arguments, 1), {doit:true, title:level, force:true}));
        };
        self.log.setLevel = function(level, isSet) {
            if (typeof level === 'object') {
                for (var i in level) {
                    if (!level.hasOwnProperty(i)) { continue; }
                    if (i === '_') { continue; }
                    _levels[i] = level[i];
                }
            } else {
                if (_coreLevels[level]) {
                    var value = false;
                    for (var i in _levels) {
                        if (!_levels.hasOwnProperty(i)) { continue; }
                        if (i === level) { value = true; }
                        if (i === '_')   { break; }
                        _levels[i] = value;
                    }
                }
                _levels[level] = isSet !== false;
            }
        };
        self.log.getLevel = function() {
            return _levels;
        };

                self.setDebugMode = function(yesno) {
            var previous = self._debugMode;
            self._debugMode = yesno === undefined ? true: yesno;
            if (self._debugMode) {
                if (previous) {
                    self.log.info('Already in Debug Mode.');
                } else {
                    self.log.info('Entering Debug Mode. Reason(s):', debugOrigin.length ? debugOrigin : prependToArguments((''+(new Error()).stack).split('\n').slice(2), 'manual call'));
                }
            } else if (previous) {
                self.log.forceInfo('Stopping Debug Mode.');
            }
            debugOrigin = [];
        };

                self.log.getConsoleObject = function() {
            return _console;
        };
        self.log.setConsoleObject = function(obj) {
            _console = obj;
        };
        self.log._consoleCompensation = [];
        self.log.setConsoleObject(console || {
            debug: function() { self.log._consoleCompensation.push({type:'debug', args:arguments}); },
            log: function() { self.log._consoleCompensation.push({type:'log', args:arguments}); },
            info: function() { self.log._consoleCompensation.push({type:'info', args:arguments}); },
            warn: function() { self.log._consoleCompensation.push({type:'warn', args:arguments}); },
            error: function() { self.log._consoleCompensation.push({type:'error', args:arguments}); }
        });

        var urlParams = location.search.substr(1).split('&');
        for (var i=0, l=urlParams.length; i<l; i++) {
            var param = urlParams[i],
                name = param.substr(0, param.indexOf('=')),
                value = param.substr(param.indexOf('=')+1),
            _;
            if (name.indexOf(Const.LOGLEVEL_PARAM_PREFIX) !== 0) { continue; }
            self.log.setLevel(name.substr(Const.LOGLEVEL_PARAM_PREFIX.length), value !== 'false');
        }

        var debugMode = false,
            debugOrigin = [];
        if (doc.documentElement.getAttribute('data-adservice-debug') !== null) {
            debugMode = (''+doc.documentElement.getAttribute('data-adservice-debug')).toLowerCase() === 'true';
            if (debugMode) { debugOrigin.push('html attribute'); }
        }
        if (window.adserviceDebug) {
            debugMode = !!window.adserviceDebug;
            if (debugMode) { debugOrigin.push('global variable'); }
        }
        if (/[?&]adservice-debug=(true|false)(&|$)/.test(loc.search)) {
            debugMode = RegExp.$1 === 'true';
            if (debugMode) { debugOrigin.push('url parameter'); }
        }
        self.setDebugMode(debugMode);
    }).apply(self);
    (function() {
        var exports = {};

                self._registerExport = function(name, obj) {
            exports[name] = obj;
        };
        self.gimme = function(name) {
            if (name) {
                return exports[name];
            }
            return keys(exports);
        };
        self.gimmeAll = function(nameMap) {
            nameMap = nameMap || {};
            var items = self.gimme();
            each(items, function(i, item) {
                win[nameMap[item] || item] = self.gimme(item);
            });
        };
    }).apply(self);
    (function() {
        self.Helper = new function() {
            this.register = function(name, ref) {
                self._registerExport(name, ref);
                this[name] = ref;
            };
        };
    }).apply(self);

            function each(obj, func, completeWalkthrough) {
            if (obj instanceof Array || isArguments(obj) || isDomList(obj)) {
                for (var i=0, l=obj.length; i<l; i++) {
                    try { func(i, obj[i]); }
                    catch (e) { self.log.error('Error in function supplied for each(Array)', e, i, obj[i], arguments, this); }
                }
            } else {
                for (var i in obj) {
                    if (completeWalkthrough !== true && !obj.hasOwnProperty(i)) { continue; }
                    try { func(i, obj[i]); }
                    catch (e) { self.log.error('Error in function supplied for each(Object)', e, i, obj[i], arguments, this); }
                }
            }
        }

            function keys(obj) {
            var keys = [];
            each(obj, function(key, value) { keys.push(key); });
            return keys;
        }

            function filter(obj, func) {
            var result = obj instanceof Array ? [] : {};
            each(obj, function(name, value) {
                if (func(name, value)) {
                    obj instanceof Array ? result.push(value) : (result[name] = value);
                }
            });
            return result;
        }

            function objCompare(obj1, obj2) {
            self.log.remind('objCompare', arguments);
        }

            function deepCopy(obj) {
            switch (true) {
                case obj === undefined:
                case obj === null:
                case !(obj instanceof Object):
                    return obj;
                case obj.constructor === Number:
                case obj.constructor === String:
                case obj.constructor === Boolean:
                case obj.constructor === Date:
                case obj.constructor === RegExp:
                case obj.constructor === Function:
                    return new obj.constructor(obj);
                case obj instanceof Array:
                    var temp = [];
                    for (var i=0, l=obj.length; i<l; i++) {
                        temp[i] = deepCopy(obj[i]);
                    }
                    return temp;
                default:
                    return extend({}, obj);
            }
        }

            function makeArray(obj, forcePlainObjectToArray) {
            switch (true) {
                case (obj === undefined):
                    return [];
                case (obj instanceof Array):
                    return obj;
                case (isArguments(obj)):
                case (obj instanceof win.NodeList):
                    var temp = [];
                    each(obj, function(i, item) { temp[i] = item; });
                    return temp;
                case (obj instanceof Object && forcePlainObjectToArray):
                    var temp = [];
                    each(obj, function(i, item) { temp[i] = item; });
                    return temp.length ? temp : [obj];
                default:
                    return [obj];
            }
            return obj;
        }

            function arrayMerge() {
            var result = [];
            each(arguments, function(index, array) {
                if (!(array instanceof Array) && !isArguments(array)) {
                    return result.push(array);
                }
                each(array, function(index, item) {
                    result.push(item);
                });
            });
            return result;
        }

            function isArguments(obj) {
            return obj && obj.callee && obj.callee.arguments === obj;
        }

            function isDomElement(obj) {
            return obj instanceof win.HTMLElement;
        }

            function isDomList(obj) {
            return obj instanceof win.HTMLCollection;
        }

            function extend() {
            function _extend(object1, object2) {
                each(object2, function(key, value) {
                    if (typeof value === 'object' && !(value instanceof Array)) {
                        if (typeof object1[key]  === 'undefined') {
                            object1[key] = value;
                        } else {
                            _extend(object1[key], value);
                        }
                    } else {
                        object1[key] = value;
                    }
                }, (object2 instanceof (win.DOMRect || win.ClientRect)));
                return object1;
            }

                var result = arguments[0];
            for (var i=1, l=arguments.length; i<l; i++) {
                result = _extend(result, arguments[i] || {});
            }
            return result;
        }

            function defaults(obj, defaults) {
            return extend(defaults, obj);
        }

            function fillIn(text, placeholder, regexp) {
            return text.replace(regexp || /\{([^}]+)\}/g, function(match, key) {
                return placeholder.hasOwnProperty(key) ? placeholder[key] : match;
            });
        }

            function getLengthValue(value) {
            if (typeof value === 'number') { return value + 'px'; }
            if ((''+value).indexOf('%') > 0) { return parseInt(value) + '%'; }
            return parseInt(value) + 'px';
        }


        function parseUrl(url) {
            var result = {};
            result.originalUrl = url;
            var parts = url.match(/^(https?:)?(?:\/\/([^:/]+?)(?::(\d+))?)?(\/[^?#]*)?(\?[^#]*)?(#.*)?$/);
            result.protocol = parts[1];
            result.hostname = parts[2];
            result.port = parts[3];
            result.pathname = parts[4];
            result.search = parts[5];
            result.hash = parts[6];
            result.host = result.hostname + (result.port ? ':'+result.port : '');
            result.origin = result.protocol + '//' + result.host;

                return result;
        }

            self.Helper.register('each', each);
        self.Helper.register('keys', keys);
        self.Helper.register('filter', filter);
        self.Helper.register('deepCopy', deepCopy);
        self.Helper.register('makeArray', makeArray);
        self.Helper.register('arrayMerge', arrayMerge);
        self.Helper.register('isArguments', isArguments);
        self.Helper.register('isDomElement', isDomElement);
        self.Helper.register('isDomList', isDomList);
        self.Helper.register('defaults', defaults);
        self.Helper.register('extend', extend);
        self.Helper.register('fillIn', fillIn);
        self.Helper.register('getLengthValue', getLengthValue);
        self.Helper.register('parseUrl', parseUrl);
        var Code = new function() {
            var Template = function(to, from) {
                var code = this,
                    choice = function(text, toOrFrom) {
                        if (toOrFrom === false) { return code.from(text); }
                        else                    { return code.to(text); }
                    };
                this.to   = choice.to   = to;
                this.from = choice.from = from;
                return choice;
            };

            this.html = new Template(
                function(text) {
                    return text.toString()
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/\"/g, '&quot;');
                },
                function(text) {
                    return text.toString()
                        .replace(/&quot;/g, '"')
                        .replace(/&gt;/g, '>')
                        .replace(/&lt;/g, '<')
                        .replace(/&amp;/g, '&');
                }
            );

            this.css = new Template(
                function(text) {
                    return CSS.escape(text);
                },
                function(text) {
                    return text;
                }
            );

            this.url = new Template(
                function(text) {
                    return encodeURIComponent(text).replace(/%2F/gi, '/');
                },
                function(text) {
                    try {
                        return decodeURIComponent(text);
                    } catch (e) {
                        if (e instanceof URIError) {
                            return unescape(text);
                        }
                        throw e;
                    }
                }
            );
        };

                self._registerExport('Code', Code);
    (function() {
        self.Error = function(name, category, fileName, properties) {
            var error = function(message, data, positionHint, lineNumber, columnNumber) {
                this._project = 'AdService'; 
                this.message = message || self.Error.NO_MESSAGE;
                this.data = data || {};
                this.positionHint = positionHint;
                this.lineNumber = lineNumber;
                this.columnNumber = columnNumber;
                this.stack = 'Error\n' + ((''+(new Error()).stack).split('\n').splice(2).join('\n') || ''); 
                if (!this.data.scope) { this.data.scope = {}; }
                if (!this.data.vars) { this.data.vars = {}; }
                this.name = this.name;
                this.category = this.category;
                this.fileName = this.fileName;
                this.properties = this.properties;
            };
            error.prototype = Object.create(Error.prototype);
            error.prototype.constructor = error;
            error.prototype.name = name;
            error.prototype.category = category;
            error.prototype.fileName = fileName;
            error.prototype.properties = properties || {};
            return error;
        };
        self.Error.NO_MESSAGE = 'no error message given';

        var clientType = navigator.userAgent.toLowerCase().indexOf('chrome')+1 ? 'chrome' : 'firefox';
        self.Error.getStackTrace = function(omitLines) {
            var error = new Error(),
                stack = [];
            if (typeof error.stack === 'string') {
                stack = error.stack.split('\n').splice((clientType==='chrome' ? 2 : 1) + (omitLines || 0));
            } else {
                var current = arguments.callee,
                    max = 12;
                while (current && stack.length < max) {
                    if (/function\s+([\w$]+)\s*\(/.test(current.toString())) {
                        stack.push(RegExp.$1);
                    } else {
                        stack.push('anonymous');
                    }
                    try {
                        current = current.caller;
                    } catch (e) {
                        break;
                    }
                }
                stack = stack.splice((omitLines || 0) + 1);
            }
            stack.toString = function(addNewLine) {
                return (addNewLine?'\r\n':'') + this.join('\r\n');
            };
            return stack;
        };
    }).apply(this);

    var AdServiceError = function(name, fileName, properties) {
        return new self.Error(name, 'core', fileName, properties);
    };





    (function() {
        self.FunctionHook = function() {
            this._functionList = [];
        }
        self.FunctionHook.prototype.check = function(func) {
            return false;
        };
        self.FunctionHook.prototype.add = function(func) {
            this._functionList.push(func);
            if (this.check()) {
                func.apply(this, Array.prototype.slice.call(arguments, 1));
            }
        };
        self.FunctionHook.prototype.run = function() {
            var args = arguments;
            each(this._functionList, function(i, item) {
                item.apply(this, args);
            });
        };
        self.FunctionHook.prototype.clear = function() {
            this.onclear();
            this._functionList = [];
        };
        self.FunctionHook.prototype.onclear = function() {
        };
    }).apply(self);
    (function() {
        var storage = {};
        self.Metronome = new function() {
            this.add = function(func, ms) {
                if (!storage[ms]) {
                    storage[ms] = new FunctionHook();
                    storage[ms].onclear = this.onclear(ms);
                    storage[ms].interval = window.setInterval(function() { storage[ms].run(); }, ms);
                }
                storage[ms].add(func);
            };
            this.onclear = function(ms) {
                return function() {
                    win.clearInterval(storage[ms].interval);
                }
            };
            this.clear = function() {
                each(storage, function(ms, item) {
                    storage[ms].clear();
                });
            };
            this.stop = function() {
                each(storage, function(ms, item) {
                    win.clearInterval(item.interval);
                });
            };
            this.go = function() {
                each(storage, function(ms, item) {
                    item.interval = win.setInterval(function() { item.run(); }, ms);
                });
            };
        };
    }).apply(self);
    (function() {
        var config = {
                'data-attribute-namespace': 'adservice',
                'friendlyiframe-adscript-id': 'external-script',
                'friendlyiframe-checkscript-id': 'internal-script',
                'friendlyiframe-readycheck-timeout': 50,
                'nonfriendlyiframe-document': 'https://dl.web.de/uim/nonfriendlyiframe.html',
                'visibility-minimum-fraction': 0.5,
                'request-ad-only-if-visible': true,
                'request-async': false,
                'adservice-iframe-script-url': 'connector.js',
                'auto-exchange-uim-cookie': false,
                'auto-set-iframe-size': true,
                'slot-enabled-default': true,
            _:0};
        delete config._;
        /**
         * retrieves the AdService configuration.
         * @function getConfig
         * @param {string} [name] - configuration key name
         * @example AdService.getConfig('adservice-iframe-script-url');
         * @example AdService.getConfig();
         */
        self.getConfig = function(name, defaultValue) {
            if (!name) { return config; }
            if (config.hasOwnProperty(name)) { return config[name]; }
            return defaultValue;
        };

                /**
         * sets the AdService configuration.
         * @function setConfig
         * @param {string} name - configuration key name
         * @param {*} value - value of the configuration key
         * @example AdService.setConfig('visibility-minimum-fraction',0.6);
         */
        self.setConfig = function(name, value) {
            var obj = arguments.length>1 ? {} : name;
            if (arguments.length>1) {
                obj[name] = value;
            }
            each(obj, function(name, value) { config[name] = value; });
            return self;
        };
    }).apply(self);
        var dom;
        if (doc.querySelectorAll) {
            dom = function(selector, context) {
                if (!context) { context = doc; }
                return context.querySelectorAll(selector);
            };
        } else {
            dom = function(selector, context) {
                var id = null,
                    tempId = false;
                AdService.__domList = new Array();
                if (context) {
                    if (context.id) {
                        id = context.id;
                    } else {
                        tempId = true;
                        id = context.id = 'temp-dom-id-'+(''+new Date().getTime()).substr(2);
                    }
                }
                var style = doc.createElement('style');
                doc.getElementsByTagName('head')[0].appendChild(style);
                style.styleSheet.cssText = (id ? '#'+id+' ' : '') + selector + '{x-dom: expression(AdService.__domList.push(this));}';
                win.scrollBy(0, 0);
                style.parentNode.removeChild(style);
                if (tempId) { context.removeAttribute('id'); }
                return [].concat(AdService.__domList);
            }
        }
        self.getDataAttrName = function(suffix) {
            return 'data-' + CSS.escape(self.getConfig('data-attribute-namespace')) + '-' + suffix;
        };
        /**
         * creates a DOM-element
         * @function createElement
         * @param {string} name - dom element name
         * @param {object} attrs - attributes of the dom element {key1: value1, key2:value2, key3:value3...}
         * @param {object} props - properties of the dom element {key1: value1, key2:value2, key3:value3...}
         * @example AdService.createElement('div',
            {
                id:'foo',
                class:'hidden',
                style:'width:100%;height:120px;background-color:yellow;'
            },
            {
                foo: function(){ alert("bar"); }
            }
        );
         */
        self.createElement = function(name, attrs, props) {
            var el = document.createElement(name);
            each(attrs, function(n, v) { el.setAttribute(n, v); });
            each(props, function(n, v) { el[n] = v; });
            return el;
        };
        /**
         * creates an IFrame within a DOM-element
         * @function buildFriendlyIframe
         * @param {domNode} domNode - dom node where to create the iframe
         * @param {object} data - data containing information about the content of the iframe - slot, markup...
         */
        self.buildFriendlyIframe = function(domNode, data, type) {
            var slot = data.slot,
                width = slot.fixedSize.type === 'fixed' ? slot.fixedSize.width : '100%',
                height = slot.fixedSize.type === 'fixed' ? slot.fixedSize.height : domNode.offsetHeight||'100%',
                iframeSrc = document.all ? "javascript:(function(){document.open('text/html', 'replace');document.domain='" + document.domain + "';})();" : 'about:blank',
                iframeAttrs = {frameborder: 0, border: 0, scrolling: 'no', marginwidth: 0, marginheight: 0, width: width, height: height},
                sandboxAttrs = slot.getSandboxAttributes(),
            _;
            if (Object.keys(sandboxAttrs).length) { iframeAttrs.sandbox = slot.getSandboxAttributeValue(sandboxAttrs); }
            if (slot.fixedSize.type === 'pagecontrol') {
                delete iframeAttrs.width;
                delete iframeAttrs.height;
            }
            var iframe = self.createElement('iframe', iframeAttrs, {src: iframeSrc});
            domNode.appendChild(iframe);
            var iframeWindow = iframe.contentWindow,
                iframeDocument = iframeWindow.document;
            iframeDocument.open();


            self.trigger('ad.request', slot, data);
            iframeDocument.write(''
                + '<!DOCTYPE html>\n'
                + '<html>\n'
                + '<head>\n'
                + '<meta charset="UTF-8"/>\n'
                + '<script>\n'
                + '    var _adServer = "' + data.slot.getAdServer().id + '";\n'
                + '    var _adSlot = "' + data.slot.id + '";\n'
                + '    window.AdService = [];\n'
                + '    function checkAdReady() { document.close(); }\n'
                + '    function checkRunner() {\n'
                + '        if (checkRunner.finished) { return; }\n'
                + '        if (window.AdService instanceof Array && --checkRunner.triesLeft) {\n'
                + '            checkRunner.timeout += 5;\n'
                + '            return window.setTimeout(checkRunner, checkRunner.timeout);\n'
                + '        }\n'
                + '        checkRunner.finished = true;\n'
                + '        checkAdReady();\n'
                + '    }\n'
                + '    checkRunner.timeout = 20;\n'
                + '    checkRunner.triesLeft = 25;\n'
                + '</script>\n'
                + '<script src="' + Code.html(self.getConfig('adservice-iframe-script-url')) + '"><\/script>\n'
                + '<style>\n'
                + 'html { overflow: hidden; }\n'
                + 'html, body { min-width: 100%; min-height: 100%; }\n'
                + 'img, iframe { display: block; }\n'
                + 'a img { border: none; }\n'
                + 'html.testsize { display: table !important; }\n'
                + 'html.testsize * { float: left !important; }\n'
                + 'html.testsize .adp-admarker-icon + .adp-admarker-text { display: none; }\n'
                + '<\/style>\n'
                + '<style id="pageStyles">' + (type ? self.useIframeCss(type) : '') + '</style>\n'
                + '<\/head>\n'
                + '<body><div>\n'
                + data.html
                + '<script id="internal-script">checkRunner();<\/script>\n'
                + '<\/body>\n'
                + '<\/html>'
            );
            self.trigger('ad.requested', slot, data);
            self.log.level('friendlyiframe', 'iframe.document.created', iframeWindow.frameElement.parentNode.getAttribute(self.getDataAttrName('slot')));

                return true;

            };

            self._registerExport('dom', dom);
    (function() {
        var eventListener = {};

                var AdServiceEvent = function(evn, slot, data) {
            this.type = evn;
            this.data = data || {};
            this.slot = slot || null;
            this.target = this.data.target || (this.slot && this.slot.getTarget && this.slot.getTarget()) || null;
            this.request = this.data.request || (this.slot && this.slot.getRequest && this.slot.getRequest()) || null;
        };
        AdServiceEvent.prototype.get = function(name, defaultValue) {
            return this.data.hasOwnProperty(name) ? this.data[name] : (defaultValue || undefined);
        };
        AdServiceEvent.prototype.set = function(name, value) {
            this.data[name] = value;
        };

                self.on = function(evn, condition, func) {
            if (!func) {
                func = condition;
                condition = undefined;
            }
            if (evn === 'now') {
                return func.apply(self);
            }
            self._initEventName(evn);
            if (eventListener[evn].isUnique && eventListener[evn].triggered && self._eventConditionFulfilled(condition)) {
                return self._runEventListener(func);
            }
            var eventFunc = function() {
                var event = arguments[0] instanceof AdServiceEvent ? arguments[0] : null;
                if (!this.condition || self._eventConditionFulfilled(this.condition, event)) {
                    this.func.apply(this, arguments);
                }
            };
            eventFunc.condition = condition;
            eventFunc.func = func;
            eventFunc = eventFunc.bind(eventFunc);
            eventListener[evn].add(eventFunc);
            self.trigger('eventhandler.added', {on: evn, condition: condition, func: func, eventFunc: eventFunc});
            return self;
        };
        self.trigger = function(evn, slot, data) {
            self.log.level('event.trigger', evn, slot, data && extend({}, data), arguments);
            if (!eventListener[evn]) { return; }
            if (eventListener[evn].isUnique && eventListener[evn].triggered) { return; }
            if (slot && !(slot instanceof self.AdSlot)) {
                data = slot;
                slot = null;
            }
            eventListener[evn].triggered = true;
            eventListener[evn].run(new AdServiceEvent(evn, slot, data));
            return self;
        };
        self._from_iframe_triggerUp = function(evn, slot, data) {
            self.trigger(evn, self.AdSlot(slot), data);
        };
        self._triggerFlat = function(evn) {
            self.log.level('event._triggerFlat', evn, arguments);
            if (!eventListener[evn]) { return; }
            if (eventListener[evn].isUnique && eventListener[evn].triggered) { return; }
            eventListener[evn].triggered = true;
            eventListener[evn].run.apply(eventListener[evn], [].splice.call(arguments, 1));
            return self;
        };
        self.triggerOnce = function(evn, slot, data) {
            self.setUniqueEvent(evn, true);
            return self.trigger(evn, slot, data);
        };
        self.setUniqueEvent = function(evn, isUnique) {
            self._initEventName(evn);
            eventListener[evn].isUnique = isUnique===false ? false : true;
            return self;
        };
        self.eventHandlerCount = function(evn) {
            return (eventListener[evn] || {_functionList:[]})._functionList.length;
        };
        self.hasEventHandler = function(evn) {
            return self.eventHandlerCount(evn) > 0;
        };

                self._initEventName = function(evn) {
            if (!eventListener[evn]) {
                eventListener[evn] = new self.FunctionHook();
            }
            return eventListener[evn];
        };
        self._eventConditionFulfilled = function(condition, event) {
            if (condition === undefined) {
                return true;
            }
            if (typeof condition === 'string') {
                return event && event.slot && event.slot.id === condition;
            }
            try {
                return condition(event);
            } catch (e) {
                return condition;
            }
            return true;
        };
        self._runEventListener = function(func) {
            try {
                return func.apply(self);
            } catch (e) {
                return undefined;
            }
        };
    }).apply(self);
    (function() {
        function bodyBegin() {
            self.setUniqueEvent('body.begin', true);
            var done = false,
                animationFrame;
            if (doc.getElementsByTagName('body').length) {
                return self.trigger('body.begin');
            }
            if (win.requestAnimationFrame) {
                animationFrame = win.requestAnimationFrame(function() {
                    if (done || doc.getElementsByTagName('body').length === 0) { return; }
                    done = true;
                    win.cancelAnimationFrame(animationFrame);
                    self.trigger('body.begin');
                });
            }
            var interval = win.setInterval(function() {
                if (doc.getElementsByTagName('body').length === 0) { return; }
                if (done) { return win.clearInterval(interval); }
                done = true; 
                win.clearInterval(interval);
                self.trigger('body.begin');
            }, 20);
        }
        function bodyEnd() {
            self.on('body.end', function() { self.trigger('body.begin'); });
            self.setUniqueEvent('body.end', true);
            if (doc.readyState === 'complete') {
                return self.trigger('body.end');
            }
            if (doc.addEventListener) {
                doc.addEventListener('DOMContentLoaded', function() {
                    self.trigger('body.end');
                }, false);
            } else if (doc.attachEvent) {
                doc.attachEvent('onreadystatechange', function() {
                    if (doc.readyState !== 'complete') { return; }
                    self.trigger('body.end');
                });
            }
        }
        function pagePositionChange() {
            var minWait = 100,
                timeoutHandler = null,
            _;
            function positionChangeHandler() {
                timeoutHandler = null;
                self.trigger('page.positionchange');
            }
            function positionChangeRunner() {
                if (timeoutHandler) { return; }
                timeoutHandler = win.setTimeout(positionChangeHandler, minWait);
            }
            win.addEventListener('resize', positionChangeRunner, false);
            doc.addEventListener('scroll', positionChangeRunner, true);
        }

                self.on('initialize.begin', function() {
            bodyBegin.apply(self);
            bodyEnd.apply(self);
            pagePositionChange.apply(self);
        });
    }).apply(self);
    (function() {
        self.Module = function(name, func) {
            if (this===self) {
                return self.Module.modules[name];
            }
            if (self.Module.modules[name]) {
                throw new Error('Module "' + name + '" already defined');
            }
            self.Module.modules[name] = this;
            if (typeof func === 'function') {
                this.exec(func);
            }
        };
        self.Module.modules = {};
        self.Module.prototype._locals = {};
        self.Module.prototype._globals = {};
        self.Module.prototype._errors = {};
        self.Module.prototype.exec = function(func) {
            func.apply(this);
            return this;
        };
        self.Module.prototype._registerMember = function(name, member, reference, collection, desc) {
            if (name in reference) {
                throw new Error(desc + ' member "' + name + '" already defined');
            }
            reference[name] = typeof member === 'function' ? member.bind(reference) : member;
            collection[name] = reference[name];
            return this;
        };
        self.Module.prototype.extendBaseObject = function(name, member) {
            return this._registerMember(name, member, self, this._globals, 'Global');
        };
        self.Module.prototype.set = self.Module.prototype.extend = function(name, member) {
            return this._registerMember(name, member, this, this._locals, 'Local');
        };
        self.Module.prototype.createError = function(name, fileName, properties) {
            this._errors[name] = new self.Error(name, 'module/'+this.name, fileName, properties);
            return this;
        };
        self.Module.prototype.getError = function(name, message, data, positionHint, lineNumber, columnNumber) {
            return new (this._errors[name] || new self.Error(name, 'module/'+this.name, '[unknown].js'))(message, data, positionHint, lineNumber, columnNumber);
        };
        self.Module.prototype.throwError = function(name, message, data, positionHint, lineNumber, columnNumber) {
            throw this.getError(name, message, data, positionHint, lineNumber, columnNumber);
        };
        self.Module.logError = function(e) {
            self.log.error('Error in Module:', e);
        };
    }).apply(self);
    (function() {
        self.asyncLimit = function(ms) {
            return new Promise(function(done, reject) {
                win.setTimeout(function() { reject('Limit of '+ms+'ms reached'); }, ms);
            });
        };
    }).apply(self);
    /**
     * saves a function to be called when AdService is available. 
     Very usefull when requesting the AsService asynchronously.
     * @function push
     * @param {function} func - the function to be executed.
     * @example AdService.push(function() {
        AdService.on('contractAd', function(evt){
            evt.data.isContractAllowed = true;
        }); 
    });
     */
    self.push = function(func) {
        precalls.push(func);
    };
    self.on('initialize.begin', function() {
        self.push = function() {
            each(arguments, function(i, func) {
                if (typeof func === 'string') {
                    return func === '#cleanup' ? self.cleanup() : self.ad(func);
                }
                try { func.apply(self); }
                catch (e) { self.log.error('Error calling function via AdService.push():', e, func); }
            });
        };
        self.push.apply(self, precalls);
    });
    (function() {
        var queues = {};

                function execute(func, name, reason) {
            var data = {name: name, reason: reason};
            try {
                func(data);
            } catch (e) {
                self.log.error('Error in waiting queue function', e, arguments, data, this);
            }
        }

                self.registerWaitingQueue = function(name) {
            queues[name] = queues[name] || [];
            return self;
        };
        self.waitFor = function(name, func) {
            if (!queues[name]) {
                execute(func, name, queues.hasOwnProperty(name) ? 'completed' : 'noqueue');
                return self;
            }
            queues[name].push(func);
            return self;
        };
        self.waitingComplete = function(name) {
            var queue = queues[name];
            queues[name] = false;
            each(queue, function(i, func) {
                execute(func, name, 'processing');
            });
            return self;
        };
        self.isQueueCompleted = function(name) {
            return queues[name] === false;
        };

                self.getQueue = function(name) {
            return name ? queues[name] : queues;
        };
    }).apply(self);

    (function() {
        self.info = {};
        var _infoStack = {};

                self._determineInfo = function(name) {
            var data = {
                info: name,
            _:0};
            self.trigger('determineSystem.begin', data);
            try {
                self.info['_'+name] = _infoStack[name]();
            } catch (e) {
                self.info['_'+name] = {};
            }
            self.trigger('determineSystem.end', data);
        };
        self.registerInfo = function(name, func, isPersistent, options) {
            if (typeof name === 'string') {
                return self.registerInfo(extend({name:name, func:func, persistent:isPersistent}, options));
            }
            var data = defaults(name, {
                persistent: false,
                event: 'now',
                initial: {}
            });
            _infoStack[data.name] = data.func;
            self.info[data.name] = data.persistent
                            ? function() {  return self.info['_'+data.name]; }
                            : function() { self._determineInfo(data.name); return self.info['_'+data.name]; }
            ;
            self.info['_'+data.name] = data.initial;
            self.on(data.event, function() {
                self._determineInfo(data.name);
            });
        };
    }).apply(self);
    (function() {
        var ua = navigator.userAgent.toLowerCase();
        function findVersion(name) {
            return new Version((ua.match(new RegExp(name + '[/ ;](\\d+(?:\\.\\d+)?)')) || [])[1]);
        }
        function determine_ua() {
            var browser = (ua.match(['edge', 'msie', 'opr', 'firefox', 'seamonkey', 'aurora', 'iron', 'chrome', 'mobile safari', 'safari', 'opera'].join('|')) || [])[0],
                os      = (ua.match(['windows nt', 'windows phone', 'windows rt', 'windows', 'mac os', 'os x', 'android', 'iphone', 'ipad', 'ipod', 'blackberry', 'rim', 'linux'].join('|')) || [])[0];
            return {
                browser: {name:browser, version:findVersion(browser)},
                os:      {name:os,      version:findVersion(os)}
            };
        };
        self.registerInfo('ua', determine_ua, true);
    }).apply(self);
    (function() {
        function determine_flash() {
            var versiontext;
            try {
                versiontext = win.navigator && win.navigator.plugins && win.navigator.plugins['Shockwave Flash']
                            ? win.navigator.plugins['Shockwave Flash'].description
                            : (win.ActiveXObject ? new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version') : '0.0');
            } catch (e) {
                self.log.error('Error in determine_flash()', e, arguments, this);
            }
            var majorminor = +(((versiontext||'').match(/\d+(?:\.\d+)?/) || [0])[0]);
            var version = new Version(majorminor);
            version.installed = !!parseInt(majorminor, 10);
            return version;
        };
        self.registerInfo('flash', determine_flash, true);
    }).apply(self);
    (function() {
        function determine_view() {
            return {
                screen: {width: screen.width, height: screen.height},
                window: {
                    width: win.outerWidth,
                    height: win.outerHeight,
                    x: ('screenLeft' in win) ? win.screenLeft : win.screenX,
                    y: ('screenTop' in win) ? win.screenTop : win.screenY
                },
                viewport: {width: win.innerWidth, height: win.innerHeight}
            };
        };
        self.registerInfo('view', determine_view, false);
    }).apply(self);
    (function() {
        var ua = navigator.userAgent.toLowerCase();
        function determine_device() {
            return {
                devicetype: /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(ua)
                    ? 'tablet'
                    : /mobi|windows phone|iphone|blackberry/.test(ua)
                        ? 'mobile'
                        : 'desktop',
                retina: 'matchMedia' in win && (win.matchMedia('(-webkit-min-device-pixel-ratio: 2)') || 0).matches,
                touchscreen: 'ontouch' in doc.documentElement  
            };
        }
        self.registerInfo('device', determine_device, true);
    }).apply(self);
    (function() {
        function determine_view() {
            return {
                canvas: 'getContext' in doc.createElement('canvas'),
            _:0};
        };
        self.registerInfo('features', determine_view, true);
    }).apply(self);
    (function() {
        function determine_connection() {
            return {
                type: ['?', 'eth', 'wifi', '2g', '3g', '4g'][(navigator.connection || 0).type || 0] || '?',
                speed: undefined
            };
        }
        self.registerInfo('connection', determine_connection, true);
    }).apply(self);

    (function() {
        self.ObjectList = function() {
            this.list = {};
            this.register = function(obj) {
                this.list[obj.id] = obj;
            };
            this.getList = function() {
                return this.list;
            };
            this.get = function(id) {
                return this.list[id];
            };
        };
    }).apply(self);
    (function() {
        self.log.setLevel('ajax');
        self.Ajax = function(url, config) {
            var emptyFunction = function(response) {
                self.log.level('ajax', this, arguments);
            };
            this.config = extend({
                async: true,
                cors: true,
                method: 'GET',
                timeout: false,
                on: {
                    success: emptyFunction.bind(this, 'success'),
                    error: emptyFunction.bind(this, 'error'),
                    complete: emptyFunction.bind(this, 'complete'),
                    status: {
                        '404': emptyFunction.bind(this, 'status.404'),
                    _:0},
                _:0},
            _:0}, config, {url:url, started:false, aborted:false, finished:false});
            this._ajaxObject = {
                abort: function() { },
            _:0};
        };
        self.Ajax.prototype._createAjaxObject = function() {
            this._ajaxObject = new XMLHttpRequest();
            this._ajaxObject.onreadystatechange = this._readyStateChange.bind(this);
            if (this.config.cors) {
                this._ajaxObject.withCredentials = true;
            }
        };
        self.Ajax.prototype._readyStateChange = function() {
            if (this._ajaxObject.readyState !== 4) { return; }
            self.log.level('ajax', 'readyStateChange', this._ajaxObject.readyState, this._ajaxObject.status, this._ajaxObject);
            var status = this._ajaxObject.status,
                statusType = +(''+status).substr(0, 1);
            if (this.config.on.status[status]) { this._call(this.config.on.status[status]); }
            if (statusType >= 4) {
                this._call(this.config.on.error);
                return this._finish();
            }
            this._call(this.config.on.success);
            this._finish();
        };
        self.Ajax.prototype._finish = function() {
            this._call(this.config.on.complete);
        };
        self.Ajax.prototype._call = function(func) {
            try {
                func.bind(this)(this._ajaxObject.response);
            } catch (e) {
                self.log.error('Error in Ajax event function', e, arguments, this);
            }
        };
        self.Ajax.prototype._requestUrl = function(method, url) {
            this._ajaxObject.open(method, url, this.config.async);
            if (this.config.timeout > 0) {
                this._ajaxObject.timeout = this.config.timeout;
                self.log.level('ajax', 'timeout', this._ajaxObject.timeout, '(', this.config.timeout, ')');
            }
            this._ajaxObject.send();
        };
        self.Ajax.prototype.run = function() {
            this._createAjaxObject();
            this.startTime = new Date();
            this._requestUrl(this.config.method, this.config.url);
            this.config.started = true;
        };
        self.Ajax.prototype.abort = function() {
            this._ajaxObject.abort();
            this.config.aborted = true;
        };
        self.Ajax.prototype.getDataAs = function(type) {
            switch (type) {
                case Const.AJAX_DATA_TYPE.JSON: return this.getDataAsJson();
                case Const.AJAX_DATA_TYPE.XML:  return this.getDataAsMarkup();
                case Const.AJAX_DATA_TYPE.HTML: return this.getDataAsString();
            }
            return this.getDataAsRaw();
        };
        self.Ajax.prototype.getDataAsJson = function() {
            return {};
        };
        self.Ajax.prototype.getDataAsMarkup = function() {
            return document.createDocumentFragment();
        };
        self.Ajax.prototype.getDataAsString = function() {
            return '';
        };
        self.Ajax.prototype.getDataAsRaw = function() {
            return this._ajaxObject.response || this._ajaxObject.responseText;
        };
    }).apply(self);
    (function() {
        var AdServerList = new self.ObjectList(),
            paramOverride = {global:{}, slots:{}, secured:{}},
            urlParams = location.search.substr(1).split('&'),
        _;

            each(urlParams, function(i, param) {
            var name = param.substr(0, param.indexOf('=')),
                value = param.substr(param.indexOf('=')+1),
            _;
            if (name.indexOf(Const.OVERRIDE_PARAM_PREFIX) !== 0) { return; }
            var nameParts = name.substr(Const.OVERRIDE_PARAM_PREFIX.length).split(':');
            if (nameParts[1]) {
                paramOverride.slots[nameParts[0]] = paramOverride.slots[nameParts[0]] || {}
                paramOverride.slots[nameParts[0]][nameParts[1]] = value;
            } else {
                paramOverride.global[nameParts[0]] = value;
            }
        });

            self.AdServer = function(id, config, params) {
            if (this === self) {
                return id instanceof self.AdServer ? id : (AdServerList.get(id) || new self.AdServer(id, config, params));
            }
            this.id = id;
            this.activated = false;
            this[securedSymbol] = {
                setSecuredParam: function(name, value) {
                    paramOverride.secured[name] = value;
                },
                getSecuredParam: function() { return paramOverride.secured; }
            };
            this._global = {};
            this.setConfig(extend({
                enabled: true,
                supportRefresh: true,
                protocol: '//',
                host: '',
                path: '',
                sepQuery: '?',
                sepParams: '&',
                sepNameValue: '=',
                sepFragment: '#',
                paramOrder: {
                    begin:  [],
                    end:    [],
                    ignore: []
                },
                requestTypes: {
                    javascript: undefined,
                    iframe: undefined,  
                    friendlyIframe: undefined,
                    json: undefined,
                    safeFrame: undefined
                },
                evenIfEmpty: [],
                checkParams: undefined, 
                nonContentElements: []
            }, config));
            this.setParam(params);

                if (typeof this.getConfig('init') === 'function') {
                try {
                    this.getConfig('init').bind(this)();
                } catch (e) {
                    self.log.error('Error in initialization of AdServer "' + id + '"', e, this);
                }
            }

                this.slotConfig = {};
            this.slotParams = {};

                this.AdServer = self.AdServer.bind(self);
            AdServerList.register(this);
            if (this.config.probableDefault && !self.getDefaultAdServer()) {
                self.setDefaultAdServer(this);
            }
        };

        self.AdServer.getList = function() {
            return AdServerList.getList();
        };

        self.AdServer.prototype.activate = function() {
            if (this.activated) { return this; }
            this.activated = true;
            if (typeof this.config.firstUse === 'function') {
                this.config.firstUse.bind(this)();
            }
            return this;
        };
        self.AdServer.prototype.firstUse = function() {
        };
        self.AdServer.prototype.configure = function(config) {
            self.log.legacy('AdService.AdServer(...).configure(...) is deprecated. Please use AdService.AdServer(...).setConfig(...) instead.');
            return this.setConfig(config);
        };
        self.AdServer.prototype.setParam = function(params) {
            if (typeof params !== 'object' || params === null) {
                var tmp = {};
                tmp[arguments[0]] = arguments[1];
                params = tmp;
            }
            var data = {
                server: this,
                params: params,
            _:0};
            self.trigger('server.setparam', data);
            this.params = extend(this.params || {}, data.params);
            return this;
        };
        self.AdServer.prototype.setDirectParam = function(params) {
            if (typeof params !== 'object' || params === null) {
                var tmp = {};
                tmp[arguments[0]] = arguments[1];
                params = tmp;
            }
            var data = {
                server: this,
                params: params,
            _:0};
            self.trigger('server.setdirectparam', data);
            this.directParams = extend(this.directParams || {}, data.params);
            return this;
        };
        self.AdServer.prototype.setConfig = function(config) {
            if (typeof config === 'string') {
                var tmp = {};
                tmp[arguments[0]] = arguments[1];
                config = tmp;
            }
            var data = {
                server: this,
                config: config,
            _:0};
            self.trigger('server.setconfig', data);
            this.config = extend(this.config || {}, data.config);
            return this;
        };
        self.AdServer.prototype.enable = function() {
            this.setConfig('enabled', true);
            self.trigger('server.enabled', self._getCurrentAdSlot(), {server:this});
            return this;
        };
        self.AdServer.prototype.disable = function() {
            this.setConfig('enabled', false);
            self.trigger('server.disabled', self._getCurrentAdSlot(), {server:this});
            return this;
        };
        self.AdServer.prototype.isEnabled = function() {
            return this.getConfig('enabled');
        };
        self.AdServer.prototype.setSlotParam = function(slot, key, value) {
            var slotParams = {};
            if (typeof slot === 'string') {
                if (typeof key === 'string') {
                    var tmp = {};
                    tmp[key] = value;
                    slotParams[slot] = tmp;
                } else {
                    slotParams[slot] = key;
                }
            } else {
                slotParams = slot;
            }
            this.slotParams = extend(this.slotParams, slot);
            return this;
        };
        self.AdServer.prototype.setSlotConfig = function(slot, key, value) {
            var slotConfig = {};
            if (typeof slot === 'string') {
                if (typeof key === 'string') {
                    var tmp = {};
                    tmp[key] = value
                    slotConfig[slot] = tmp;
                } else {
                    slotConfig[slot] = key
                }
            } else {
                slotConfig = slot;
            }

                this.slotConfig = extend(this.slotConfig, slot);
            return this;
        };
        self.AdServer.prototype.getUrl = function(slot, requestMethod) {
            slot = self._getAdSlot(slot);
            var data = {
                server: this,
                slot: slot,
                requestMethod: requestMethod,
            _:0};
            self.trigger('server.getUrl', slot, data);
            var url = this._getUrl(slot, requestMethod);
            return url;
        };
        self.AdServer.prototype.getConfig = function(key, defaultValue) {
            if (typeof key !== 'undefined') {
                return this.config.hasOwnProperty(key) ? this.config[key] : defaultValue;
            } else {
                return this.config;
            }
        };
        self.AdServer.prototype.getParams = function() {
            var params = extend({}, this.params || {}, paramOverride.global || {}, paramOverride.secured || {});
            each(params, function(key, value) {
                if (typeof params[key] === 'function') {
                    params[key] = params[key](this);
                }
            });
            return params;
        };
        self.AdServer.prototype.getParam = function(key, defaultValue) {
            if (key instanceof Array) {
                var result = {};
                var params = this.getParams();
                each(key, function(i, name) {
                    result[name] = params[name];
                });
                return result;
            }
            return this.getParams()[key] || defaultValue;
        };

            self.AdServer.prototype.getParamsForSlot = function(slot) {
            var params = extend({}, this.params || {}, slot.params || {}, paramOverride.global, paramOverride.slots[slot] || {}, slot.onetimeParams || {}, paramOverride.secured || {}, slot.getExpiringParams() || {});
            each(params, function(key, value) {
                if (typeof value === 'function') {
                    params[key] = params[key](slot);
                }
            });
            return params;
        };

            self.AdServer.prototype.getParamForSlot = function(slot, key, defaultValue) {
            return this.getParamsForSlot(slot)[key] || defaultValue;
        };

            self.AdServer.prototype._getUrl = function(slot, requestMethod) {
            var config = this.config;
            var params = this.getParams();
            var paramString = this._getParamString(params, slot);
            return config.protocol + config.host + '/' + config.path + config.sepQuery + paramString;
        };

        self.AdServer.prototype.getUrlParams = function(slot, requestMethod) {
            var params = this.getParamsForSlot(slot, requestMethod);
            params = this.prepareParamsForUrl ? this.prepareParamsForUrl(params, slot) : params;
            var config = this.config;

                var data = {
                    params: params,
                    keyList: [],
                    sortedParams: {},
                _:0},
                paramOrder = config.paramOrder,
            _;

            var evenIfEmpty = config.evenIfEmpty;
            for (var i=0, l=evenIfEmpty.length; i<l; i++) {
                if (typeof data.params[evenIfEmpty[i]] === 'undefined') {
                    data.params[evenIfEmpty[i]] = undefined;
                }
            }

                data.keyList = keys(data.params);
            self.trigger('server.getParams.begin', slot, data);

            var beginLength = paramOrder.begin.length;
            while (beginLength > 0) {
                var index = data.keyList.indexOf(paramOrder.begin[--beginLength]);
                if (index !== -1) {
                    data.keyList.unshift(data.keyList.splice(index, 1)[0]);
                }
            }

            for (var i=0, l=paramOrder.end.length; i<l; i++) {
                var index = data.keyList.indexOf(paramOrder.end[i]);
                if (index !== -1) {
                    data.keyList.push(data.keyList.splice(index, 1)[0]);
                }
            }

            for (var i=0, l=paramOrder.ignore.length; i<l; i++) {
                var index = data.keyList.indexOf(paramOrder.ignore[i]);
                if (index !== -1) {
                    data.keyList.splice(index, 1);
                }
            }

            var sortedParams = {};
            for (var i=0, l=data.keyList.length; i<l; i++) {
                sortedParams[data.keyList[i]] = data.params[data.keyList[i]];
            }

                data.sortedParams = sortedParams;
            self.trigger('server.getParams.end', slot, data);
            return data.sortedParams;
        };

            self.AdServer.prototype._getParamName = function(key, value, slot) {
            return key;
        };

            self.AdServer.prototype._getParamString = function(params, slot) {
            var paramStrings = [],
                config = this.config,
                server = this;
            each(params, function(key, value) {
                if (typeof value !== 'undefined' || config.evenIfEmpty.indexOf(key) !== -1 ) {
                    if (typeof value === 'function') {
                        value = value(slot);
                    }
                    paramStrings.push(server._getParamName(key, value, slot) + config.sepNameValue + Code.url(typeof value === 'undefined' ? '' : value));
                }
            });
            return paramStrings.join(config.sepParams);
        };
        self.AdServer.prototype.isEmptyAd = function(domNode) {
            var elements = ['script', 'style'].concat(this.getConfig('nonContentElements'));
            var hasContent = false;
            each(domNode.childNodes, function(i, node) {
                if (node.nodeType !== document.ELEMENT_NODE) { return; }
                hasContent = hasContent || !(elements.indexOf(node.nodeName.toLowerCase())+1);
            });
            return !hasContent;
        };
        self.AdServer.prototype.renderMeta = function(html, meta) {
            return html;
        };
        self.AdServer.prototype.newPageContext = function() {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').newPageContext()');
            return this;
        };

            self.AdServer.prototype.getAdSize = function(domNode) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').getAdSize(domNode)');
            return {width:undefined, height:undefined};
        };

            self.AdServer.prototype.splitMultiResponse = function(domNode) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').splitMultiResponse()');
            return [];
        };

            self.AdServer.prototype.exportMetaData = function() {
            return this;
        };
        self.AdServer.prototype.importMetaData = function(data) {
        };

            self.AdServer.prototype.getAdFormByMetaData = function(meta, fallbackAllowed) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').getAdFormByMetaData()');
            return undefined;
        };

            self.AdServer.prototype.getEventsByMetaData = function(meta) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').getEventsByMetaData()');
            return undefined;
        };
        self.AdServer.prototype.isAlive = function() {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').isAlive()');
            return new Promise(function(done, reject) { window.setTimeout(function() { return Math.random() < 0.5 ? done(true) : reject(false); }, 500 + Math.random()*1000)});
        };

            /**
         * @TODO comment! checks if adserver url is valid
         */
        self.AdServer.prototype.checkUrlValidity = function(url) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').checkUrlValidity()');
            return false;
        };

            self.AdServer.prototype.back = function() {
            return self;
        };

        self.getParams = function() {
            return self.getDefaultAdServer().getParams();
        };
        self.getParam = function(name) {
            if (name instanceof Array) {
                var result = {};
                var params = self.getDefaultAdServer().getParams();
                each(name, function(i, name) {
                    result[name] = params[name];
                });
                return result;
            }
            return self.getDefaultAdServer().getParams()[name];
        };
        self.setParam = function() { 
            var server = self.getDefaultAdServer();
            server.setParam.apply(server, arguments);
            return self;
        };
       self.setDirectParam = function() { 
           var server = self.getDefaultAdServer();
           server.setDirectParam.apply(server, arguments);
           return self;
       };


            }).apply(self);
    (function() {
        var AdSlotList = new self.ObjectList();

        self.AdSlot = function(id, config, params) {
            if (this === self) {
                return id instanceof self.AdSlot
                     ? id
                     : (id instanceof Node
                       ? self.findAdSlotByNode(id)
                       : (AdSlotList.get(id) || new self.AdSlot(id, config, params))
                     );
            }
            this.id = id;
            this.config = config || {};
            this.params = params || {};
            this.onetimeParams = {};
            this.expiringParams = {};
            this.directParams = {};
            this.sandboxAttributes = {};
            this.clones = [];
            this.parent = null;
            this.lastRequestedUrl = null;
            this.lastUsedAdHtml = null;
            this._pendingAdHtml = null;
            this.htmlQueue = [];
            this.fixedSize = {type: 'auto'};
            this.timeout = {id: undefined, note: '', callback: undefined, time: null};
            this.isIndependent = false;

                if (!this.config.hasOwnProperty('enabled')) {
                this.setConfig('enabled', self.getConfig('slot-enabled-default', true));
            }

                if (this.config.domNode) {
                this.setDomNode(this.config.domNode);
            }
            AdSlotList.register(this);
            if (!this.getConfig('enabled')) {
                self.trigger('slot.disabled', this);
            }
        };

        self.AdSlot.getList = function() {
            return AdSlotList.getList();
        };

            self.AdSlot.get = function(id) {
            self.log.deprecated('AdService.AdSlot.get("'+id+'"): Please use AdService.AdSlot("'+id+'") instead. The method .get() will be removed soon!');
            return AdSlotList.get(id) || new self.AdSlot(id);
        };

        self.AdSlot.getDomNodes = function() {
            var selectors = [];
            each(arguments, function(i, item) {
                var slotname = (item instanceof self.AdSlot || typeof item !== 'string')
                             ? item.id
                             : item;
                selectors.push('[' + self.getDataAttrName('slot') + '="' + Code.css(slotname) + '"]');
            });
            return dom(selectors.join(', '));
        };

        self.AdSlot.prototype.getDomNode = function() {
            return this.setDomNode(self.getConfig('slot-getdomnode-function')(this));
        };
        function getDomNode(slot) {
            return slot.domNode || self.AdSlot.getDomNodes(slot)[0];
        }
        self.setConfig('slot-getdomnode-function', getDomNode);

        self.AdSlot.prototype.setDomNode = function(domNode) {
            if (!domNode) { return; }
            if (this.domNode === domNode) { return domNode; }
            this.domNode = domNode;
            this.domNode.adSlot = this;
            this.domId = this.domNode.id = this.domNode.id || this.generateDomId();
            this.domNode.setAttribute(self.getDataAttrName('slot') + '-initialized', 'true');
            var paramRoot = self.getDataAttrName('param-'),
                slot = this,
            _;
            each(this.domNode.attributes, function(i, attr) {
                if (attr.nodeName.indexOf(paramRoot) < 0) { return; }
                slot.params[attr.nodeName.substr(paramRoot.length)] = attr.nodeValue;
            });
            self._runOutsourceable('slotDomNodeInit', this, [this], this.getAdServer());
            return domNode;
        };
        self._global.slotDomNodeInit = function() { return self; };

            self.AdSlot.prototype.generateDomId = function() {
            var namespace = self.getConfig('data-attribute-namespace');
            return namespace + '-' + this.id;
        };

            self.AdSlot.prototype.getTarget = function() {
            return this.target || this.getDomNode();
        };
        self.AdSlot.prototype.setTarget = function(domNode) {
            this.target = domNode;
        };

            self.AdSlot.prototype.toString = function() {
            return this.id;
        };
        self.AdSlot.prototype.getParam = function(key, defaultValue) {
            if (key instanceof Array) {
                var result = {};
                var slot = this;
                each(key, function(i, name) {
                    result[name] = slot.getParam(name); 
                });
                return result;
            }
            if (typeof this.params[key] !== 'undefined') {
                if (typeof this.params[key] === 'function') {
                    return this.params[key](this);
                } else {
                    return this.params[key];
                }
            } else {
                return this.getAdServer().getParamForSlot(this, key, defaultValue);
            }
        };
        self.AdSlot.prototype.setParam = function(key, value) {
            if (typeof key === 'object') {
                var slot = this;
                each(key, function(key, value) {
                    slot.setParam(key, value);
                });
                return self;
            }
            var data = {
                name: key,
                value: value,
            _:0};
            self.trigger('slot.setparam', this, data);
            this.params[data.name] = data.value;
            each(this.clones, function(i, clone) { clone.setParam(key, data.value); });
            return self;
        };
       self.AdSlot.prototype.setDirectParam = function(key, value) {
           if (typeof key === 'object') {
               var slot = this;
               each(key, function(key, value) {
                   slot.setDirectParam(key, value);
               });
               return self;
           }
           var data = {
               name: key,
               value: value,
           _:0};
           self.trigger('slot.setdirectparam', this, data);
           this.directParams[data.name] = data.value;
           each(this.clones, function(i, clone) { clone.setDirectParam(key, data.value); });
           return self;
       };
        self.AdSlot.prototype.setOnetimeParam = function(key, value) {
            if (typeof key === 'object') {
                var slot = this;
                each(key, function(key, value) {
                    slot.setOnetimeParam(key, value);
                });
                return self;
            }
            var data = {
                name: key,
                value: value,
                onetime: true,
            _:0};
            self.trigger('slot.setonetimeparam', this, data);
            this.onetimeParams[data.name] = data.value;
            each(this.clones, function(i, clone) { clone.setOnetimeParam(key, data.value); });
            return self;
        };
        self.AdSlot.prototype.removeOnetimeParam = function() {
            var slot = this;
            each(arguments, function(i, key) {
                delete slot.onetimeParams[key];
            })
        };
        self.AdSlot.prototype.clearOnetimeParams = function() {
            this.onetimeParams = {};
        };
        self.AdSlot.prototype.setExpiringParam = function(key, value, expires) {
            if (typeof key === 'object') {
                var slot = this,
                    expires = key.expires;
                each(key.params, function(key, value) {
                    slot.setExpiringParam(key, value, expires);
                });
                return self;
            }
            var data = {
                name: key,
                value: value,
                onetime: true,
                expires: (+ new Date()) + expires,
            _:0};
            self.trigger('slot.setexpiringparam', this, data);
            this.expiringParams[data.name] = { value: data.value, expires: data.expires };
            each(this.clones, function(i, clone) { clone.setExpiringParam(key, data.value, expires); });
            return self;
        };
        self.AdSlot.prototype.removeExpiringParam = function() {
            var slot = this;
            each(arguments, function(i, key) {
                delete slot.expiringParams[key];
            })
        };
        self.AdSlot.prototype.clearExpiringParams = function() {
            this.expiringParams = {};
        };
        self.AdSlot.prototype.getExpiringParams = function() {
          var slot = this,
              params = {};
          each(this.expiringParams, function(key, data) {
            if(data.expires && data.expires < +new Date()) {
              slot.removeExpiringParam(key);
            } else {
              params[key] = data.value;
            }

              });
          return params;
        };

            self.AdSlot.prototype.getConfig = function(key, defaultValue) {
            return this.config.hasOwnProperty(key) ? this.config[key] : defaultValue;
        };
        self.AdSlot.prototype.setConfig = function(key, value) {
            var data = {
                name: key,
                value: value,
            _:0};
            switch (data.name) {
                case 'adserver':
                    data.value = self.AdServer(data.value);
                    break;
                default:
                    break;
            }
            self.trigger('slot.setconfig', this, data);
            this.config[data.name] = data.value;
            each(this.clones, function(i, clone) { clone.setConfig(key, data.value); });
            return self;
        };

            /**
         * setSandboxAttributes(false) -- no sandbox attributes
         * setSandboxAttributes({foo:true, bar:false}) -- foo, but no bar, and all default (=previous) values
         * this.sandboxAttribute = {} => no sandbox attribute (Object.keys(this.sandbox).length===0)
         * this.sandboxAttribute = {...:false} => empty sandbox attribute
         * this.sandboxAttribute = {...:true} => filled sandbox attribute
         */
        self.AdSlot.prototype.setSandboxAttributes = function(attr) {
            if (attr === false) {
                this.sandboxAttributes = {};
                return self;
            }
            this.sandboxAttributes = extend(this.sandboxAttributes, attr);
            return self;
        };
        self.AdSlot.prototype.getSandboxAttributeValue = function(attrs) {
            var attr = Object.keys(attrs || this.sandboxAttributes).filter(function(key) {
                return (attrs || this.sandboxAttributes)[key];
            }.bind(this));
            return attr.join(' ');
        };
        self.AdSlot.prototype.getSandboxAttribute = function(attrs) {
            if (Object.keys(attrs || this.sandboxAttributes).length) {
                return ' sandbox="' + this.getSandboxAttributeValue(attrs) + '"';
            }
            return '';
        };
        self.AdSlot.prototype.getSandboxAttributes = function() {
            return extend({}, self.getSandboxAttributes(), this.sandboxAttributes);
        };

        self.AdSlot.prototype.getAdServer = function() {
            return (typeof this.config.adserver !== 'undefined') ? self.AdServer(this.config.adserver) : self.getDefaultAdServer();
        };
        self.AdSlot.prototype.setAdServer = function(adserver) {
            this.setConfig('adserver', adserver);
        };
        self.AdSlot.prototype.enable = function() {
            this.setConfig('enabled', true);
            self.trigger('slot.enabled', this);
            return this;
        };
        self.AdSlot.prototype.disable = function() {
            this.setConfig('enabled', false);
            self.trigger('slot.disabled', this);
            return this;
        };
        self.AdSlot.prototype.isEnabled = function() {
            return this.getConfig('enabled', true);
        };
        self.AdSlot.prototype.isEmpty = function() {
            return this.getAdServer().isEmptyAd(this.getDomNode());
        };
        self.AdSlot.prototype.getUrl = function(requestMethod, callback) {
            if (typeof requestMethod === 'function') {
                callback = requestMethod;
                requestMethod = undefined;
            }
            var server = this.getAdServer().activate();
            if (typeof callback === 'function') {
                function sendResult() {
                    callback(server.getUrl(this, requestMethod));
                }
                return self.waitFor('auction.finished', sendResult.bind(this)), undefined;
            }
            var url = server.getUrl(this, requestMethod);
            return url;
        };
        self.AdSlot.prototype.getAdSize = function(doc) {
            var server = this.getAdServer();
            return server.getAdSize(doc || this.domNode);
        };
        self.AdSlot.prototype.setFixedSize = function(width, height) {
            if (width && height) {
                this.fixedSize.type = 'fixed';
                this.fixedSize.width = width;
                this.fixedSize.height = height;
            } else if (width === false) {
                this.fixedSize.type = 'pagecontrol';
            } else {
                this.fixedSize.type = 'auto';
            }
            return this;
        };
        self.AdSlot.prototype.getVisibleFraction = function() {
            var dom = this.getDomNode();
            if (!dom || !dom.getBoundingClientRect) { return 0; }
            var rect = dom.getBoundingClientRect(),
                winrect = {
                    width: win.innerWidth || win.clientWidth,
                    height: win.innerHeight || win.clientHeight
                },
                rectSize = (rect.width || rect.right-rect.left) * (rect.height || rect.bottom-rect.top),
                areaSize = (Math.min(rect.right, winrect.width) - Math.max(rect.left, 0)) * (Math.min(rect.bottom, winrect.height) - Math.max(rect.top, 0)),
            _;
            self.log.level('adreq', '[AdSlot.getVisibleFraction]', 'slot', this.id, 'rect', rect, 'winrect', winrect, 'rectSize', rectSize, 'areaSize', areaSize, '+(rect.left >= 0 && rect.right <= winrect.width && rect.top >= 0 && rect.bottom <= winrect.height)', +(rect.left >= 0 && rect.right <= winrect.width && rect.top >= 0 && rect.bottom <= winrect.height));
            return rectSize ? areaSize / rectSize : +(rect.left >= -2 && Math.floor(rect.right)-2 <= winrect.width && rect.top >= -2 && Math.floor(rect.bottom)-2 <= winrect.height);
        };
        self.AdSlot.prototype.isVisible = function(minFraction) {
            var preCheck = this.getConfig('visibility-precheck', this.getAdServer().getConfig('visibility-precheck', self.getConfig('visibility-precheck')));
            if (typeof preCheck === 'function') {
                try {
                    var result = preCheck(this, minFraction);
                    if (typeof result === 'boolean') {
                        return result;
                    }
                } catch (e) {
                    self.log.error('Error in function supplied for AdService.AdSlot(\''+this.id+'\').setConfig(\'visibility-precheck\')', e, arguments, this);
                }
            }
                var lookahead = self.getConfig('visibility-lookahead', false);
                if (lookahead && (typeof minFraction !== 'boolean' || !minFraction)) {
                    var domnode = this.getDomNode();
                    self.log.level('adreq', '[AdSlot.isVisible lookahead]', 'slot', this.id, 'lookahead', self.getConfig('visibility-lookahead', false), 'domnode', domnode ? domnode.getBoundingClientRect().top <= win.pageYOffset + win.innerHeight + lookahead : false);
                    return domnode ? domnode.getBoundingClientRect().top <= win.pageYOffset + win.innerHeight + lookahead : false;
                }
                minFraction = undefined;
            self.log.level('adreq', '[AdSlot.isVisible end]', 'slot', this.id, 'preCheck', preCheck, 'minFraction', minFraction || self.getConfig('visibility-minimum-fraction', 0.5));
            return this.getVisibleFraction() >= (minFraction || self.getConfig('visibility-minimum-fraction', 0.5));
        };
        self.AdSlot.prototype.clone = function(id, config, params) {
            var slot = new self.AdSlot(id, config, params);
            slot.parent = this;
            slot.config = extend(slot.config, this.config);
            slot.params = extend(slot.params, this.params);
            this.clones.push(slot);
            return slot;
        };

            self.AdSlot.prototype.queueAdHtml = function(html, type) {
            this.htmlQueue.push({html:html, type:type});
            return this;
        };
        self.AdSlot.prototype.hasQueuedAdHtml = function() {
            return this.htmlQueue.length > 0;
        };
        self.AdSlot.prototype.getQueuedAdHtml = function() {
            var data = this.htmlQueue.shift();
            this._pendingAdHtml = data.html;
            return data.html;
        };
        self.AdSlot.prototype.getNextQueuedAdType = function() {
            return (this.htmlQueue[0] || [{}]).type;
        };

        self.AdSlot.prototype.empty = function() {
            var slot = this;
            return this.modify('empty', function(data) { data.domNode.innerHTML = ''; });
        };
        self.AdSlot.prototype.kill = function() {
            var slot = this;
            return this.modify('kill', function(data) { data.domNode.parentNode.removeChild(data.domNode); }, function(data) { slot.disable(); });
        };
        self.AdSlot.prototype.hide = function(method) {
            var slot = this;
            switch (method) {
                case 'visibility':
                    method = function(data) { data.domNode.style.visibility = 'hidden'; };
                    break;
                case 'display':
                default:
                    if (typeof method !== 'function') {
                        method = function(data) { data.domNode.style.display = 'none'; };
                    }
            }
            return this.modify('hide', method, function(data) { slot.disable(); });
        };
        self.AdSlot.prototype.show = function(method) {
            var slot = this;
            switch (method) {
                case 'visibility':
                    method = function(data) { data.domNode.style.visibility = 'visible'; };
                    break;
                case 'display':
                    method = function(data) { data.domNode.style.display = ''; if (!data.domNode.offsetHeight) { data.domNode.style.display = 'inline-block'; } };
                    break;
                default:
                    if (typeof method !== 'function') {
                        method = function(data) { data.domNode.style.visibility = 'visible'; data.domNode.style.display = ''; if (!data.domNode.offsetHeight) { data.domNode.style.display = 'inline-block'; } };
                    }
            }
            return this.modify('show', method, function(data) { slot.enable(); });
        };
        self.AdSlot.prototype.modify = function(action, func, toggleFunc) {
            var slot = this;
            var data = {
                    action: action, 
                    domNode: slot.getDomNode(),
                    method: func,
                    autoToggleEnabled: true,
                _:0},
            _;
            self.trigger('slot.' + action.toLowerCase(), slot, data);
            if (data.domNode) {
                try {
                    data.method(data);
                    if (toggleFunc && data.autoToggleEnabled) {
                        toggleFunc(data);
                    }
                } catch (e) {
                    self.log.error('Error in function supplied for AdService.modifySlot(slot, \''+action+'\', func, toggleFunc)', e, arguments, data, this);
                }
            }
            return this;
        };

        self.AdSlot.prototype.resize = function(width, height, elements) {
            if (this.fixedSize.type === 'pagecontrol') { return; }
            if (this.fixedSize.type === 'fixed') {
                width = this.fixedSize.width;
                height = this.fixedSize.height;
            }
            if (typeof width !== 'undefined') {
                if (!width.match(/\%/)) { width += 'px'; }
                this.domNode.style.width = width;
            }
            if (typeof height !== 'undefined') {
                if (!height.match(/\%/)) { height += 'px'; }
                this.domNode.style.height = height;
            }
            each(elements, function(i, element) {
                width && (element.style.width = width);
                height && (element.style.height = height);
            });
        };

        self.AdSlot.prototype.setTimeout = function(time, note, callback) {
            win.clearTimeout(this.timeout.id);
            if (typeof note === 'function') {
                callback = note;
                note = undefined;
            }
            this.timeout.note = note || 'deferred';
            this.timeout.callback = callback;
            this.timeout.id = win.setTimeout(this.timeoutReached.bind(this), time);
            this.timeout.time = new Date();
            self.log.level('slottimeout', 'setTimeout', this.id, extend({}, this.timeout), 0);
            return this;
        };
        self.AdSlot.prototype.timeoutReached = function() {
            var timeout = extend({}, this.timeout);
            self.log.level('slottimeout', 'timeoutReached', this.id, extend({}, this.timeout), new Date()-this.timeout.time);
            this.clearTimeout();
            if (timeout.callback) {
                return timeout.callback.call(this);
            }
            AdService.ad(this.id);
        };
        self.AdSlot.prototype.clearTimeout = function(note) {
            if (note && note !== this.timeout.note) {
                self.log.level('slottimeout', 'clearTimeout', '( wrong timeout cancel attempt:', note, ')', this.id, extend({}, this.timeout), new Date()-this.timeout.time);
                return false;
            }
            self.log.level('slottimeout', 'clearTimeout', this.id, extend({}, this.timeout), new Date()-this.timeout.time);
            this.timeout = {
                id: win.clearTimeout(this.timeout.id),
                note: '',
                callback: undefined,
                time: null
            };
            return true;
        };
        self.AdSlot.prototype.isDeferred = function() {
            return this.timeout.note;
        };

            self.AdSlot.prototype.setIndependent = function(isIndependent) {
            this.isIndependent = isIndependent === undefined ? true : isIndependent;
        };
        self.setIndependentSlot = function(slot, isIndependent) {
            return self.AdSlot(slot).setIndependent(isIndependent);
        };

        self.AdSlot.prototype._metaData = [];
        self.AdSlot.prototype.clearMetaData = function() {
            this._metaData = [];
            return this;
        };
        self.AdSlot.prototype.addMetaData = function(meta) {
            this._metaData.push(meta);
            return this;
        };
        self.AdSlot.prototype.getMetaData = function() {
            if(this._metaData.length == 0 && typeof this.getAdServer().getMetaData === 'function') {
                this.addMetaData(this.getAdServer().getMetaData(this));
            }
            return this._metaData;
        };


        self.AdSlot.prototype.getContainerWidth = function() {
            var node = this.getDomNode();
            return node ? node.offsetWidth : undefined;
        };

            self.AdSlot.prototype.getCurrentUrl = function() {
            return this.lastRequestedUrl || this.getUrl();
        };

        self.findAdSlots = function(rootNode) {
            var attrName = self.getDataAttrName('slot'),
                nodes = dom('[' + attrName + ']', rootNode);
            each(nodes, function(index, node) {
                if (node.adSlot) { return; }
                new self.AdSlot(node.getAttribute(attrName), {domNode: node});
            });
            return nodes;
        };

            self.findAdSlotByNode = function(node) {
            var attrName = self.getDataAttrName('slot'),
                origNode = node,
            _;
            while (!node.hasAttribute(attrName) && node !== doc.documentElement) {
                node = node.parentNode;
            }
            return node.hasAttribute(attrName) ? self.AdSlot(node.getAttribute(attrName)) : self.AdSlot(origNode.id);
        };

            self.getVisibleSlots = function(minFraction) {
            var slots = self.AdSlot.getList(),
                visible = [],
            _;
            each(slots, function(i, slot) {
                if (slot.isVisible(minFraction)) {
                    visible.push(slot);
                }
            });
            return visible;
        };

            self.on('ad.requested', function(evt) {
            if (evt.slot._pendingAdHtml) {
                evt.slot.lastUsedAdHtml = evt.slot._pendingAdHtml;
                evt.slot._pendingAdHtml = null;
            } else {
                evt.slot.lastRequestedUrl = evt.data.url;
            }
        });


            }).apply(self);

    (function() {
        var MethodList = new self.ObjectList(),
            storage = [];

            self.Communication = new function() {
            this.handlePostMessage = function(evt) {
                var sourceIframe = this.getIframe(evt.source),
                    data = this.parsePostMessage(evt.data);
                if (!sourceIframe && evt.source !== top) {
                    return this.demandRedo(data);
                }
                this.handleMessage(data, sourceIframe.contentWindow || evt.source, evt);
            };
            this.handleMessage = function(message, source, evt) {
                var message = this.normalizeMessage(message),
                    sourceMessage = typeof message.sourceId !== 'undefined' ? storage[message.sourceId] : undefined,
                _;

                    if (message.type === Const.MESSAGE_TYPE.CALL) {
                    if (source !== win.top) {
                        var currentAdSlot = self._getCurrentAdSlot(),
                            iframe = this.getIframe(source),
                            callerSlot
                        _;

                        var copy = iframe.parentNode;
                        var attr = self.getDataAttrName('slot');
                        while (copy !== document.body && !copy.getAttribute(attr)) {
                            copy = copy.parentNode;
                        }
                        if (copy !== document.body) {
                            callerSlot = self._getAdSlot(copy.getAttribute(attr));
                        }

                            self._setCurrentAdSlot(callerSlot);
                        try {
                            var method = AdService['_from_iframe_'+message.name] || (MethodList.get(message.name)||{}).func || AdService[message.name],
                                result,
                                result = method.apply({
                                    isPostMessage: true,
                                    message: message,
                                    window: source,
                                    iframe: iframe,
                                    slot: callerSlot,
                                    event: evt
                                }, makeArray(message.data, true)),
                            _;
                            if (result !== null) {
                                this.answerMessage(message, source, message.name, result);
                            }
                        } catch (e) {
                            self.log.error('Communication.handleMessage', 'Error in function request', e, arguments, this);
                        }
                        self._setCurrentAdSlot(currentAdSlot);
                    } else {
                        try {
                            var method = AdService[message.name],
                                result,
                                result = method.apply({
                                    isPostMessage: true,
                                    message: message,
                                    window: source,
                                    iframe: iframe,
                                    slot: callerSlot,
                                    event: evt
                                }, makeArray(message.data, true)),
                            _;
                            if (result !== null) {
                                this.answerMessage(message, source, message.name, result);
                            }
                        } catch (e) {
                            self.log.error('Communication.handleMessage', 'Error in function request in IFrame', e, arguments, this);
                        }
                    }
                } else if (message.type === Const.MESSAGE_TYPE.DEMAND_REDO) {
                    var test = storage[message.id];
                    if (test && test.name === message.name) {
                        this.sendPostMessage(source, test);
                    }
                }

                    if (typeof sourceMessage !== 'undefined' && typeof sourceMessage.callback === 'function') {
                    try {
                        sourceMessage.callback(message.data);
                    } catch (e) {
                        self.log.error('Communication.handleMessage', 'Error in callback function', e, arguments, this);
                    }
                }
            };
            this.answerMessage = function(sourceMessage, target, name, data) {
                var message = this.createMessage('answer#'+name, data);
                if (typeof sourceMessage !== 'undefined' && typeof sourceMessage.id !== 'undefined') {
                    message.sourceId = sourceMessage.id;
                }
                this._sendMessage(target, message);
            };
            this.sendMessage = function(target, name, data, callback) {
                if (data && !callback && typeof data === 'function') {
                    callback = data;
                    data = {};
                }
                var message = this.createMessage(name, data, callback);
                this._sendMessage(target, message);
            };
            this._sendMessage = function(target, message) {
                this.createMessageId(message);
                if (target.window === target) {
                    this.sendPostMessage(target, message);
                } else if (target.nodeName && target.nodeName.toLowerCase() === 'iframe') {
                    this.sendPostMessage(target.contentWindow, message);
                } else if (target instanceof HTMLElement) {
                    this.sendDirectMessage(target, message);
                }
            };
            this.sendPostMessage = function(targetWindow, message) {
                message = typeof message === 'string' ? message : JSON.stringify(message);
                (new win.Function('targetWindow', 'message', "targetWindow.postMessage(message, '*');"))(targetWindow, message);

            };
            this.sendDirectMessage = function(target, message) {
                var evt = new CustomEvent(message.name, message);
                target.dispatchEvent(evt);
            };

            this.addMethod = function(name, func) {
                MethodList.register({
                    id: name,
                    func: func,
                _:0});
                return this;
            };
            this.demandRedo = function(sourceMessage) {
                return;
            };

            this.getIframe = function(windowObject) {
                if (!windowObject) { return false; }
                var iframes = doc.getElementsByTagName('iframe');
                for (var i=0, l=iframes.length; i<l; i++) {
                    if (iframes[i].contentWindow === windowObject) {
                        return iframes[i];
                    }
                }
                return false;
            };
            this.parsePostMessage = function(message) {
                try {
                    return JSON.parse(message);
                } catch (e) {
                }
                return message;
            };
            this.normalizeMessage = function(message) {
                if (typeof message === 'string') {
                    message = {name: message};
                };
                return message;
            };
            this.createMessage = function(name, data, callback) {
                var type = Const.MESSAGE_TYPE.CALL;
                if (name.indexOf('answer#') === 0) {
                    type = Const.MESSAGE_TYPE.ANSWER;
                    name = name.substr('answer#'.length);
                } else if (name.indexOf('demandredo#') === 0) {
                    type = Const.MESSAGE_TYPE.DEMAND_REDO;
                    name = name.substr('demandredo#'.length);
                }
                var message = {
                    type: type,
                    name: name,
                    data: data,
                    callback: callback
                };
                return message;
            };
            this.createMessageId = function(message) {
                message.id = storage.push(message) - 1;
            };

            this.init = function() {

                    win.addEventListener('message', function(evt) {
                    self.Communication.handlePostMessage(evt);
                });
            };
            this.init();
        };


            self.sendMessage = function() {
            self.Communication.sendMessage.apply(self.Communication, arguments);
        }
    }).apply(self);
    (function() {
        self.Communication.addMethod('resolution', function(message, source, evt) {
            var info = self.info.view();
            return info.screen;
        });
        self.Communication.addMethod('windowSize', function(message, source, evt) {
            var info = self.info.view();
            return info.viewport;
        });
        self.Communication.addMethod('hasCanvas', function(message, source, evt) {
            var info = self.info.features();
            return info.canvas;
        });
        self.Communication.addMethod('os', function(message, source, evt) {
            var info = self.info.ua();
            return info.os.name;
        });
        self.Communication.addMethod('browser', function(message, source, evt) {
            var info = self.info.ua();
            return info.browser.name;
        });
        self.Communication.addMethod('browserVersion', function(message, source, evt) {
            var info = self.info.ua();
            return info.browser.version.majorminor;
        });
        self.Communication.addMethod('adOffset', function(message, source, evt) {
            var info = source.getBoundingClientRect();
            return {x:info.left, y:info.top};
        });
        self.Communication.addMethod('scrollPosition', function(message, source, evt) {
            var info = doc.body.scrollTop;
            return info;
        });
        self.Communication.addMethod('pageHeight', function(message, source, evt) {
            var info = doc.body.offsetHeight;
            return info;
        });
    }).apply(self);

    (function() {
        var head = document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        var obaIconUrl = 'data:image/png;base64,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';
        style.innerText = '.oba-corner-position{top:0;right:0;}.oba-wrapper{position:relative;}div.oba-wrapper div.oba-panel,div.oba-wrapper div.oba-admarker{font-family:Arial,Verdana,Tahoma,sans-serif;font-size:11px;line-height:1.3;font-weight:normal;font-style:normal;text-align:left;color:#000;}.oba-admarker:hover .oba-admarker-text,.oba-admarker-hover .oba-admarker-text{display:block;white-space:nowrap;}.oba-admarker-icon{background:url('+obaIconUrl+') no-repeat top left #ccc;width:19px;height:15px;position:absolute;cursor:pointer;}div.oba-wrapper div.oba-admarker .oba-admarker-text,div.oba-wrapper div.oba-panel .oba-panel-close{background:#ccc;font-size:10px;line-height:15px;padding:0 5px;position:absolute;cursor:pointer;}.oba-admarker-text{display:none;}.oba-corner-position .oba-admarker-text{right:15px;}';
        head.appendChild(style);
    }).apply(self);
/*!
     * mustache.js - Logic-less {{mustache}} templates with JavaScript
     * http://github.com/janl/mustache.js
     */


        (function defineMustache (global, factory) {
      if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
        factory(exports); 
      } else if (typeof define === 'function' && define.amd) {
        define(['exports'], factory); 
      } else {
        global.Mustache = {};
        factory(global.Mustache); 
      }
    }(this, function mustacheFactory (mustache) {

          var objectToString = Object.prototype.toString;
      var isArray = Array.isArray || function isArrayPolyfill (object) {
        return objectToString.call(object) === '[object Array]';
      };

          function isFunction (object) {
        return typeof object === 'function';
      }

          /**
       * More correct typeof string handling array
       * which normally returns typeof 'object'
       */
      function typeStr (obj) {
        return isArray(obj) ? 'array' : typeof obj;
      }

          function escapeRegExp (string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
      }

          /**
       * Null safe way of checking whether or not an object,
       * including its prototype, has a given property
       */
      function hasProperty (obj, propName) {
        return obj != null && typeof obj === 'object' && (propName in obj);
      }

          /**
       * Safe way of detecting whether or not the given thing is a primitive and
       * whether it has the given property
       */
      function primitiveHasOwnProperty (primitive, propName) {  
        return (
          primitive != null
          && typeof primitive !== 'object'
          && primitive.hasOwnProperty
          && primitive.hasOwnProperty(propName)
        );
      }

      var regExpTest = RegExp.prototype.test;
      function testRegExp (re, string) {
        return regExpTest.call(re, string);
      }

          var nonSpaceRe = /\S/;
      function isWhitespace (string) {
        return !testRegExp(nonSpaceRe, string);
      }

          var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      };

          function escapeHtml (string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
          return entityMap[s];
        });
      }

          var whiteRe = /\s*/;
      var spaceRe = /\s+/;
      var equalsRe = /\s*=/;
      var curlyRe = /\s*\}/;
      var tagRe = /#|\^|\/|>|\{|&|=|!/;

          /**
       * Breaks up the given `template` string into a tree of tokens. If the `tags`
       * argument is given here it must be an array with two string values: the
       * opening and closing tags used in the template (e.g. [ "" ]). Of
       * course, the default is to use mustaches (i.e. mustache.tags).
       *
       * A token is an array with at least 4 elements. The first element is the
       * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
       * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
       * all text that appears outside a symbol this element is "text".
       *
       * The second element of a token is its "value". For mustache tags this is
       * whatever else was inside the tag besides the opening symbol. For text tokens
       * this is the text itself.
       *
       * The third and fourth elements of the token are the start and end indices,
       * respectively, of the token in the original template.
       *
       * Tokens that are the root node of a subtree contain two more elements: 1) an
       * array of tokens in the subtree and 2) the index in the original template at
       * which the closing tag for that section begins.
       */
      function parseTemplate (template, tags) {
        if (!template)
          return [];

            var sections = [];     
        var tokens = [];       
        var spaces = [];       
        var hasTag = false;    
        var nonSpace = false;  

        function stripSpace () {
          if (hasTag && !nonSpace) {
            while (spaces.length)
              delete tokens[spaces.pop()];
          } else {
            spaces = [];
          }

              hasTag = false;
          nonSpace = false;
        }

            var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags (tagsToCompile) {
          if (typeof tagsToCompile === 'string')
            tagsToCompile = tagsToCompile.split(spaceRe, 2);

              if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
            throw new Error('Invalid tags: ' + tagsToCompile);

              openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
          closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
          closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }

            compileTags(tags || mustache.tags);

            var scanner = new Scanner(template);

            var start, type, value, chr, token, openSection;
        while (!scanner.eos()) {
          start = scanner.pos;

          value = scanner.scanUntil(openingTagRe);

              if (value) {
            for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
              chr = value.charAt(i);

                  if (isWhitespace(chr)) {
                spaces.push(tokens.length);
              } else {
                nonSpace = true;
              }

                  tokens.push([ 'text', chr, start, start + 1 ]);
              start += 1;

              if (chr === '\n')
                stripSpace();
            }
          }

          if (!scanner.scan(openingTagRe))
            break;

              hasTag = true;

          type = scanner.scan(tagRe) || 'name';
          scanner.scan(whiteRe);

          if (type === '=') {
            value = scanner.scanUntil(equalsRe);
            scanner.scan(equalsRe);
            scanner.scanUntil(closingTagRe);
          } else if (type === '{') {
            value = scanner.scanUntil(closingCurlyRe);
            scanner.scan(curlyRe);
            scanner.scanUntil(closingTagRe);
            type = '&';
          } else {
            value = scanner.scanUntil(closingTagRe);
          }

          if (!scanner.scan(closingTagRe))
            throw new Error('Unclosed tag at ' + scanner.pos);

              token = [ type, value, start, scanner.pos ];
          tokens.push(token);

              if (type === '#' || type === '^') {
            sections.push(token);
          } else if (type === '/') {
            openSection = sections.pop();

                if (!openSection)
              throw new Error('Unopened section "' + value + '" at ' + start);

                if (openSection[1] !== value)
              throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
          } else if (type === 'name' || type === '{' || type === '&') {
            nonSpace = true;
          } else if (type === '=') {
            compileTags(value);
          }
        }

        openSection = sections.pop();

            if (openSection)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

            return nestTokens(squashTokens(tokens));
      }

          /**
       * Combines the values of consecutive text tokens in the given `tokens` array
       * to a single token.
       */
      function squashTokens (tokens) {
        var squashedTokens = [];

            var token, lastToken;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          token = tokens[i];

              if (token) {
            if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
              lastToken[1] += token[1];
              lastToken[3] = token[3];
            } else {
              squashedTokens.push(token);
              lastToken = token;
            }
          }
        }

            return squashedTokens;
      }

          /**
       * Forms the given array of `tokens` into a nested tree structure where
       * tokens that represent a section have two additional items: 1) an array of
       * all tokens that appear in that section and 2) the index in the original
       * template that represents the end of that section.
       */
      function nestTokens (tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];

            var token, section;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          token = tokens[i];

              switch (token[0]) {
            case '#':
            case '^':
              collector.push(token);
              sections.push(token);
              collector = token[4] = [];
              break;
            case '/':
              section = sections.pop();
              section[5] = token[2];
              collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
              break;
            default:
              collector.push(token);
          }
        }

            return nestedTokens;
      }

          /**
       * A simple string scanner that is used by the template parser to find
       * tokens in template strings.
       */
      function Scanner (string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
      }

          /**
       * Returns `true` if the tail is empty (end of string).
       */
      Scanner.prototype.eos = function eos () {
        return this.tail === '';
      };

          /**
       * Tries to match the given regular expression at the current position.
       * Returns the matched text if it can match, the empty string otherwise.
       */
      Scanner.prototype.scan = function scan (re) {
        var match = this.tail.match(re);

            if (!match || match.index !== 0)
          return '';

            var string = match[0];

            this.tail = this.tail.substring(string.length);
        this.pos += string.length;

            return string;
      };

          /**
       * Skips all text until the given regular expression can be matched. Returns
       * the skipped string, which is the entire tail if no match can be made.
       */
      Scanner.prototype.scanUntil = function scanUntil (re) {
        var index = this.tail.search(re), match;

            switch (index) {
          case -1:
            match = this.tail;
            this.tail = '';
            break;
          case 0:
            match = '';
            break;
          default:
            match = this.tail.substring(0, index);
            this.tail = this.tail.substring(index);
        }

            this.pos += match.length;

            return match;
      };

          /**
       * Represents a rendering context by wrapping a view object and
       * maintaining a reference to the parent context.
       */
      function Context (view, parentContext) {
        this.view = view;
        this.cache = { '.': this.view };
        this.parent = parentContext;
      }

          /**
       * Creates a new context using the given view with this context
       * as the parent.
       */
      Context.prototype.push = function push (view) {
        return new Context(view, this);
      };

          /**
       * Returns the value of the given name in this context, traversing
       * up the context hierarchy if the value is absent in this context's view.
       */
      Context.prototype.lookup = function lookup (name) {
        var cache = this.cache;

            var value;
        if (cache.hasOwnProperty(name)) {
          value = cache[name];
        } else {
          var context = this, intermediateValue, names, index, lookupHit = false;

              while (context) {
            if (name.indexOf('.') > 0) {
              intermediateValue = context.view;
              names = name.split('.');
              index = 0;

                  /**
               * Using the dot notion path in `name`, we descend through the
               * nested objects.
               *
               * To be certain that the lookup has been successful, we have to
               * check if the last object in the path actually has the property
               * we are looking for. We store the result in `lookupHit`.
               *
               * This is specially necessary for when the value has been set to
               * `undefined` and we want to avoid looking up parent contexts.
               *
               * In the case where dot notation is used, we consider the lookup
               * to be successful even if the last "object" in the path is
               * not actually an object but a primitive (e.g., a string, or an
               * integer), because it is sometimes useful to access a property
               * of an autoboxed primitive, such as the length of a string.
               **/
              while (intermediateValue != null && index < names.length) {
                if (index === names.length - 1)
                  lookupHit = (
                    hasProperty(intermediateValue, names[index]) 
                    || primitiveHasOwnProperty(intermediateValue, names[index])
                  );

                    intermediateValue = intermediateValue[names[index++]];
              }
            } else {
              intermediateValue = context.view[name];

                  /**
               * Only checking against `hasProperty`, which always returns `false` if
               * `context.view` is not an object. Deliberately omitting the check
               * against `primitiveHasOwnProperty` if dot notation is not used.
               *
               * Consider this example:
               * ```
               * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
               * ```
               *
               * If we were to check also against `primitiveHasOwnProperty`, as we do
               * in the dot notation case, then render call would return:
               *
               * "The length of a football field is 9."
               *
               * rather than the expected:
               *
               * "The length of a football field is 100 yards."
               **/
              lookupHit = hasProperty(context.view, name);
            }

                if (lookupHit) {
              value = intermediateValue;
              break;
            }

                context = context.parent;
          }

              cache[name] = value;
        }

            if (isFunction(value))
          value = value.call(this.view);

            return value;
      };

          /**
       * A Writer knows how to take a stream of tokens and render them to a
       * string, given a context. It also maintains a cache of templates to
       * avoid the need to parse the same template twice.
       */
      function Writer () {
        this.cache = {};
      }

          /**
       * Clears all cached templates in this writer.
       */
      Writer.prototype.clearCache = function clearCache () {
        this.cache = {};
      };

          /**
       * Parses and caches the given `template` according to the given `tags` or
       * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
       * that is generated from the parse.
       */
      Writer.prototype.parse = function parse (template, tags) {
        var cache = this.cache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var tokens = cache[cacheKey];

            if (tokens == null)
          tokens = cache[cacheKey] = parseTemplate(template, tags);

            return tokens;
      };

          /**
       * High-level method that is used to render the given `template` with
       * the given `view`.
       *
       * The optional `partials` argument may be an object that contains the
       * names and templates of partials that are used in the template. It may
       * also be a function that is used to load partial templates on the fly
       * that takes a single argument: the name of the partial.
       *
       * If the optional `tags` argument is given here it must be an array with two
       * string values: the opening and closing tags used in the template (e.g.
       * [ "" ]). The default is to mustache.tags.
       */
      Writer.prototype.render = function render (template, view, partials, tags) {
        var tokens = this.parse(template, tags);
        var context = (view instanceof Context) ? view : new Context(view);
        return this.renderTokens(tokens, context, partials, template, tags);
      };

          /**
       * Low-level method that renders the given array of `tokens` using
       * the given `context` and `partials`.
       *
       * Note: The `originalTemplate` is only ever used to extract the portion
       * of the original template that was contained in a higher-order section.
       * If the template doesn't use higher-order sections, this argument may
       * be omitted.
       */
      Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate, tags) {
        var buffer = '';

            var token, symbol, value;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          value = undefined;
          token = tokens[i];
          symbol = token[0];

              if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
          else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
          else if (symbol === '>') value = this.renderPartial(token, context, partials, tags);
          else if (symbol === '&') value = this.unescapedValue(token, context);
          else if (symbol === 'name') value = this.escapedValue(token, context);
          else if (symbol === 'text') value = this.rawValue(token);

              if (value !== undefined)
            buffer += value;
        }

            return buffer;
      };

          Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);

        function subRender (template) {
          return self.render(template, context, partials);
        }

            if (!value) return;

            if (isArray(value)) {
          for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
            buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
          }
        } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
          buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        } else if (isFunction(value)) {
          if (typeof originalTemplate !== 'string')
            throw new Error('Cannot use higher-order sections without the original template');

          value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

              if (value != null)
            buffer += value;
        } else {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }
        return buffer;
      };

          Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
        var value = context.lookup(token[1]);

        if (!value || (isArray(value) && value.length === 0))
          return this.renderTokens(token[4], context, partials, originalTemplate);
      };

          Writer.prototype.renderPartial = function renderPartial (token, context, partials, tags) {
        if (!partials) return;

            var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null)
          return this.renderTokens(this.parse(value, tags), context, partials, value);
      };

          Writer.prototype.unescapedValue = function unescapedValue (token, context) {
        var value = context.lookup(token[1]);
        if (value != null)
          return value;
      };

          Writer.prototype.escapedValue = function escapedValue (token, context) {
        var value = context.lookup(token[1]);
        if (value != null)
          return mustache.escape(value);
      };

          Writer.prototype.rawValue = function rawValue (token) {
        return token[1];
      };

          mustache.name = 'mustache.js';
      mustache.version = '3.0.1';
      mustache.tags = [ '{{', '}}' ];

      var defaultWriter = new Writer();

          /**
       * Clears all cached templates in the default writer.
       */
      mustache.clearCache = function clearCache () {
        return defaultWriter.clearCache();
      };

          /**
       * Parses and caches the given template in the default writer and returns the
       * array of tokens it contains. Doing this ahead of time avoids the need to
       * parse templates on the fly as they are rendered.
       */
      mustache.parse = function parse (template, tags) {
        return defaultWriter.parse(template, tags);
      };

          /**
       * Renders the `template` with the given `view` and `partials` using the
       * default writer. If the optional `tags` argument is given here it must be an
       * array with two string values: the opening and closing tags used in the
       * template (e.g. [ "" ]). The default is to mustache.tags.
       */
      mustache.render = function render (template, view, partials, tags) {
        if (typeof template !== 'string') {
          throw new TypeError('Invalid template! Template should be a "string" ' +
                              'but "' + typeStr(template) + '" was given as the first ' +
                              'argument for mustache#render(template, view, partials)');
        }

            return defaultWriter.render(template, view, partials, tags);
      };

      mustache.to_html = function to_html (template, view, partials, send) {

            var result = mustache.render(template, view, partials);

            if (isFunction(send)) {
          send(result);
        } else {
          return result;
        }
      };

      mustache.escape = escapeHtml;

      mustache.Scanner = Scanner;
      mustache.Context = Context;
      mustache.Writer = Writer;

          return mustache;
    }));

    (function() {
        var config = {
            enabled: true,
            iframeUrl: undefined,
            timeout: {auctionIframe: 1000, initial: 1000, slots: [1000], config: 5000},
            disableonadblock: true,
            expires: 10000,
        };
        var auctionIframe = null;
        var auctionResults = {};
        var slotStack = {
            initial: {},
            delayed: {},
            called: {}
        };
        var adblockDetected = false;
        var configTimeout = setTimeout(function() {
            self.triggerOnce('auction.end');
        },config.timeout.config);



        function auctionCommunicator(method, data, slot) {
            self.Communication.sendMessage(slot ? dom('iframe', slot.getDomNode())[0] : auctionIframe.contentWindow, method, data);
        }

            function callSlot(slot, isInitial) {
            if (slotStack.called[slot]) {
                if (Object.keys(slotStack.initial).length === 0 || isInitial) {
                    self.ad(slot);
                } else {
                    slotStack.delayed[slot] = true;
                }
            }
        }

            function reviveSlots() {
            each(slotStack.delayed, function(slot) {
                delete slotStack.delayed[slot];
                callSlot(slot);
            });
        }

            var inits = {
            disableonadblock: function(value, config) {
                if (!value) { return; }
                if (!config.enabled) { return; }
                var isBlocked = self.info.abd().isBlocked;
                if (isBlocked) {
                    self.disableAuctions();
                }
            },
            slotSets: function(value, config) {
                config.slotConfig = {};
                each(value, function(i, slotSet) {
                    if (slotSet instanceof Array) {
                        each(slotSet, function(i, slot) {
                            config.slotConfig[slot] = slotSet;
                        });
                    } else {
                        config.slotConfig[slotSet] = [slotSet];
                    }
                });
            },
            passover: function(value, config) {
                if (!value) { return; }
                value.initialSlots = config.initial;
            },
            initial: function(value, config) {
                each(value, function(i, slot) {
                    slotStack.initial[slot] = true;
                });
            },
            iframeUrl: function(value, config) {
    self.log('iframeUrl', value, config);
                if (!self.auctionsIsEnabled()) { return; }
                self.registerWaitingQueue('auction.finished');
                if (!value) { return; }
                if (auctionIframe) { return; }
                var passOverData = config.passover;
                var namespace = self.getConfig('data-attribute-namespace');
                var html = fillIn(
                    '<iframe src="{nfiDocument}" name="{data}" data-{namespace}-auction="true" frameborder="0" border="0" scrolling="no" marginwidth="0" marginheight="0" width="1" height="1" style="{css}"><\/iframe>',
                    {
                        namespace: namespace,
                        nfiDocument: Code.html(value),
                        data: Code.html(JSON.stringify(passOverData)),
                        css: 'position: fixed; top: -1000px; left: -1000px;'
                    }
                );
                doc.body.insertAdjacentHTML('afterbegin', html);
                auctionIframe = doc.body.querySelector(fillIn('[data-{namespace}-auction="true"]', {namespace: namespace}));
                self.log.level('auction', 'Auction IFrame created', html);
                if (config.timeout && config.timeout.auctionIframe) {
                    each(config.initial, function(i, slot) {
    self.log('initializing timeout', slot);
                        self.AdSlot(slot).setTimeout(config.timeout.auctionIframe, 'auctionIframe', function() {
    self.log.error('auctionIframe', 'timeout reached', this);
                            self.disableAuctions();
                            delete slotStack.initial[slot];
                            callSlot(this.id, true);
                            if (i === config.initial.length-1) { reviveSlots(); }
                        });
                    });
                }

                    self.on('ad.begin', function(evt) {
                    if (!config.enabled) { return; }
                    if (adblockDetected) { return; }
                    if (!config.slotConfig.hasOwnProperty(evt.slot.id)) { return; }
                    if (!auctionIframe) { return; }
                    if (evt.slot.hasQueuedAdHtml()) { return; }
                    if (auctionResults[evt.slot.id]) {
                        if (auctionResults[evt.slot.id] && auctionResults[evt.slot.id].expires && auctionResults[evt.slot.id].expires < +new Date()) {
                            evt.slot.removeExpiringParam(Object.keys(auctionResults[evt.slot.id].param));
                            delete auctionResults[evt.slot.id];
                        } else {
                            return;
                        }
                    }
                    evt.data.deferred = true;
                    slotStack.called[evt.slot.id] = true;
                    if (!auctionIframe.ready) {
                        if (evt.slot.isDeferred()) { return; }
                        slotStack.delayed[evt.slot.id] = true;
                        return;
                    }
                    if (evt.slot.isDeferred() !== 'auctionResult') {
                        var slots = config.slotConfig[evt.slot.id];
                        self.Communication.sendMessage(auctionIframe.contentWindow, 'getAuctionForSlots', {slots: slots});
                        each(slots, function(i, name) {
                            config.slotConfig[name] = [name]; 
                            self.AdSlot(name).setTimeout(
                                config.timeout.slots[Math.min(slots.length, config.timeout.slots.length)-1],
                                'auctionResult',
                                function() {
                                    self.log.error('auctionResult slotSets', 'timeout reached', name, this);
                                    delete slotStack.initial[name];
                                    auctionResults[name] = {};
                                    callSlot(name);
                                }
                            );
                        });
                    }
                });
                self.on('ad.finished', function(evt) {
                    if (auctionResults[evt.slot.id] && auctionResults[evt.slot.id].expires && auctionResults[evt.slot.id].expires < +new Date()) {
                        delete auctionResults[evt.slot.id];
                    }
                    delete slotStack.called[evt.slot.id];
                });
            },
        };

            self.on('adblock.detected', function(evt) {
            self.cancelAuctions();
            self.registerWaitingQueue('auction.finished');
            self.waitingComplete('auction.finished');
            self.triggerOnce('auction.end');
    self.log('blocker detected - auction.finished', evt);
        });

            self.getAuctionConfig = function(name, defaultValue) {
            if (!name) { return config; }
            if (config.hasOwnProperty(name)) { return config[name]; }
            return defaultValue;
        };
        self.setAuctionConfig = function(obj) {
            clearTimeout(configTimeout);
            if (typeof obj === 'function') {
                try {
                    obj = obj();
                } catch (e) {
                    return self.log.error('Error in function supplied for AdService.setAuctionConfig()', e, arguments, this);
                }
            }
            config = defaults(obj, config);
            each(inits, function(name, value) {
                if (typeof value !== 'function') { return; }
                value(config[name], config);
            });
            self.log.level('auction', 'Auction config set', 'New values:', obj, 'Resulting config:', config);
    self.log('setAuctionConfig ende', config);
            return self;
        };

            self.enableAuctions = function() {
            config.enabled = true;
        };
        self.disableAuctions = function() {
            self.triggerOnce('auction.end');
            config.enabled = false;
        };
        self.auctionsIsEnabled = function() {
            if (!config.enabled) { self.triggerOnce('auction.end'); }
            return config.enabled;
        };

            self.cancelAuctions = function() {
            var calledSlots = Object.keys(slotStack.called),
                initialSlots = Object.keys(slotStack.initial),
                timeoutSlots = calledSlots.concat(initialSlots.filter(function(initialSlot) {
                    return calledSlots.indexOf(initialSlot) < 0;
                }));
            each(timeoutSlots, function(i, slot) {
                self.AdSlot(slot).isIndependent = true;
                if(auctionIframe.ready) { self.AdSlot(slot).clearTimeout('auctionResult'); }
                self.AdSlot(slot).clearTimeout('auctionIframe');
                callSlot(slot, true);
            });
            slotStack.initial = slotStack.called = {};
            self.waitingComplete('auction.finished');
            self.disableAuctions();
            adblockDetected = true;
            reviveSlots();
        };
        self.auctionBlockedByAdBlock = function() {
            return adblockDetected;
        }

            self.auctionIframeReady = function() {
            if (auctionIframe.ready) { return; }
            if (adblockDetected) { return; }
            if (!self.auctionsIsEnabled()) { return self.enableAuctions(); }
            auctionIframe.ready = true;
            each(config.initial, function(i, slot) {
    self.log('initializing timeout', slot);
                self.AdSlot(slot).clearTimeout('auctionIframe');
                self.AdSlot(slot).setTimeout(config.timeout.initial, 'auctionResult', function() {
    self.log.error('auctionResult initial', 'timeout reached', slot, this);
                    self.waitingComplete('auction.finished');
                    self.triggerOnce('auction.end');
                    delete slotStack.initial[slot];
                    callSlot(slot, true);
                });
                if (i === config.initial.length-1) { reviveSlots(); }
            });
        };

            self.setAuctionResult = function(obj) {
    self.log('setAuctionResult start', extend({}, obj), extend({}, auctionResults));
            if (!auctionIframe.ready) { self.auctionIframeReady(); }
            var expires = +new Date() + config.expires;
            each(obj, function(slot, data) {
                var isInitial = !!slotStack.initial[slot];
                delete slotStack.initial[slot];
                if (!self.AdSlot(slot).clearTimeout('auctionResult')) { return; }
                auctionResults[slot] = data;
                self.AdSlot(slot).setExpiringParam({params: {prebid:'as2'}, expires: config.expires});
                self.AdSlot(slot).setExpiringParam({params: data.param, expires: config.expires});
                auctionResults[slot].expires = expires;

                    callSlot(slot, isInitial);
            });
            self.log.level('auction', 'setAuctionResult', extend({}, obj), extend({}, auctionResults));
            if (Object.keys(slotStack.initial).length === 0) {
                reviveSlots();
            }
    self.log('setAuctionResult ende', extend({}, auctionResults));
            self.waitingComplete('auction.finished');
            self.triggerOnce('auction.end');
        };

            self.applyAuction = function(type, obj) {
    self.log('applyAuction start', type, obj, arguments, this);
            self.log.level('auction', 'AdServer selected auction result to be used', this);
            var slot = self._getAdSlot(this.slot);
            slot.clearExpiringParams();
            if(!!slot.domNode.dataset.prioSlot) {
                auctionResults[slot.id] = auctionResults[self.getAuctionConfig().initial[0]];
                slot['tempId'] = self.getAuctionConfig().initial[0];
            }
            if (!auctionResults[slot.id] || !auctionResults[slot.id].type[type]) {
                self.log.level('auction', 'Empty applyAuction', slot, this);
                return;
            }
            var result = auctionResults[slot.id].type[type];
            if (obj) {
                result = extend({}, result, obj);
            }
            var setWidth = ['sitebar', 'right', 'skyright'].indexOf(this.slot.params.tagid) !== -1 ? true : false;
            switch (true) {
                case !!result.jsonAsString:
                    dom('iframe', slot.getDomNode())[0].contentWindow.postMessage(JSON.stringify(auctionResults[slot.id].json), '*');
                    break;
                case !!result.json:
                    self.Communication.sendMessage(dom('iframe', slot.getDomNode())[0].contentWindow, 'auctionResultJson', {slot: slot.id, json: result.json});
                    break;
                case !!result.html:
                    self.Communication.sendMessage(dom('iframe', slot.getDomNode())[0].contentWindow, 'auctionResultHtml', {size: {width: result.size.width, height: result.size.height}, html: result.html});
                    break;
                default:
                    break;
            }
            if (!!result.size) {
                slot.resize(setWidth ? result.size.width : undefined, result.size.height, [this.iframe]);
            }

            if (type === 'amazon') {
                slot.getDomNode().style.width = '';
            }

                self.Communication.sendMessage(auctionIframe.contentWindow, 'auctionSuccess', {slot: slot.tempId || slot.id, type: type});
            delete auctionResults[slot.id];
        };

            var viewabilityStack = {};

            self.applyViewability = function() {
            var slot = self._getAdSlot(this.slot);
            var iframe = dom('iframe', slot.getDomNode())[0];
            var message = {
                'event': 'parentFrameGeometryChange',
                'scrollY': window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 1,
                'offsetTop': iframe.offsetTop,
                'windowHeight': window.innerHeight
            };
            if (AdService.AdSlot(slot).getVisibleFraction() > 0) {
                iframe.contentWindow.postMessage(message,'*');
            }

                if(viewabilityStack[slot.id]) { return; }
            viewabilityStack[slot.id] = true;

                document.addEventListener('scroll', function(e) {
                if (AdService.AdSlot(slot).getVisibleFraction() > 0) {
                    var message = {
                        'event': 'parentFrameGeometryChange',
                        'scrollY': window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 1,
                        'offsetTop': iframe.offsetTop,
                        'windowHeight': window.innerHeight
                    };
                    iframe.contentWindow.postMessage(message,'*');
                }
            });
        };

        self.adInserted = function(data) {
            self.log.level('auction', 'Ad has been inserted into IFrame', data, this);
            self._ad_finished(this.slot, data);
        };
    }).apply(self);


    (function() {
        var defaultAdServer;
        /**
         * sets the default AdServer.
         * @function setDefaultAdServer
         * @param {string} adserver - name of the AdServer.
         * @example AdService.setDefaultAdServer('adition-asp');
         */
        self.setDefaultAdServer = function(adserver) {
            defaultAdServer = self.AdServer(adserver);
            return self;
        };
        /**
         * returns the  default AdServer.
         * @function getDefaultAdServer
         * @example AdService.getDefaultAdServer();
         */
        self.getDefaultAdServer = function() {
            return defaultAdServer;
        };
        /**
         * enables an AdServer.
         * @function enableServer
         * @param {object|string} server - the adserver to enable
         * @example AdService.enableServer('adition-asp');
         */
        self.enableServer = function(server) {
            server = server ? self.AdServer(server) : self._getCurrentAdSlot().getAdServer();
            server.enable();
            return self;
        };
        /**
         * disables an AdServer.
         * @function disableServer
         * @param {object|string} server - the adserver to disable
         * @example AdService.disableServer('adition-asp');
         */
        self.disableServer = function(server) {
            server = server ? self.AdServer(server) : self._getCurrentAdSlot().getAdServer();
            server.disable();
            return self;
        };
        self.newPageContext = function() {
            each(self.AdServer.getList(), function(i, server) {
                server.newPageContext();
            });
            return self;
        };
    }).apply(self);

    (function() {
        /**
         * Represents a hook.
         * @function setAdHook
         * @param {string} type - name of the hook.
         * @param {function} func - function to execute.
         */
        self.setAdHook = function(type, func) {
            self.on('adhook.' + type, func);
            return self;
        };
        /**
         * createAd triggers events that can be catched by an AdHook (see. setAdHook).
         * @function createAd
         * @param {object} object - name of the object.
         * @example AdService.createAd({
            'type': 'sitebar', 
            'components': {
                'sitebar': {
                    'html': '<div class="container">Hello World</div>'
                }
            }
        });
         */
        self.createAd = function(obj) {
            obj = obj || {};
            var type = obj.type || '_unknown',
                slot = self._getCurrentAdSlot(),
                meta = slot ? slot.getMetaData()[0] : {},
            _;
            self._triggerFlat('adhook._global:prepare', obj, meta, slot);
            self._triggerFlat(self.hasEventHandler('adhook.' + type + ':prepare') ? ('adhook.' + type + ':prepare') : ('adhook._default:prepare'), obj, meta, slot);
            self._triggerFlat('adhook._global', obj, meta, slot);
            self._triggerFlat('adhook._global:after', obj, meta, slot);
            self._triggerFlat(self.hasEventHandler('adhook.' + type) ? ('adhook.' + type) : ('adhook._default'), obj, meta, slot);
            self._triggerFlat(self.hasEventHandler('adhook.' + type + ':after') ? ('adhook.' + type + ':after') : ('adhook._default:after'), obj, meta, slot);
            self._triggerFlat('adhook.:finished', obj, meta, slot);
        };

                /**
         * adds a property to AdService.
         * @function setAdProperty
         * @param {string} property - name of the property.
         * @example - AdService.setAdProperty('sticky').
         */
        var adPropertyFunctions = {
            'resize': {
                post: function(property, slot, data) {
                    slot.setConfig('auto-set-iframe-size', false);
                }
            },
        _:0};
        self.setAdProperty = function(property) {
            if (!property) {
                self.log.error('setAdProperty', 'No property given');
                return self;
            }
            var slot = this instanceof self.AdSlot ? this : self._getCurrentAdSlot(),
                data = {
                    arguments: Array.prototype.slice.call(arguments, 1),
                _:0},
            _;
            data[property] = arguments[1];
            if (adPropertyFunctions.hasOwnProperty(property) && adPropertyFunctions[property].pre) {
                adPropertyFunctions[property].pre(property, slot, data);
            }
            if (data.stopAction) {
                self.trigger('ad.property.' + property + '.stopped', slot, data);
                return self;
            }
            self.trigger('ad.property.' + property, slot, data);
            if (adPropertyFunctions.hasOwnProperty(property) && adPropertyFunctions[property].post) {
                adPropertyFunctions[property].post(property, slot, data);
            }
            return self;
        };

                /**
         * requests ad expanding.
         * @function expandAd
         * @param {object} data - contains the new width and height.
         * @example AdService.expandAd({width: "300px", height: "600px"});
         * @return data.done: 
         *   1. true  
         *   2. false  
         *   3. object (suggestion)
         */
        self.expandAd = function(data) {
            var slot = self._getCurrentAdSlot();
            return self._from_iframe_expandAd.apply({
                isPostMessage: false,
                message: null,
                window: win,
                iframe: (slot.getDomNode() || {getElementsByTagName:function() { return []; }}).getElementsByTagName('iframe')[0],
                slot: slot,
                event: null
            }, makeArray(arguments, true));
        };
        self._from_iframe_expandAd = function(data) {
            data = self.Helper.defaults(data, {width:this.iframe.style.width, height: this.iframe.style.height});
            var originalSize = {};

                        if (this.iframe.getAttribute('data-_ad-expandad-width')) {
                originalSize = {
                    width: this.iframe.getAttribute('data-_ad-expandad-width'),
                    height: this.iframe.getAttribute('data-_ad-expandad-height')
                };
            } else {
                originalSize = {
                    width: this.iframe.offsetWidth,
                    height: this.iframe.offsetHeight
                };
            }

                        data.done = false;
            data.isExpandAllowed = true;

                        self.trigger('addemand.expand', self._getCurrentAdSlot(), data);

                        if (data.isExpandAllowed && !data.done) {
                this.iframe.setAttribute('data-_ad-expandad-width', originalSize.width);
                this.iframe.setAttribute('data-_ad-expandad-height', originalSize.height);
                this.iframe.style.width = getLengthValue(data.width);
                this.iframe.style.height = getLengthValue(data.height);
                data.done = true;
            }
            if (!data.isExpandAllowed) {
                data.done = false;
            }
            self.Communication.answerMessage(data, this.iframe.contentWindow, 'expandAd', data);
        };

            /**
         * requests ad contracting.
         * @function contractAd
         * @example AdService.contractAd();
         * @return data.done: 
         *   1. true  (contract is allowed)
         *   2. false  (contract is not allowed)
         */
        self._from_iframe_contractAd = function(data) {
            data.done = false;
            data.isContractAllowed = true;
            self.trigger('addemand.contract', self._getCurrentAdSlot(), data);

                        if (data.isContractAllowed && !data.done) {
                if (this.iframe.getAttribute('data-_ad-expandad-width')) {
                    this.iframe.style.width = this.iframe.getAttribute('data-_ad-expandad-width')+'px' || '';
                    this.iframe.style.height = this.iframe.getAttribute('data-_ad-expandad-height')+'px' || '';
                    this.iframe.removeAttribute('data-_ad-expandad-width');
                    this.iframe.removeAttribute('data-_ad-expandad-height');
                    data.done = true;
                }
            }
            self.Communication.answerMessage(data, this.iframe.contentWindow, 'contractAd', data);
        };

            /**
         * requests ad closing.
         * @function closeAd
         * @example AdService.contractAd();
         * @return data.done: 
         *   1. true  (the slot containing the ad is killed)
         *   2. false  (close is not allowed)
         */
        self._from_iframe_closeAd = function(data) {
            data.done = false;
            self.trigger('addemand.close', self._getCurrentAdSlot(), data);
            if (data.isCloseAllowed) {
                self.killSlot(this.slot);
            } else {
                self.Communication.answerMessage(data, this.iframe.contentWindow, 'closeAd', data);
            }
        };

            /**
         * requests layer opening.
         * @function openLayer
         * @example AdService.openLayer();
         * @return data.done: 
         *   1. true  (openLayer allowed)
         *   2. false  (openLayer not allowed)
         */
        self._from_iframe_openLayer = function(data) {
            data.done = false;
            self.trigger('addemand.openlayer', self._getCurrentAdSlot(), data);
            self.Communication.answerMessage(data, this.iframe.contentWindow, 'openLayer', data);
        };

                /**
         * requests layer closing.
         * @function closeLayer
         * @example AdService.closeLayer();
         * @return data.done: 
         *   1. true  (closeLayer allowed)
         *   2. false  (closeLayer not allowed)
         */
        self._from_iframe_closeLayer = function(data) {
            data.done = false;
            self.trigger('addemand.closelayer', self._getCurrentAdSlot(), data);
            self.Communication.answerMessage(data, this.iframe.contentWindow, 'closeLayer', data);
        };

            }).apply(self);

    (function() {

            var exclusionRuleSet = {};

            /**
         * This method defines a set of exlclusion rules.
         * @function setExclusionRuleSet
         * @param {object} obj - the object containing the rulesets.
         * @example AdService.setExclusionRuleSet({
            '_prio': 'top',
            'test': {
                'rules': [
                    {action:'setParam', slot:'*', name:'foo', value:'bar'},
                    {action:'setParam', slot:'rectangle', name:'foo', value:'bar'},
                    {action:'disableSlot', slot:'sky_right'},
                    {action:'setParam', slot:/^lazyload_.+/, name:'foo', value:'bar'},
                    {action:'useIframeCss', css:'foo'}, // the value of the css property defaults to the current adform; a slot can be named
                0],
            _:0}
         });
         */

            self.setExclusionRuleSet = function(obj) {
    /**
     * @TODO  - kein simples extend(), sondern separat durchlaufen um zu erweitern und nicht zu überschreiben
     *        - Anforderungen definieren und Funktion neuschreiben
     */
            exclusionRuleSet = obj;
            each(obj, function(adform, properties) {
                if (adform === '_prio') { return; }
                self.on(
                    'ad.finished',
                    (function(adform) { return function(evt) {
                        var slot = evt.slot || self._getCurrentAdSlot();
                        return adform === slot.getAdServer().getAdFormByMetaData(slot.getMetaData()[0], true);
                    } })(adform),
                    generateRuleRunnerFunction(adform, properties)
                );
            });
            if (obj._prio) {
                deferAdRequests = true;
                self.registerWaitingQueue('prioad');
                startPrioMechanism(obj._prio);
            }
            return self;
        };
        /**
         * retrieves all exclusionruleset.
         * @function getExclusionRuleSet
         */
        self.getExclusionRuleSet = function() {
            return exclusionRuleSet;
        };

            var deferAdRequests = false,
            deferredAdSlots = [],
        _;
        function startPrioMechanism(prio) {
            self.on('ad.begin', function(evt) {
                if (!deferAdRequests) { return; }
                if (evt.slot.id !== prio) {
                    evt.data.deferred = true;
                    if (deferredAdSlots.indexOf(evt.slot) >= 0) {
                        return;
                    }
                    deferredAdSlots.push(evt.slot);
                    self.waitFor('prioad', function() {
                        self.ad(evt.slot);
                    });
                }
            });
            self.on('ad.finished', prio, function(evt) {
                deferAdRequests = false;
                self.trigger('ad.priofinished', evt.slot);
                self.waitingComplete('prioad');
                deferredAdSlots = [];
            });
        }

            self.getExclusionRules = function(adform, slot) {
            for (var i in exclusionRuleSet) {
                if (!exclusionRuleSet.hasOwnProperty(i)) { continue; }
                if (adform === '_prio') { continue; }
                var properties = exclusionRuleSet[i];
                if (!(properties instanceof Array)) { properties = [properties]; }
                for (var j=0, k=properties.length; j<k; j++) {
                    var data = properties[j];
                    if (!checkConditions(data.conditions, {slot:slot})) { continue; }
                    return data.rules || [];
                }
            }
            return [];
        };
        function checkConditions(conditions, evt) {
            if (conditions && conditions.length) {
                for (var i=0, l=conditions.length; i<l; i++) {
                    var cond = conditions[i];
                    if (!cond) { continue; }
                    if (!checkCondition(cond, evt)) { return false; }
                };
            }
            return true;
        }
        function checkCondition(cond, evt) {
            switch (cond.check) {
                case 'prio':
                    return evt.slot && evt.slot.id === self.getExclusionRuleSet()._prio;
                case 'slot':
                    return evt.slot && evt.slot.id === cond.slot;
                case 'param':
                    return evt.slot && evt.slot.getParam(cond.name) === cond.value;
                default:
                    return false;
            }
        }

            function generateRuleRunnerFunction(adform, properties) {
            return function(evt) {
                if (!(properties instanceof Array)) { properties = [properties]; }
                for (var i=0, l=properties.length; i<l; i++) {
                    var data = properties[i];
                    if (!checkConditions(data.conditions, evt)) { continue; }
                    each(data.rules, function(i, rule) {
                        if (rule) { executeRule(adform, rule, evt); }
                    });
                    return;
                }
            }
        }
        function executeRule(adform, rule, evt) {
            switch (rule.action) {
                case 'disableSlot':
                    return self.disableSlot(rule.slot);
                case 'enableSlot':
                    return self.enableSlot(rule.slot);
                case 'setParam':
                    if (!rule.slot || rule.slot==='*') {
                        return self.setParam(rule.name, rule.value);
                    }
                    return self.setSlotParam(rule.slot, rule.name, rule.value);
                case 'moveAdToSlot':
                    self._currentAdSlot = self._getAdSlot(evt.slot);
                    return self.moveAdToSlot(rule.slot);
                case 'moveAdToDom':
                    self.log.nyi('exclusionRule', rule.action, rule);
                    return null;
                case 'applyCreateAd':
                    if (slotCreateAd[evt.slot.id]) {
                        self.trigger('exclusionrule.applycreatead.prematurecreatead', evt.slot, {adform:adform});
                    } else {
                        var nodes = filter(
                            makeArray(evt.slot.getDomNode().childNodes),
                            function(i, node) { return node.nodeType === doc.ELEMENT_NODE; }
                        );
                        self.createAd({type:adform, origin:'exclusionrule', rule:rule, domlist:nodes});
                    }
                    return true;
                case 'refresh':
                    var slotSet = rule.slot.split(/ +/);
                    return self.refresh(slotSet);
                case 'useIframeCss':
                    return self.useIframeCss(rule.css || adform, rule.slot || evt.slot);
                case 'setAdProperty':
                    return self.setAdProperty.apply(self.AdSlot(rule.slot), [rule.property].concat(rule.args));
                case 'log':
                    self.log[rule.type || 'debug']('exclusionRule log', adform, rule.text, rule, evt);
                    return null;
                case 'clearOnetimeParams':
                    return self.AdSlot(rule.slot).clearOnetimeParams();
                default:
                    self.log.warn('exclusionRule unknown:', rule.action, rule);
                    return undefined;
            }
        }

            var slotCreateAd = {};
        self.on('ad.request', function(evt) {
            delete slotCreateAd[evt.slot.id];
        });
        self.on('adhook:finished', function(obj, meta, slot) {
            if (slot && slot instanceof self.AdSlot) {
                slotCreateAd[slot.id] = true;
            }
        });

        }).apply(self);

    (function() {
        self.disableSlot = function(slot) {
            self._getAdSlot(slot).disable();
            return self;
        };
        self.enableSlot = function(slot) {
            self._getAdSlot(slot).enable();
            return self;
        };

            function changeEnabledForAllSlots(enabled) {
            self.setConfig('slot-enabled-default', enabled);
            each(self.AdSlot.getList(), function(id, slot) {
                enabled ? slot.enable() : slot.disable();
            });
        }
        self.disableAllSlots = function() {
            changeEnabledForAllSlots(false);
        };
        self.enableAllSlots = function() {
            changeEnabledForAllSlots(true);
        };

        self.getUrlForSlot = function(slot) {
            return self.AdSlot(slot).getUrl.apply(self.AdSlot(slot), Array.prototype.slice.call(arguments, 1));
        };

        self.initSlots = function(slots) {
            each(slots, function(slot, paramsAndConfig) {
                var params = paramsAndConfig.params,
                    config = paramsAndConfig.config || {},
                _;
                slot = self.AdSlot(slot);
                each(params, function(key, value) {
                    slot.setParam(key, value);
                });
                each(config, function(key, value) {
                    slot.setConfig(key, value);
                });
            });
        };
        self.getSlotParam = function(slot, key) {
            if (!(slot instanceof Array)) {
                return self._getAdSlot(slot).getParam(key);
            }
            var result = {};
            each(slot, function(i, slot) {
                result[slot] = self.getSlotParam(slot, key);
            });
            return result;
        };
        self.setSlotParam = function(slot, key, value) {
            if (!(slot instanceof Array)) { slot = [slot]; }
            each(slot, function(i, slot) {
                self._getAdSlot(slot).setParam(key, value);
            });
            return self;
        };
        self.setDirectSlotParam = function(slot, key, value) {
            if (!(slot instanceof Array)) { slot = [slot]; }
            each(slot, function(i, slot) {
                self._getAdSlot(slot).setDirectParam(key, value);
            });
            return self;
        };
        self.getSlotConfig = function(slot, key) {
            return self._getAdSlot(slot).getConfig(key);
        };
        self.setSlotConfig = function(slot, key, value) {
            return self._getAdSlot(slot).setConfig(key, value);
        };

        self.emptySlot = function(slot) {
            self._getAdSlot(slot).empty();
            return self;
        };
        self.killSlot = function(slot) {
            self._getAdSlot(slot).kill();
            return self;
        };
        self.hideSlot = function(slot, method) {
            self._getAdSlot(slot).hide(method);
            return self;
        };
        self.showSlot = function(slot, method) {
            self._getAdSlot(slot).show(method);
            return self;
        };
        self.modifySlot = function(slot, action, func, toggleFunc) {
            self._getAdSlot(slot).modify(action, func, toggleFunc);
            return self;
        };

        self.createSlot = function(slotName, target, attr, adServiceData) {
            var dom = self.createSlotDomNode(slotName, attr, adServiceData);
            if (typeof target === 'string') {
                target = doc.querySelectorAll(target)[0];
            }
            try {
                target.appendChild(dom);
                self.ad(slotName);
            } catch (e) {
                self.log.error('Error in target supplied for AdService.createSlot()', e, arguments, this);
            }
            return self;
        };

        self._getAdSlot = function(slot) {
            if (slot instanceof self.AdSlot) {
                return slot;
            }
            return self.AdSlot(slot);
        };

        var currentAdSlot = null;
        self._getCurrentAdSlot = function() {
            if (this._currentAdSlot) { self._setCurrentAdSlot(this._currentAdSlot); }
            return currentAdSlot;
        };
        self._setCurrentAdSlot = function(slot) {
            currentAdSlot = slot;
        };

        self._currentPositionInTarget = function(slot) {
            if (doc.readyState === 'loading') {
                var target = slot.getDomNode(),
                    id = self.getConfig('data-attribute-namespace')+'-cursor';
                doc.write('<div id="'+id+'"></div>');
                var cursor = doc.getElementById(id);
                var cursorParentIsTarget = cursor.parentElement === target;
                cursor.parentNode.removeChild(cursor);
                return cursorParentIsTarget;
            }
            return false;
        };

        }).apply(self);

    (function() {
        var checkForVisibility = {},
            sandboxAttributes = {
                'allow-forms': true,
                'allow-popups': true,
                'allow-popups-to-escape-sandbox': true,
                'allow-same-origin': true,
                'allow-scripts': true,
            },
            __debug = false,
        _;

            self._getRecommendedRequestType = function(slot) {
            if (self.getConfig('request-async')) {
                return Const.REQUEST_TYPE.ASYNC;
            }
            if (doc.readyState !== 'complete' && (slot.config.requestType||'').toUpperCase() !== Const.REQUEST_TYPE.ASYNC && self._currentPositionInTarget(slot)) {
                return Const.REQUEST_TYPE.SYNC;
            } else {
                return Const.REQUEST_TYPE.ASYNC;
            }
        };

        self._getRequestMethod = function(slot) {
            var requestType = self._getRecommendedRequestType(slot);
            if (requestType === Const.REQUEST_TYPE.SYNC) {
                return Const.REQUEST_METHOD.SCRIPT_SRC;
            } else {
                if (slot.config.secure===true || slot.getAdServer().getConfig().secure || self.getConfig().secure) {
                    return Const.REQUEST_METHOD.NONFRIENDLY_IFRAME;
                } else {
                    return Const.REQUEST_METHOD.FRIENDLY_IFRAME;
                }
            }
        };

            /**
         * requests an Ad
         * @function ad
         * @param {slot} slot - Slotname (can be a string).
         * @example AdService.ad('rectangle')
         */
        self.ad = function(slot, isRefresh) {
            return self._runOutsourceable('ad', self, [slot, isRefresh], self._getAdSlot(slot).getAdServer());
        };
        self._global.ad = function(slot, isRefresh) {
            slot = self._getAdSlot(slot);
            var data = {
                slot: slot,
                target: slot.getTarget(),
                deferred: false,
                isRefresh: !!isRefresh,
            _:0};
            if (!slot.isEnabled()) {
                data.cancelReason = 'slot.disabled';
                self.trigger('ad.cancel', slot, data);
                return self;
            }
            if (!slot.getAdServer().isEnabled()) {
                data.cancelReason = 'server.disabled';
                self.trigger('ad.cancel', slot, data);
                return self;
            }
            var checkEnabled = slot.getConfig('checkEnabled', slot.getAdServer().getConfig('checkEnabled', self.getConfig('checkEnabled', true)));
            if (typeof checkEnabled === 'function') {
                try {
                    checkEnabled = checkEnabled(slot, data);
                } catch (e) {
                    self.log.error('Error in function supplied for AdService.AdSlot('+slot.id+').setConfig(\'checkEnabled\', func)', e, arguments, data, this);
                }
            }
            if (!checkEnabled) {
                data.cancelReason = 'checked.disabled';
                self.trigger('ad.cancel', slot, data);
                return self;
            }
            if (slot.id !== self.getExclusionRuleSet()._prio) {
                var shouldBeVisible = (self.getConfig('request-ad-only-if-visible') && slot.getConfig('request-ad-only-if-visible', true)) || slot.getConfig('request-ad-only-if-visible');
                if (shouldBeVisible && !slot.isVisible(data.isRefresh)) {
                    checkForVisibility[slot.id] = {slot:slot, data:data};
                    self.trigger('ad.notvisible', slot, data);
                    self.log.level('adreq', '[AdService.ad]', 'slot', slot.id, 'notVisible');
                    return self;
                }
                self.log.level('adreq', '[AdService.ad]', 'slot', slot.id, 'visible');
            }
            self.trigger('ad.begin', slot, data);
            if (data.deferred && !slot.isIndependent) {
                self.trigger('ad.deferred', slot, data);
                return self;
            }

            if (typeof data.target !== 'undefined') {
                var requestMethod = self._getRequestMethod(slot);
                slot.setConfig('requestMethod', requestMethod);
                data.requestMethod = requestMethod;
                data.url = slot.getUrl(requestMethod);
                self.trigger('ad.urlReady', slot, data);
                slot.clearOnetimeParams();
                slot.clearMetaData();
                switch (requestMethod) {
                    case Const.REQUEST_METHOD.SCRIPT_SRC:
                        self._request_scriptSrc(slot, data);
                        break;
                    case Const.REQUEST_METHOD.AJAX:
                        self._request_ajax(slot, data);
                        break;
                    case Const.REQUEST_METHOD.NONFRIENDLY_IFRAME:
                        self._request_iframeNonfriendly(slot, data);
                        break;
                    case Const.REQUEST_METHOD.FRIENDLY_IFRAME:
                        self._request_iframeFriendly(slot, data);
                        break;
                }

            } else {
                if (doc.readyState === 'loading') {
                    self.log.remind('AdService.ad()', 'no target, not yet document.ready', slot, data);
                } else {
                    self.log.remind('AdService.ad()', 'no target, document.ready', slot, data);
                }
            }

                self.trigger('ad.end', slot, data);
            return self;
        };

        self.getAdUrl = function(slot) {
            slot = self._getAdSlot(slot);
            return slot.getCurrentUrl();
        };

            self.cleanup = function() { 
            var slot = self._getCurrentAdSlot();
            if (!slot) { return; }
            return self._ad_finished(slot);
        };

            self._ad_finished = function(slot, data) {
            slot = self._getAdSlot(slot);
            var meta = slot.getMetaData();
            if (meta[0]) {
                var events = slot.getAdServer().getEventsByMetaData(meta[0]);
                each(events, function(name, value) {
                    if (name === '_') { return; }
                    self.trigger('ad.' + name + ':' + value, slot);
                });
            }
            self.trigger('ad.finished', slot, data);
            if (slot.isEmpty()) {
                self.trigger('ad.empty', slot, data);
            }
            return self;
        };

            self._from_iframe_adFinished = function(data) { 
            return self._ad_finished(data.slot, data);
        };
        self._from_iframe_effectiveAdSize = function(data) { 
            if (this.slot.getConfig('auto-set-iframe-size') === false) { return; }
            if (!self.getConfig('auto-set-iframe-size')) { return; }
            if (this.slot.fixedSize.type === 'pagecontrol') { return; }
            if (this.slot.fixedSize.type === 'fixed') {
                data.width = this.slot.fixedSize.width;
                data.height = this.slot.fixedSize.height;
            }
            this.iframe.style.width = data.width + 'px';
            this.iframe.style.height = data.height + 'px';
        };
        self._from_iframe_setAdSize = function(data) {
            var width  = ((+data.width)+''===data.width+'') ? data.width + 'px' : data.width,
                height = ((+data.height)+''===data.height+'') ? data.height + 'px' : data.height;
            this.slot.domNode.style.width  = this.iframe.style.width  = width;
            this.slot.domNode.style.height = this.iframe.style.height = height;
        };
        self._from_iframe_importMetaData = function(data) {
            this.slot.getAdServer().importMetaData(this);
        };

            self._request_scriptSrc = function(slot, data) {
            self.trigger('ad.request', slot, data);
            self._setCurrentAdSlot(slot);
            if (slot.hasQueuedAdHtml()) {
                doc.write(fillIn('<script src="{url}"></script>', {url: Code.html(data.url)}));
            } else {
                doc.write(slot.getQueuedAdHtml());
            }
            self.trigger('ad.requested', slot, data);
            return true;
        };

            self._request_ajax = function(slot, data) {
            self.trigger('ad.request', slot, data);
            var ajax = new self.Ajax(data.url, {
                on: {
                    success: function() {
                        return self._ad_finished(slot, data);
                    },
                    error: function() {
                    },
                _:0},
            _:0});
            self.trigger('ad.requested', slot, data);

                return true;
        };

            self._request_iframeNonfriendly = function(slot, data) {
            self.trigger('ad.request', slot, data);
            var passOverData = {
                slot: slot.id,
                server: slot.getAdServer().id,
                connector: self.getConfig('adservice-iframe-script-url'),
            };
            if (slot.hasQueuedAdHtml()) {
                passOverData.css = self.getIframeCssFromExclusionRules(slot.getNextQueuedAdType(), slot);
                passOverData.html = slot.getQueuedAdHtml();
            } else {
                passOverData.url = data.url;
            }
            var html = fillIn(
                '<iframe src="{nfiDocument}" name="{data}" data-{namespace}-slot="{slot}" frameborder="0" border="0" scrolling="no" marginwidth="0" marginheight="0"{sandbox} {size}><\/iframe>',
                {
                    namespace: self.getConfig('data-attribute-namespace'),
                    nfiDocument: Code.html(data.slot.getConfig('nonfriendlyiframe-document') || data.slot.getAdServer().getConfig('nonfriendlyiframe-document') || self.getConfig('nonfriendlyiframe-document')),
                    data: Code.html(JSON.stringify(passOverData)),
                    slot: Code.html(slot.id),
                    sandbox: slot.getSandboxAttribute(slot.getSandboxAttributes()),
                    size: slot.fixedSize.type === 'pagecontrol'
                        ? ''
                        : fillIn(
                            'width="{width}" height="{height}"',
                            {
                                width: slot.fixedSize.type === 'fixed' ? slot.fixedSize.width : '100%',
                                height: slot.fixedSize.type === 'fixed' ? slot.fixedSize.height : '100%'
                            }
                        )
                }
            );
            data.target.insertAdjacentHTML('beforeend', html);
            self.trigger('ad.requested', slot, data);
            return true;
        };
        self._from_iframe_nonFriendlyIframeError = function() {
            self.log.warn('NFI', 'error in iframe', arguments);
        };

            self.setSandboxAttributes = function(attr) {
            if (attr === false) {
                sandboxAttributes = {};
                return self;
            }
            sandboxAttributes = extend(sandboxAttributes, attr);
            return self;
        };

            self.getSandboxAttributes = function() {
            return sandboxAttributes;
        };

            self._request_iframeFriendly = function(slot, data) {
            if (__debug) {
                var debugContainerSize = true;
                self.log.setLevel('friendlyiframe', true);
            }

                var type;
            if (slot.hasQueuedAdHtml()) {
                type = slot.getNextQueuedAdType();
                data.html = slot.getQueuedAdHtml();
            } else {
                data.html = '<script id="external-script" src="' + Code.html(data.url) + '" onload="window.setTimeout(checkRunner, 100);" onerror="checkRunner();"><\/script>\n';
            }

                self.buildFriendlyIframe(data.target, data, type);





        };

        self.__debug_showContainerSize = function(iframeDocument) {
            var root = iframeDocument.createElement('div');
            root.innerHTML = ''
                + '<table>'
                + '<thead>'
                + '<tr><th rowspan="2"></th><th colspan="3">scroll</th><th colspan="3">offset</th><th colspan="3">client</th></tr>'
                + '<tr><th>html</th><th>body</th><th>div</th><th>html</th><th>body</th><th>div</th><th>html</th><th>body</th><th>div</th></tr>'
                + '</thead>'
                + '<tbody>'
                + '<tr>'
                + '<th>width</th>'
                + '<td>'+iframeDocument.documentElement.scrollWidth+'</td><td>'+iframeDocument.body.scrollWidth+'</td><td>'+iframeDocument.body.firstChild.scrollWidth+'</td>'
                + '<td>'+iframeDocument.documentElement.offsetWidth+'</td><td>'+iframeDocument.body.offsetWidth+'</td><td>'+iframeDocument.body.firstChild.offsetWidth+'</td>'
                + '<td>'+iframeDocument.documentElement.clientWidth+'</td><td>'+iframeDocument.body.clientWidth+'</td><td>'+iframeDocument.body.firstChild.clientWidth+'</td>'
                + '</tr>'
                + '<tr>'
                + '<th>height</th>'
                + '<td>'+iframeDocument.documentElement.scrollHeight+'</td><td>'+iframeDocument.body.scrollHeight+'</td><td>'+iframeDocument.body.firstChild.scrollHeight+'</td>'
                + '<td>'+iframeDocument.documentElement.offsetHeight+'</td><td>'+iframeDocument.body.offsetHeight+'</td><td>'+iframeDocument.body.firstChild.offsetHeight+'</td>'
                + '<td>'+iframeDocument.documentElement.clientHeight+'</td><td>'+iframeDocument.body.clientHeight+'</td><td>'+iframeDocument.body.firstChild.clientHeight+'</td>'
                + '</tr>'
                + '</tbody>'
                + '</table>'
            ;
            iframeDocument.body.insertBefore(root, iframeDocument.body.firstChild);
        };

            self.on('page.positionchange', function() {
            each(checkForVisibility, function(id, info) {
                if (info.slot.isVisible()) {
                    delete checkForVisibility[id];
                    self.ad(id, info.data.isRefresh);
                }
            });
        });

        }).apply(self);
    (function() {
        var intervalSlots = {};
        /**
         * refreshes an Ad on a set of slots.
         * @function refresh
         * @param {array} [slots] - a set of slots. If no arguments are defined all slots will be refreshed. Please note that refreshing a slot will cause tracking it twice!.
         * @example AdService.refresh(['right', 'ambient']);
         * @example AdService.refresh('right', 'ambient');
         * @example AdService.refresh(); // this will refresh all available slots.
         */
        self.refresh = function() {
            return self._runOutsourceable('refresh', self, arguments, self.getDefaultAdServer());
        };
        self._global.refresh = function() {
            var slots = arguments.length ? (arguments[0] instanceof Array ? arguments[0] : arguments) : self.AdSlot.getList();
            each(slots, function(index, slot) {
                self.refreshSlot(slot);
            });
            return self;
        };

            self._from_iframe_refresh = function() {
            self.refresh(this.slot);
        };

            /**
         * refreshes an Ad on a specific slot.
         * @function refresh
         * @param {slot} slot - a slot.
         * @example AdService.refresh('right');
         */
        self.refreshSlot = function(slot) {
            slot = self._getAdSlot(slot);
            if (!slot.getConfig('refreshDisabled', false) && (!slot.getConfig('refreshOnlyIfVisible', false) || slot.isVisible()) && slot.getAdServer().getConfig('supportRefresh', false)) {
                slot.setConfig('auto-set-iframe-size', self.getConfig('auto-set-iframe-size'));
                slot.empty();
                var metaData = slot.getMetaData();
                if (metaData && metaData[0] && metaData[0].bannerid) {
                    slot.setOnetimeParam('refreshbanner', metaData[0].bannerid);
                }
                self.ad(slot, true);
            } else {
                self.trigger('ad.norefresh', slot);
            }
            return self;
        };

            /**
         * disables refreshing of slots.
         * @function disableRefresh
         * @param {array} [slots] - a set of slots. If no arguments are defined all slots will be disabled to be refreshed.
         * @example AdService.disableRefresh(['right', 'ambient']);
         * @example AdService.disableRefresh(); // this will disable refreshing all available slots.
         */
        self.disableRefresh = function() {
            var slots = arguments.length ? arguments : self.AdSlot.getList();
            each(slots, function(index, slot) {
                slot = self._getAdSlot(slot);
                slot.setConfig('refreshDisabled', true);
            });
            return self;
        };

            /**
         * enables refreshing of slots.
         * @function enableRefresh
         * @param {array} [slots] - a set of slots. If no arguments are defined all slots will be enabled to be refreshed.
         * @example AdService.enableRefresh(['right', 'ambient']);
         * @example AdService.enableRefresh(); // this will enable refreshing all available slots.
         */
        self.enableRefresh = function() {
            var slots = arguments.length ? arguments : self.AdSlot.getList();
            each(slots, function(index, slot) {
                slot = self._getAdSlot(slot);
                slot.setConfig('refreshDisabled', false);
            });
            return self;
        };

        /**
        * refreshes slots in given interval. existing intervals on slot will be cleared and newly instantiated
        * @function setRefreshInterval
        * @param {object} {slot: interval} - a set of slots with its according interval in seconds.
        * @example AdService.setRefreshInterval({'right':5, 'ambient':20});
        */
        self.setRefreshInterval = function(config) {
          if (!config) { return; }

          each(config, function(slot, timer) {
              if(!!intervalSlots[slot]) {
                clearInterval(intervalSlots[slot]);
              }
              intervalSlots[slot] = setInterval(function() {
                self.refresh(slot);
              }, timer * 1000);
          });
          return self;
        }
    }).apply(self);

    (function() {
        var iframeCss = {};

                self.setIframeCss = function(data) {
            iframeCss = extend(iframeCss, data);
            return self;
        };

                self.getIframeCss = function(type) {
            if (type) { return iframeCss[type]; }
            else      { return iframeCss; }
        };

                self.getIframeCssFromExclusionRules = function(adform, slot) {
            var rules = self.getExclusionRules(adform, slot);
            for (var i=0, l=rules.length; i<l; i++) {
                if (rules[i].action === 'useIframeCss') {
                    return (iframeCss[rules[i].css || adform] || '').css;
                }
            }
        };
        self.useIframeCss = function(type, slot) {
            var css = (iframeCss[type] || '').css;
            if (!slot) {
                return css || '';
            }
            slot = self._getAdSlot(slot);
            var target = dom('iframe', slot.getDomNode())[0];
            if (target) {
                var data = {css: css};
                self.trigger('ad.useiframecss', slot, data);
                self.Communication.sendMessage(target, 'useIframeCss', data);
            } else {
                self.log.warn('IFrame CSS not applied: slot does not (yet) have an IFrame content.', 'type:', type, 'slot:', slot);
            }
            return self;
        };

                self.setIframeCss({'default': {css: ''}});
    }).apply(self);

    (function() {
        var templates = {},
            mustacheTemplateUrl,
        _;
        self.setTemplateEngine = function(engine, templateUrl) {
            if (engine && engine !== 'mustache') {
                self.log.error('AdService.setTemplateEngine(engine, templateUrl) MUST be called with \'mustache\' as the engine.');
                self.log.error('Other engines might be implemented later.');
                throw new AdServiceError('WrongTemplateEngine', 'api/render.js');
            }
            return self.setTemplateUrl(templateUrl);
        };
        self.setTemplateUrl = function(templateUrl) {
            var data = {url: templateUrl};
            self.trigger('render.templateurl', data);
            mustacheTemplateUrl = data.url;
            return self;
        };
        self.getTemplate = function(tpl) {
            if (!tpl) { return templates; }
            var parts = tpl.split('-');
            for (var i=parts.length; i>0; i--) {
                tpl = parts.slice(0, i).join('-');
                if (templates[tpl]) {
                    return templates[tpl];
                }
            }
            return '';
        };
        self.setTemplates = function(data) {
            self.trigger('render.templates', data);
            templates = extend(templates, data);
            self.trigger('render.templateloaded');
        };
        self._loadTemplates = function() {
            self.log.level('render', 'Loading Templates from', mustacheTemplateUrl);
            self.loadJsonp(mustacheTemplateUrl);
            return null;
        };

            function renderTemplate(data, template, message) {
            return AdService.Mustache.render(template, data.render);
        }
        function doRender(data, template, message) {
            var html = self.getConfig('render-template-callback')(data, template, message);
            if (data.render._oba_direct && data.render._oba_direct.length) {
                html = '<a class="oba-admarker" href="'+data.render._oba_direct+'" target="_blank"><div class="oba-wrapper oba-corner-position" style="z-index:28;" onmouseover="this.className += \' oba-admarker-hover\';" onmouseout="this.className = this.className.replace(/oba-admarker-hover/, \'\');"><div class="oba-admarker"><div class="oba-admarker-icon oba-corner-position"></div><div class="oba-admarker-text oba-corner-position">Datenschutzinfo</div></div></div></a>' + html;
            }
            if (data.slot) {
                var meta = data.slot.getMetaData()[0],
                    server = data.slot.getAdServer(),
                _;
                html = server.renderMeta(html, meta);
            }
            switch (data._method) {
                case 'write':
                    document.write(html);
                    data._rendered = true;
                    break;
                case 'dom':
                default:
                    data.target.innerHTML = html;
                    data._rendered = true;
                    self._ad_finished(data.slot, data);
            }
            if (data.render.count && data.render.count.length) {
                var countFunction = self.getConfig('render-count-function');
                if (typeof countFunction === 'function') {
                    try {
                        countFunction(makeArray(data.render.count), data);
                    } catch (e) {
                        self.log.error('Error in function supplied for AdService.setConfig(\'render-count-function\', func)', e, arguments, data, this);
                    }
                }
            }
            self.trigger('render.end', data);
        }
        function render(data, target, message) {
            data = {render: data, target: target, slot: data.slot};
            self.trigger('render.begin', data);
            self.trigger('render._builddata', data);
            if ((data.target === undefined) || (data.target && data.target.self === data.target.window)) {
                data.target = data.slot.getDomNode() || {};
                data._method = 'dom';
            } else if (data.target === false) {
                data._method = 'write';
            } else {
                data._method = 'dom';
            }
            var template = data.render._type;
            if (self.getConfig('render-template-callback') === renderTemplate) {
                template = self.getTemplate(template);
                if (!template) {
                    self.on('render.templateloaded', (function(data, doRender, message) { return function() {
                        if (data._rendered) { return; }
                        doRender(data, self.getTemplate(data.render._type), message);
                    }})(data, doRender, message));
                    return self._loadTemplates();
                }
            }
            doRender(data, template, message);
            return self;
        }
        self.setConfig('render-callback', render);
        self.setConfig('render-template-callback', renderTemplate);
        /**
         * renders an Ad within a DOM node.
         * @function render
         * @param {object} data - contains the data of the object to be rendered.
         * @param {string} target - a domNode of a slot where to render.
         * @param {string} message - a set of slots. If no arguments are defined all slots will be disabled to be refreshed.
         */
        self.render = function(data, target, message) {
            if (!data.slot) { data.slot = self._getCurrentAdSlot(); }
            self.getConfig('render-callback')(data, target, message);
        };
        self._from_iframe_render = function(data) {
            data.slot = this.slot;
            self.render(data, this.window, this.message);
            return null;
        };

            self.setConfig('render-count-function', function(count, data) {
            each(count, function(i, url) {
                new Image(1, 1).src = url;
            });
        });

            self.on('render._builddata', function(evt) {
            var render = evt.data.render;
            each(render._splitlines, function(i, property) {
                var lineProperty = property + '_lines';
                render[lineProperty] = render[property].split(/\r\n|\r|\n|\s*##br##\s*/);
                for (var i=0, l=render[lineProperty].length; i<l; i++) {
                    render[lineProperty][i] = {
                        line:     render[lineProperty][i],
                        isLast:   render[lineProperty].length === i+1,
                        notLast:  render[lineProperty].length !== i+1,
                        isFirst:  i === 0,
                        notFirst: i !== 0
                    };
                }
            });
        });
    }).apply(self);

    (function() {
        self.param = function(obj, sepParam, sepValue, escFuncName, escFuncValue) { 
            var param = [];
            each(obj, function(name, value) {
                param.push((escFuncName||Code.url)(''+name) + (sepValue||'=') + (escFuncValue||escFuncName||Code.url)(''+value));
            });
            return param.join(sepParam||'&');
        };

                self.createHtmlFromDom = function(domNode) {
            var el = document.createElement('div');
            el.appendChild(domNode);
            return el.innerHTML;
        };
        self.createSlotHtml = function(slot, attr, adServiceData) {
            return self.createHtmlFromDom(self.createSlotDomNode.apply(self, arguments));
        };
        self.createSlotDomNode = function(slot, attr, adServiceData) {
            var el = document.createElement('div');
            el.setAttribute(self.getDataAttrName('slot'), slot);
            attr && each(attr, function(name, value) {
                el.setAttribute(name, value);
            });
            adServiceData && each(adServiceData, function(name, value) {
                el.setAttribute(self.getDataAttrName(name), value);
            });
            return el;
        };
        self.loadJsonp = function(url) {
            var head = document.getElementsByTagName('head')[0],
                script = document.createElement('script'),
            _;
            script.src = url;
            head.appendChild(script);
            return self;
        };
        self.getContainerWidth = function(domNode) {
            return domNode.offsetWidth;
        };

                self.createPageBackgroundDom = function(bg) { 
        };

            }).apply(self);


    (function() {
        function legacy(methodName, alternative, text, cutOut) {
            self.log.deprecated(' ');
            self.log.deprecated('----- WARNING -----');
            self.log.deprecated('You are using a deprecated method of AdService:');
            self.log.deprecated('AdService.' + methodName + '()');
            if (cutOut) {
                self.log.deprecated('This method does no longer exist.');
            } else {
                self.log.deprecated('This method will be removed in a future version.');
            }
            if (alternative) {
                self.log.deprecated('Try using AdService.' + alternative + (alternative.indexOf('(')>=0 ? '' : '()') + ' instead -- see documentation for further details.');
                self.log.deprecated('You find the documentation here:', 'wiki://TAM/AdService2');
            }
            if (text) {
                self.log.deprecated(text);
            }
            self.log.deprecated('-------------------');
            self.log.deprecated('Stack Trace:\n' + (''+(new Error()).stack).split('\n').slice(3).join('\n'));
            self.log.deprecated('-------------------');
            self.log.deprecated(' ');
        }

                self.init = function() { 
            legacy('init', 'AdServer(\'adition-asp\').setParam', 'There\'s much more that can be configured now.');
            return self.AdServer('adition-asp').setParam.apply(self, arguments);
        };
        self.onSticky = function(tagid, func) { 
            legacy('onSticky', 'on(\'ad.property.sticky\', tagid, func)');
            return self.on('ad.property.sticky', tagid, func);
        };
        self.setSticky = function() {
            legacy('setSticky', 'setAdProperty(\'sticky\')');
            return self.setAdProperty.apply(self, arrayMerge('sticky', arguments));
        };
        self.onAdsize = function(adsize, func) { 
            legacy('onAdsize', 'on(\'ad.property.adsize\', adsize, func)');
            return self.on('ad.property.adsize', adsize, func);
        };
        self.setAdCallback = function(func) {
            legacy('setAdCallback', 'on(\'ad.finished\', func)');
            return self.on('ad.finished', func);
        };
        self.setServer = function(server, config) {
            self.log.legacy('self.setServer(', arguments, ')');
            return self.AdServer(server).setConfig(config);
        };
        self.useDoubleclick = function() {
            legacy('useDoubleclick');
        };
        self.stopAdserverAds = function() {
            legacy('stopAdserverAds', 'disableServer()');
            return self.disableServer();
        };
        self.stopGoogleAds = function() {
            legacy('stopGoogleAds', 'AdServer(\'google\').disable()');
            return self.AdServer('google').disable();
        };
        self.fly = function() {
            legacy('fly', 'setSlotParam/push');
        };
        self.addPosition = function() {
            legacy('addPosition');
        };
        self.createPosition = function() {
            legacy('createPosition', 'createSlot');
            return self.createSlot.apply(self, arguments);
        };
        self.setAdplayerUrls = function() {
            legacy('setAdplayerUrls');
        };
        self.fireEvent = function() {
            legacy('fireEvent', 'trigger');
            return self.trigger.apply(self, arguments);
        };

        self.disablePosition = function() {
            legacy('disablePosition', 'disableSlot');
            return self.disableSlot.apply(self, arguments);
        };
        self.enablePosition = function() {
            legacy('enablePosition', 'enableSlot');
            return self.enableSlot.apply(self, arguments);
        };
        self.getPositionParam = function() {
            legacy('getPositionParam', 'getSlotParam');
            return self.getSlotParam.apply(self, arguments);
        };
        self.setPositionParam = function() {
            legacy('setPositionParam', 'setSlotParam');
            return self.setSlotParam.apply(self, arguments);
        };
        self.moveAdToPosition = function() {
            legacy('moveAdToPosition', null, 'AdService.createAd() has to be used within the ad.', true);
        };
        self.moveAdToSlot = function() {
            legacy('moveAdToSlot', null, 'AdService.createAd() has to be used within the ad.', true);
        };
        self.setPositions = function() {
            legacy('setPositions');
            return self;
        };
    }).apply(self);


    self._initialize = function() {
        self.triggerOnce('initialize.begin');
        self.triggerOnce('initialize.end');
    };
};

try {
    new AdService.Module('abd', function() {
            if (AdService._isConnector) { return; }
            var AdBlockDetection;
            var adBlockDetectionConfig = {
                onlyTheseChecks: undefined,
                notTheseChecks: undefined,
                resultFunction: resultFunction,
                eventname: null,
                informOn: ['everything'],
                detectionAttributes: {
                    css_sync: {
                        id: 'adservice-abd-container-sync',
                    },
                    css_async: {
                        id: 'adservice-abd-container-async',
                        maxTries: 3,
                        timeout: 100,
                    }
                },
            };
            var result = {isBlocked: undefined, didCheck: false};
            function resultFunction(abdResult) {
                result = {
                    isBlocked: abdResult.detected,
                    didCheck: abdResult.pending === 0 ? true : false,
                    details: abdResult,
                    directBlocked: abdResult.type.css || false,
                    indirectBlocked: abdResult.type.request || false,
                };
                if (result.directBlocked) {
                    AdService.triggerOnce('adblock.detected');
                    AdService.triggerOnce('adblock.direct');
                } else if (result.indirectBlocked) {
                    AdService.triggerOnce('adblock.detected');
                    AdService.triggerOnce('adblock.indirect');
                }
                if (result.didCheck) {
                    if (!result.isBlocked) { AdService.triggerOnce('adblock.notdetected'); }
                    AdService.triggerOnce('adblock.detectionfinished');
                }
            }
            (function() {
                AdBlockDetection = {
                    getCurrentStatus: function() { return { detected:undefined, pending:undefined, type:{}, fyi:{}, detection:{} }; },
                    start: function() { AdBlockDetection.autostart = true; },
                };
                function createAbd() {
                    var abdCopy = AdBlockDetection;
                    AdBlockDetection = new function() {
                        this.version = '1.4.4';
                        var self = this;
                        var STATE = {FINISHED: 'finished', INITIALIZED: 'initialized', OMITTED: 'omitted', QUEUED: 'queued', RUNNING: 'running', TIMEOUT: 'timeout',};
                        var detection = {};
                        var detectionList = {
                            known: {},
                            created: {},
                            getsResult: [],
                            results: {},
                        };
                        var abdList = [{abd: this, notifyOn: {}, runs: {}}];
                        var abdConfig = this.conf = {
                            onlyTheseChecks: undefined,
                            notTheseChecks: undefined,
                            resultFunction: undefined,
                            eventname: 'abdresult',
                            informOn: ['everything'],
                            timeout: 5000,
                            autostart: true,
                            detectionAttributes: {
                            },
                        };
                        var isFinished = false;
                        if (typeof adBlockDetectionConfig !== 'undefined') {
                            abdConfig = setDefaults(deepCopy(adBlockDetectionConfig), abdConfig);
                            this.conf = abdConfig;
                        }
                        if (!abdConfig.informOn instanceof Array) { abdConfig.informOn = [abdConfig.informOn]; }
                        ['onlyTheseChecks', 'notTheseChecks'].forEach(function(item) {
                            var checks = abdConfig[item];
                            if (checks === undefined) { return; }
                            for (var i=0, l=checks.length; i<l; i++) {
                                checks[i] = checks[i] instanceof Array ? checks[i] : [checks[i]];
                            }
                        });

                                    if (document.documentElement.AdBlockDetection && typeof document.documentElement.AdBlockDetection.registerABD === 'function') {
                            var result = document.documentElement.AdBlockDetection.registerABD(this);
                            detectionList.known = result.known.reduce(function(result, item) {
                                result[item] = true;
                                return result;
                            }, detectionList.known);
                            detectionList.created = result.needed.reduce(function(result, item) {
                                result[item] = false;
                                return result;
                            }, detectionList.created);
                            detectionList.getsResult = result.getsResult;
                            detectionList.results = result.results;
                            abdConfig.notTheseChecks = (abdConfig.notTheseChecks || []).concat(document.documentElement.AdBlockDetection.externalExclusions || []);
                            var outerDetections = document.documentElement.AdBlockDetection.getCurrentStatus().detection;
                            Object.keys(outerDetections).forEach(function(name) {
                                abdConfig.notTheseChecks.push(outerDetections[name].types);
                            });
                            document.documentElement.AdBlockDetection.externalExclusions = abdConfig.notTheseChecks;
                        } else {
                            this._isCentralInstance = true;
                            document.documentElement.AdBlockDetection = this;
                        }

                                    var status = {
                            detected: undefined,
                            pending: 0,
                            running: 0,
                            timeout: false,
                            type: {},
                            fyi: {},
                            detection: detection
                        };

                                    function logError() {
                            var info = ['[AdBlockDetection]'].concat(Array.prototype.slice.call(arguments));
                            if ('apply' in console.error) {
                                console.error.apply(console, info);
                            } else {
                                console.error(info);
                            }
                        }

                                    function deepCopy(original) {
                            var copy;
                            switch (true) {
                                case typeof original === 'number' && isNaN(original):
                                    return NaN;
                                case ['string', 'number', 'boolean'].indexOf(typeof original) >= 0:
                                case [undefined, null].indexOf(original) >= 0:
                                    return original;
                                case typeof original === 'function':
                                    return original;
                                case original instanceof Date:
                                    return new Date(original);
                                case original instanceof Array:
                                    copy = [];
                                    original.forEach(function(value, index) {
                                        copy[index] = deepCopy(value);
                                    });
                                    return copy;
                                default:
                                    copy = {};
                                    for (var i in original) {
                                        if (!original.hasOwnProperty(i)) { continue; }
                                        copy[i] = deepCopy(original[i]);
                                    }
                                    return copy;
                            }
                        };

                                    function setDefaults(result, defaults) {
                            for (var key in defaults) {
                                if (!defaults.hasOwnProperty(key)) { continue; }
                                if (result.hasOwnProperty(key)) {
                                    if (typeof defaults[key] === 'object' && defaults[key] !== null) {
                                        result[key] = setDefaults(result[key], defaults[key]);
                                    }
                                    continue;
                                }
                                result[key] = defaults[key];
                            }
                            return result;
                        }

                                    function distributeResult(name, result, isProvisional) {
                            if (self._isCentralInstance) {
                                abdList.forEach(function(obj) {
                                    if (obj.notifyOn[name]) {
                                        obj.abd.incomingResult(name, result, isProvisional);
                                    }
                                });
                            } else {
                                document.documentElement.AdBlockDetection.incomingResult(name, result, isProvisional);
                            }
                        }

                                    function informPage(isProvisional) {
                            var status = self.getCurrentStatus();
                            function send() {
                                if (typeof abdConfig.eventname === 'string') {
                                    var event = new CustomEvent(abdConfig.eventname, { detail: status });
                                    document.documentElement.dispatchEvent(event);
                                }
                                if (typeof abdConfig.resultFunction === 'function') {
                                    try {
                                        abdConfig.resultFunction(status);
                                    } catch (e) {
                                        logError('Failed to execute custom function adBlockDetectionConfig.resultFunction', abdConfig.resultFunction, status, e);
                                    }
                                }
                            }
                            if (abdConfig.informOn.indexOf('verbose')+1) { return send(); }
                            if (isProvisional) { return; }
                            if (abdConfig.informOn.indexOf('everything')+1) { return send(); }
                            if (abdConfig.informOn.indexOf('detected')+1 && status.detected && !informPage.detectedSent) { informPage.detectedSent = true; return send(); }
                            if (abdConfig.informOn.indexOf('finished')+1 && !status.pending && !isFinished) { isFinished = true; return send(); }
                        };

                                    this.incomingResult = function(name, result, isProvisional) {
                            if (this._isCentralInstance) {
                                distributeResult(name, result, isProvisional);
                            } else {
                                var detection = detectionList.known[name];
                                if (detection) {
                                    detection.setResult(result, isProvisional, true);
                                }
                            }
                        };

                                    this.getCurrentStatus = function() {
                            return deepCopy(status);
                        };

                                    this.start = function() {
                            var running = false;
                            Object.keys(detectionList.created).forEach(function(name) {
                                var detection = detectionList.created[name];
                                if (!detection) { return; }
                                status.pending++;
                            });
                            informPage(false);
                            Object.keys(detectionList.created).forEach(function(name) {
                                var detection = detectionList.created[name];
                                if (!detection) { return; }
                                if (isBlocked(detection.conf.name, detection.userConf || {})) {
                                    detection.status.state = STATE.QUEUED;
                                    return;
                                }
                            });
                            Object.keys(detectionList.created).forEach(function(name) {
                                var detection = detectionList.created[name];
                                if (!detection || detection.status.state !== STATE.INITIALIZED) { return; }
                                detection.status.state = STATE.RUNNING;
                                status.running++;
                                running = true;
                                detection.run();
                            });
                            Object.keys(detectionList.results).forEach(function(name) {
                                var detection = detectionList.created[name];
                                if (!detection) { return; }
                                detection.setResult(detectionList.results[detection.conf.name], false, true);
                            });
                            if (!running) {
                                status.pending = 0;
                                Object.keys(detectionList.created).forEach(function(name) {
                                    var detection = detectionList.created[name];
                                    if (detection && detection.status.state === STATE.QUEUED) {
                                        detection.status.pending = false;
                                        detection.status.state = STATE.OMITTED;
                                    }
                                });
                                return informPage(false);
                            }
                        };

                                    this.registerABD = function(abd) {
                            var result = {
                                known: Object.keys(detectionList.known),
                                needed: [],
                                getsResult: [],
                                results: {},
                            };
                            var abdObject = {
                                abd: abd,
                                notifyOn: {},
                                runs: {},
                            };
                            Object.keys(detectionList.known).forEach(function(name) {
                                var det = detectionList.known[name];
                                var needed = detectionMatch(det.conf.types, abd.conf.onlyTheseChecks, true) && !detectionMatch(det.conf.types, abd.conf.notTheseChecks, false);
                                if (!needed) { return; }
                                var running = abdList.reduce(function(running, obj) {
                                    return running || !!obj.runs[name];
                                }, false);
                                if (!running) { abdObject.runs[name] = true; }
                                else          { abdObject.notifyOn[name] = true; }
                            });
                            abdList.push(abdObject);
                            result.needed = Object.keys(abdObject.runs);
                            result.getsResult = Object.keys(abdObject.notifyOn);
                            result.getsResult.forEach(function(name) {
                                if (detectionList.created[name] && detectionList.created[name].status.pending === false) {
                                    result.results[name] = detectionList.created[name].status.result;
                                }
                            });
                            return result;
                        };

                                    /**
                         * returns whether a detection is included / excluded by checking detections against user defined custom settings
                         * @types       holds the type categories the specific detection falls into
                         * @checks      holds the custom settings that determine if a detection type is included / excluded
                         * @ifUndefined default value in case checks === undefined - meaning no custom settings; true for onlyTheseChecks; false for notTheseChecks
                         */

                                    function detectionMatch(types, checks, ifUndefined) {
                            if (checks === undefined) { return ifUndefined; }
                            outer: for (var i=0, l=checks.length; i<l; i++) {
                                inner: for (var j=0, k=checks[i].length; j<k; j++) {
                                    if (types.indexOf(checks[i][j]) === -1) {
                                        continue outer;
                                    }
                                }
                                return true;
                            }
                            return false;
                        }

                                    function determineIfNecessary(detection) {
                            if (self._isCentralInstance) {
                                detectionList.known[detection.conf.name] = detection;
                                return detectionMatch(detection.conf.types, abdConfig.onlyTheseChecks, true) && !detectionMatch(detection.conf.types, abdConfig.notTheseChecks, false);
                            }
                            return detectionList.created[detection.conf.name] === false
                                || (!detectionList.known[detection.conf.name] && detectionMatch(detection.conf.types, abdConfig.onlyTheseChecks, true) && !detectionMatch(detection.conf.types, abdConfig.notTheseChecks, false));
                        }

                                    function isBlocked(name, conf) {
                            if (!conf.dependencies || typeof conf.dependencies !== 'object') { return false; }
                            return !Object.values(conf.dependencies).reduce(function(noBlock, dependency) {
                                return noBlock || !Object.keys(dependency).reduce(function(isBlocked, key) {
                                    if (key === name || !status.detection[key]) {
                                        return isBlocked || false;
                                    } else if (dependency[key] === status.detection[key].result) {
                                        return isBlocked || false;
                                    } else if (dependency[key] === status.detection[key].state) {
                                        return isBlocked || false;
                                    }
                                    return true;
                                }, false);
                            }, false);
                        }

                                    var Detection = this.Detection = function(conf) {
                            this.conf = conf;
                            this.conf.results = this.conf.results || {};
                            this.conf.abort = this.conf.abort || function() {
                                if (this.status.state === STATE.OMITTED) {
                                    this.status.pending = false;
                                } else if(this.status.state === STATE.QUEUED) {
                                    this.status.pending = false;
                                    this.status.state = STATE.OMITTED;
                                    this.setResult(undefined, true);
                                } else {
                                    status.timeout = true;
                                    this.status.state = STATE.TIMEOUT;
                                    this.setResult(false);
                                    this.conf.cleanup.call(this);
                                }
                            }.bind(this);
                            this.conf.results = this.conf.results || {};
                            this.conf.results._default = this.conf.results._default || { type: function(a, b) { return a || b; } };
                            this.conf.results._global = this.conf.results._global || function(a, b) {
                                if (a || b) { return true; }
                                else if (a === b) { return a; }
                                else { return b === undefined ? a : b }
                            };
                            this.userConf = setDefaults(deepCopy(abdConfig.detectionAttributes[this.conf.name]||{}), this.conf.userConfDefaults||{});
                            this.data = {};
                            this.status = {
                                pending: true,
                                state: STATE.INITIALIZED,
                                result: undefined,
                                types: this.conf.types
                            };
                            if (!determineIfNecessary.call(this, this)) {
                                if (detectionList.getsResult.indexOf(this.conf.name) >= 0) {
                                    this.executedExternally = true;
                                    detection[conf.name] = this.status;
                                    detectionList.created[this.conf.name] = this;
                                    detectionList.known[this.conf.name] = this;
                                }
                                return false;
                            }
                            abdList[0].runs[this.conf.name] = true;
                            this.timeout = window.setTimeout(this.abort.bind(this), abdConfig.timeout);
                            this.conf.types.forEach(function(type) {
                                var temp = this.conf.results[type] || this.conf.results._default || {type: true};
                                if (!status.type.hasOwnProperty(type) && temp.type) { status.type[type] = undefined; }
                                if (!status.fyi.hasOwnProperty(type)  && temp.fyi)  { status.fyi[type]  = undefined; }
                            }.bind(this));
                            detection[conf.name] = this.status;
                            detectionList.created[this.conf.name] = this;
                        };

                                    Detection.prototype.run = function() {
                            if (this.executedExternally) { return; }
                            if (this.conf.initialize) { this.conf.initialize.call(this); }
                            this.conf.runner.call(this);
                        };

                                    Detection.prototype.setResult = function(result, isProvisional, isDistributed) {
                            if (this.status.pending) { this.status.pending = !!isProvisional; }
                            if (this.status.state === STATE.RUNNING && !isProvisional) {
                                this.status.state = STATE.FINISHED;
                            }
                            this.status.result = result;
                            status.pending = Object.values(status.detection).reduce(function(counter, detection) { return counter + detection.pending; }, 0);
                            status.running = Object.values(status.detection).reduce(function(counter, detection) { return counter + (detection.state === STATE.RUNNING); }, 0);
                            this.conf.types.forEach(function(type) {
                                var combinator = this.conf.results[type] || this.conf.results._default;
                                if (typeof combinator.type === 'function') { status.type[type] = combinator.type(status.type[type], result); }
                                if (typeof combinator.fyi  === 'function') { status.fyi[type]  = combinator.fyi(status.fyi[type], result); }
                                status.detected = this.conf.results._global(status.detected, result);
                            }.bind(this));
                            if (!isDistributed && !isProvisional && this.conf.cleanup) {
                                this.conf.cleanup.call(this);
                            }
                            if (!isProvisional) {
                                if (!status.timeout) {
                                    Object.keys(detectionList.created).forEach(function(name) {
                                        var detection = detectionList.created[name];
                                        if (!detection || detection.status.state !== STATE.QUEUED) { return; }
                                        if (isBlocked(detection.conf.name, detection.userConf || {})) { return; }
                                        detection.status.state = STATE.RUNNING;
                                        status.running++;
                                        detection.run();
                                    });
                                }
                                if (!status.running && status.pending) {
                                    status.pending = 0;
                                    Object.keys(detectionList.created).forEach(function(name) {
                                        var detection = detectionList.created[name];
                                        if (!detection || detection.status.state !== STATE.QUEUED) { return; }
                                        detection.conf.abort.call(detection);
                                    });
                                }
                            }
                            if (!isDistributed) {
                                distributeResult(this.conf.name, result, isProvisional);
                            }
                            informPage(isProvisional);
                        };
                        Detection.prototype.abort = function() {
                            if (typeof this.conf.abort === 'function' && this.status.pending) {
                                this.conf.abort.call(this);
                            }
                        };

                                    (function() {
                            new Detection({
                                name: 'css_sync',
                                types: ['css', 'sync'],
                                userConfDefaults: {
                                    id: 'abd-container-sync',
                                },
                                initialize: function() {
                                    var el = this.data.element = document.createElement('div');
                                    el.id             = this.userConf.id;
                                    el.className      = 'gemini-ad advertorial adv ad ad-container ad-contain promoad pub_300x250 plainAd photoad ad-body ad-content adContent ad300x250 adBox adCreative adModule adboxcontent sponsorad ezo_ad';
                                    el.setAttribute('lazy-ad', 'top_banner');
                                    el.style.width    = '300px';
                                    el.style.height   = '250px';
                                    el.style.position = 'absolute';
                                    el.style.top      = '-1000px';
                                    el.style.left     = '-1000px';
                                    document.body.firstChild ? document.body.insertBefore(el, document.body.firstChild) : document.body.appendChild(el);
                                },
                                runner: function() {
                                    var height = this.data.element.clientHeight || this.data.element.offsetHeight;
                                    var isBlocked = height>0 ? false : true;
                                    this.setResult(isBlocked);
                                },
                                cleanup: function() {
                                    if (this.data.element) { document.body.removeChild(this.data.element); }
                                },
                            });
                        })();
                        (function() {
                            new Detection({
                                name: 'css_async',
                                types: ['css', 'async'],
                                userConfDefaults: {
                                    id: 'abd-container-async',
                                    maxTries: 5,
                                    timeout: 100,
                                },
                                initialize: function() {
                                    var el = this.data.element = document.createElement('div');
                                    el.id             = this.userConf.id;
                                    el.className      = 'gemini-ad advertorial adv ad ad-container ad-contain promoad pub_300x250 plainAd photoad ad-body ad-content adContent ad300x250 adBox adCreative adModule adboxcontent sponsorad ezo_ad';
                                    el.setAttribute('lazy-ad', 'top_banner');
                                    el.style.width    = '300px';
                                    el.style.height   = '250px';
                                    el.style.position = 'absolute';
                                    el.style.top      = '-1000px';
                                    el.style.left     = '-1000px';
                                    document.body.firstChild ? document.body.insertBefore(el, document.body.firstChild) : document.body.appendChild(el);
                                },
                                runner: function() {
                                    if (this.conf.custom.count++ <= this.userConf.maxTries) {
                                        if (this.conf.custom.count === 1 || !this.conf.custom.check.call(this)) {
                                            this.conf.custom.timeout = window.setTimeout(function() {
                                                this.conf.runner.call(this);
                                            }.bind(this), this.userConf.timeout);
                                        }
                                    } else {
                                        this.setResult(false);
                                    }
                                },
                                cleanup: function() {
                                    if (this.data.element) { document.body.removeChild(this.data.element); }
                                },
                                abort: function() {
                                    if (this.status.state === STATE.OMITTED) {
                                        this.status.pending = false;
                                    } else if(this.status.state === STATE.QUEUED) {
                                        this.status.pending = false;
                                        this.status.state = STATE.OMITTED;
                                        this.setResult(undefined, true);
                                    } else {
                                        status.timeout = true;
                                        this.status.state = STATE.TIMEOUT;
                                        this.setResult(false);
                                        window.clearTimeout(this.conf.custom.timeout);
                                    }
                                },
                                custom: {
                                    timeout: undefined,
                                    count: 0,
                                    check: function() {
                                        var height = this.data.element.clientHeight || this.data.element.offsetHeight;
                                        var isBlocked = height>0 ? false : true;
                                        this.setResult(isBlocked, !isBlocked);
                                        return isBlocked;
                                    },
                                },
                            });
                        })();
                        (function() {
                            new Detection({
                                name: 'indirect',
                                types: ['request', 'async'],
                                userConfDefaults: {
                                    dependencies: [
                                        { css_sync: false },
                                    ],
                                    url: 'https://imagesrv.adition.com/1x1.gif',
                                    css: { display: 'none' },
                                },
                                initialize: function() {
                                    this.data.pixel = document.createElement('img');
                                    this.data.pixel.onload = function() {
                                        this.setResult(false);
                                    }.bind(this);
                                    this.data.pixel.onerror = function() {
                                        this.setResult(true);
                                    }.bind(this);
                                    this.data.pixel.src = this.userConf.url;
                                    Object.keys(this.userConf.css).forEach(function(key) {
                                        this.data.pixel.style[key] = this.userConf.css[key];
                                    }.bind(this));
                                    document.body.firstChild ? document.body.insertBefore(this.data.pixel, document.body.firstChild) : document.body.appendChild(this.data.pixel);
                                },
                                runner: function() {
                                },
                                cleanup: function() {
                                    try {
                                        document.body.removeChild(this.data.pixel);
                                    } catch(e) {
                                    }
                                },
                            });
                        })();
                        (function() {
                            new Detection({
                                name: 'acceptable',
                                types: ['acceptable', 'async', 'request'],
                                userConfDefaults: {
                                    dependencies: [
                                        { css_async: true },
                                        { css_sync: true },
                                    ],
                                },
                                results: {
                                    _global: function(a, b) { return a; },
                                    _default: {},
                                    acceptable: { fyi: function(a, b) { return a === undefined ? b : a && b; } },
                                },
                                initialize: function() {
                                    var abp_test = new function() {
                                        this.alreadyRunning = false;
                                        this.detect = function(url, callback) {
                                            if (typeof callback !== 'function') { return; }
                                            if (abp_test.alreadyRunning) { return; }
                                            abp_test.alreadyRunning = true;
                                            var result = [undefined, undefined],
                                                rnd = Math.floor((Math.random() * Math.pow(10, 9)) + 1),
                                                acceptable = new Image,
                                                blockable = new Image;
                                            url += '?ch=*&rn=' + rnd;
                                            acceptable.onload  = function() { setResult(0, true); };
                                            acceptable.onerror = function() { setResult(0, false); };
                                            acceptable.src     = url.replace('*', 1);
                                            blockable.onload   = function() { setResult(1, true); };
                                            blockable.onerror  = function() { setResult(1, false); };
                                            blockable.src      = url.replace('*', 2);
                                            function setResult(index, isAcceptable) {
                                                result[index] = isAcceptable;
                                                if (result[0] !== undefined && result[1] !== undefined) {
                                                    callback(result[0] === true && result[1] === false);
                                                }
                                            }
                                        }
                                    };
                                    abp_test.detect('//static.criteo.net/images/pixel.gif', function(doesAcceptAcceptables) {
                                        if (this.status.state !== STATE.TIMEOUT) {
                                            this.setResult(doesAcceptAcceptables);
                                        }
                                    }.bind(this));
                                },
                                runner: function() {
                                },
                                cleanup: function() {
                                },
                            });
                        })();
                        (function() {
                            new Detection({
                                name: 'united_info',
                                types: ['unitedBlocked', 'request', 'async'],
                                userConfDefaults: {
                                    dependencies: [
                                        { css_async: true },
                                        { css_sync: true },
                                    ],
                                    css: { display: 'none' },
                                },
                                results: {
                                    _global: function(a, b) { return a; },
                                    _default: {},
                                    unitedBlocked: { fyi: function(a, b) { return a === undefined ? b : a && b; } },
                                },
                                initialize: function() {
                                    this.data.pixel = document.createElement('img');
                                    this.data.pixel.onload = function() {
                                        this.setResult(false);
                                    }.bind(this);
                                    this.data.pixel.onerror = function() {
                                        this.setResult(true);
                                    }.bind(this);
                                    this.data.pixel.src = 'https://united-infos.net/pixel.gif';
                                    Object.keys(this.userConf.css).forEach(function(key) {
                                        this.data.pixel.style[key] = this.userConf.css[key];
                                    }.bind(this));
                                    document.body.firstChild ? document.body.insertBefore(this.data.pixel, document.body.firstChild) : document.body.appendChild(this.data.pixel);
                                },
                                runner: function() {
                                },
                                cleanup: function() {
                                    try {
                                        document.body.removeChild(this.data.pixel);
                                    } catch(e) {
                                    }
                                },
                            });
                        })();
                        (function() {
                            new Detection({
                                name: 'ff_private',
                                types: ['private', 'async'],
                                results: {
                                    _global: function(a, b) { return a; },
                                    _default: {},
                                    private: { fyi: function(a, b) { return a === undefined ? b : a && b; } },
                                },
                                initialize: function() {
                                    var isFirefox = typeof InstallTrigger !== 'undefined';
                                    var isPrivate = indexedDB.open("test");
                                    isPrivate.onerror = function(isPrivate) { this.setResult(isFirefox); }.bind(this);
                                    isPrivate.onsuccess = function(isPrivate) { this.setResult(false); }.bind(this);
                                },
                                runner: function() {
                                },
                                cleanup: function() {
                                },
                            });
                        })();

                                    if (abdConfig.autostart || abdCopy.autostart) {
                            this.start();
                        }
                    }
                }

                            if (typeof window.CustomEvent !== 'function') {
                    CustomEvent = function(event, params) {
                        params = params || { bubbles: false, cancelable: false, detail: null };
                        var evt = document.createEvent( 'CustomEvent' );
                        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                        return evt;
                    };
                    window.CustomEvent = CustomEvent;
                }
                if (typeof Object.values === 'undefined') {
                    Object.values = function(obj) { return Object.keys(obj).map(function(e) { return obj[e]; }); }
                }

                            if (document.body) { return createAbd(); }
                if (typeof MutationObserver !== 'undefined') {
                    var observer = new MutationObserver(function() {
                        if (document.body) {
                            createAbd();
                            observer.disconnect();
                        }
                    });
                    observer.observe(document.documentElement, {childList: true, subtree: true});
                }
            })();
            AdService.registerInfo({
                name: 'abd',
                func: function() { return result || {isBlocked: undefined, didCheck: false}; },
                persistent: false,
                event: 'body.begin',
                initial: result
            });
        })
        .extendBaseObject('setAdserverFallback', function(func) {
            AdService.on('adblock.detected', func);
            return AdService;
        })
        .extendBaseObject('abdDirectAdServer', function(func) {
            AdService.on('adblock.direct', func);
            return AdService;
        })
        .extendBaseObject('abdIndirectAdServer', function(func) {
            AdService.on('adblock.indirect', func);
            return AdService;
        });
} catch (e) {
    AdService.Module.logError(e);
}
try {
    new AdService.Module('uim-cookie-exchanger', function() {
            AdService.on('initialize.end', function() {
                if (AdService.getConfig('auto-exchange-uim-cookie')) {
                    AdService.Module('uim-cookie-exchanger').run();
                }
            });
        })
        .set('data', {
            requested: false,
            received: false,
            cookie: null
        })
        .set('run', function() {
            if (AdService.Module('uim-cookie-exchanger').data.requested) { return; }
            var script = AdService.createElement('script', {src:'https://uir.uimserv.net/id/'});
            document.getElementsByTagName('head')[0].appendChild(script);
            if ('onload' in script) {
                script.onload = script.onerror = function() {
                    AdService.Module('uim-cookie-exchanger').setCookie();
                };
            } else {
                var counter = 10,
                    timeout = 50,
                    factor = 1.3,
                    tester = function() {
                        if (window.UI_nguserid) {
                            return AdService.Module('uim-cookie-exchanger').setCookie();
                        }
                        if (--counter) {
                            return nextTest();
                        }
                    },
                    nextTest = function() {
                        timeout = timeout * factor;
                        window.setTimeout(tester, timeout);
                    },
                _;
                nextTest();
            }
            AdService.Module('uim-cookie-exchanger').data.requested = true;
        })
        .set('setCookie', function() {
            function reportNgUserId(nguserid) {
                AdService.Module('uim-cookie-exchanger').data.cookie = nguserid;
                AdService.triggerOnce('module.uim-cookie-exchanger.cookie-set', {nguserid: nguserid});
            }
            function getNgUserId() {
                return (document.cookie.match(/(?:^|; )NGUserID=([^;]*)/) || [0, ''])[1];
            };
            AdService.Module('uim-cookie-exchanger').data.received = true;
            var domain = '.' + location.host.split('.').splice(-2).join('.'),
                expires = new Date(),
            _;
            expires.setTime(expires.getTime() + 365*86400000);
            var nguserid = getNgUserId();
            if (['.gmx.ch', '.gmx.at', '.gmx.net', '.web.de', '.1und1.de'].indexOf(domain) >= 0) {
                if (nguserid === 'TGP-OPT-OUT') {
                    reportNgUserId(nguserid);
                    return;
                }
                if (window.UI_nguserid !== 'TGP-OPT-OUT') {
                    if (!(''+window.UI_nguserid).match(/^[A-Za-z0-9-]{10,2000}$/)) {
                        reportNgUserId(nguserid);
                        return;
                    }
                }
            }
            if (!window.UI_nguserid) {
                reportNgUserId(nguserid);
                return;
            }
            document.cookie = [
                'NGUserID=' + window.UI_nguserid,
                'domain=' + domain,
                'path=/',
                'expires=' + expires.toGMTString(),
                'secure',
                'samesite=none'
            ].join('; ');
            reportNgUserId(window.UI_nguserid);
        })
        .set('info', function() {
            return AdService.Module('uim-cookie-exchanger').data;
        })
    ;
} catch (e) {
    AdService.Module.logError(e);
}
try {
    new AdService.Module('session-storage', function() {
            this.storageName = 'as2data';
            this.storage = JSON.parse(sessionStorage.getItem(this.storageName) || '{}');
            if (!this.storage.param) { this.storage.param = {}; }
            AdService.on('initialize.begin', function() {
                AdService.setParam(this.storage.param);
            }.bind(this));
        })
        .set('getStorage', function() {
            return this.storage;
        })
        .set('setStorage', function(data) {
            var extend = AdService.gimme('extend');
            this.storage = extend(this.storage, data);
            sessionStorage.setItem(this.storageName, JSON.stringify(this.storage));
        })
        .extendBaseObject('setSessionParam', function(params) {
            if (typeof params !== 'object' || params === null) {
                var tmp = {};
                tmp[arguments[0]] = arguments[1];
                params = tmp;
            }
            AdService.Module('session-storage').setStorage({param:params});
            AdService.setParam(params);

        })
    ;
} catch (e) {
    AdService.Module.logError(e);
}

function handleParam(paramList, key, value, separator, translate) {
    var urlParamsTranslate = {
        wi: 'w',
        ac: 'a',
        browser: 'b',
        fvers: 'f',
        os: 'o',
        screen_res: 'r',
        ref: 'e',
    };

    if(!(!!value)) { return; }

    if (translate && typeof urlParamsTranslate[key] !== 'undefined') {
        key = urlParamsTranslate[key];
    }

    paramList.push(key + separator + value);
}

var extend = AdService.gimme('extend'),
      each = AdService.gimme('each');

try {
    new AdService.Module('adition-asp-single-request', function() {
    })
        .set('loadAds', function(data) {
            var singleRequestObject = data;
            var slots = Object.keys(data.slots);

            var srUrl = (slots.length === 1 && slots[0] === 'prioad') ? this.prioadSingleRequest(slots) : this.generateSingleRequestUrl(slots),
                code = '<script>var adition = {jp: {h: function(x) { parent.postMessage(JSON.stringify({singleRequestResponse:x}), \'*\'); }}}<\/script><script src="' + srUrl + '" onerror=\"adition.jp.h({\'b\':[{\'c\':\''+srUrl+'\',\'w\':0,\'h\':0}]},\'failure\');\"><\/script>';

            if (typeof srUrl === 'object') {
                AdService.AdSlot(data.target || 'srq').queueAdHtml('', 'srq');
                AdService.ad(data.target || 'srq');
                parent.postMessage(JSON.stringify({singleRequestResponse:srUrl}));
            } else {
                AdService.AdSlot(data.target || 'srq').setIndependent();
                AdService.AdSlot(data.target || 'srq').queueAdHtml(code, 'srq');
                AdService.ad(data.target || 'srq');
            }
AdService.getDefaultAdServer().increaseRequestCount();
            /**
             * listen to the singleRequestResponse and normalize data.
             * depending on the settings callback will be executed or rendered
             */
            var singleRequestMessage = function(event) {
                if (!event.data) { return; }
                if (typeof event.data !== 'string') { return; }
                if (typeof event.data === 'string' && event.data.indexOf('"singleRequestResponse"') === -1) { return; }

                var singleRequestResponse = JSON.parse(event.data),
                    slots = Object.keys(singleRequestObject.slots).filter(function(key) { return !!singleRequestObject.slots[key]; });

                for(var i=0, len=slots.length; i<len; i++) {
                    var data = singleRequestResponse.singleRequestResponse.b[i],
                        slot = slots[i];

                    if(data.w === 0 && data.h === 0) {
                        if(AdService.getConfig('srqTracking',false)) {
                            var srqUrl = encodeURIComponent(data.c);
                            (new Image()).src = 'https://t.uimserv.net/drp_p/?evtID=915&haID='+AdService.getParam('wi')+'&mediaID=&site='+AdService.getParam('portal')+'&sc=&att1=' + srqUrl;
                        }
                        data.w = 468;
                        data.h = 60;
                        data.c = '';
                    }

                    if(typeof singleRequestObject.slots[slot] === 'function') {
                      var callback = singleRequestObject.slots[slot],
                          callbackData = {
                              'ad': data.c,
                              'width': data.w,
                              'height': data.h,
                              'adsize': data.w + 'x' + data.h
                          };

                      callbackData.type = AdService.getDefaultAdServer().getAdFormByMetaData(callbackData);
                      singleRequestObject.slots[slot] = callback(callbackData);

                    }

                    if (singleRequestObject.slots[slot]) {
                        AdService.AdSlot(slot).queueAdHtml(data.c);
                        AdService.refresh(slot);
                    }
                }
                window.removeEventListener('message', singleRequestMessage, false);
            };
            window.addEventListener('message', singleRequestMessage);
        })
        .set('generateSingleRequestUrl', function(slots) {
            var requestUrl = AdService.AdSlot(slot[0]).getUrl(),
                adserver = AdService.getDefaultAdServer(),
                params = adserver.params,
                baseUrl = '//' + adserver.config.host + '/s?';

            var learningTag = [
                'portal('+params.portal+')',
                'category('+params.category+')',
                'section('+params.section+')',
                'layoutclass('+params.layoutclass,
            ];

            var slotParams = {
                mutual: {},
                slots: {},
            };

            each(slots, function(index, slot){
                AdService.AdSlot(slot).setParam('tagid', slot);
                var requestUrl = adserver.getUrl(slot),
                    list = {},
                    tagid;

                if(requestUrl.indexOf('ac=-1') !== -1) {
                }

                requestUrl.split('?')[1].split('&').forEach(function(pair) {
                    var values = pair.split('=');
                    if(values[0] !== 'tagid' && values[0] !== 'lt' && values[0] !== 'wpt') {
                        list[values[0]] = values[1];
                        if(slotParams.mutual && slotParams.mutual[values[0]] === values[1]) {
                            delete list[values[0]];
                            if(index===1) {
                                delete slotParams.slots[Object.keys(slotParams.slots)][values[0]];
                            }
                        }
                    } else if (values[0] === 'lt') {
                        tagid = (/tagid\((\w+)\)/g.exec(values[1]))[1];
                    }
                });
                if(index===0) { extend(slotParams.mutual, list); }
                slotParams.slots[slot] = list;
            });

            var urlParams = ['t='+slots.join('.'), 'v=1'],
                profileParams = [];

            Object.keys(slotParams.mutual).forEach(function(key){
                if (key.indexOf('prf[') === -1) {
                    handleParam(urlParams, key, slotParams.mutual[key], '=', true);
                } else {
                    handleParam(profileParams, (/(prf\[)(\w+)(\])/g.exec(key))[2], slotParams.mutual[key], '(', false);
                }
            });

            var paramString = urlParams.join('&') + '&p=' + profileParams.join(')');

            var tagids = [];

            for(var i=0,len=slots.length; i<len; i++) {
                var tagid = slotParams.slots[slots[i]]['prf[tagid]'],
                    slotParamsList = slotParams.slots[slots[i]],
                    slotProfileParams = [];

                if(slots.length > 1){
                    Object.keys(slotParamsList).forEach(function(key) {
                        if (key.indexOf('prf[') !== -1) {
                            handleParam(slotProfileParams, (/(prf\[)(\w+)(\])/g.exec(key))[2], slotParamsList[key], '(', true);
                        } else {
                            handleParam(slotProfileParams, key, slotParamsList[key], '(', false);
                        }
                    });
                }

                if(i === len-1) {
                    tagids.push('tagid('+tagid+'!'+slotProfileParams.join(')'));
                } else {
                    tagids.push('tagid('+tagid+'!'+slotProfileParams.join(')')+'*');
                }
            }
            return baseUrl + paramString + '&lt=' + learningTag.join('') + '&s=' + tagids.join('');
        })
        .set('prioadSingleRequest', function(slot) {
            var requestUrl = AdService.AdSlot(slot[0]).getUrl(),
                list = {},
                baseUrl = '//' + AdService.getDefaultAdServer().config.host + '/s?';

            requestUrl.split('?')[1].split('&').forEach(function(pair) {
                var values = pair.split('=');
                list[values[0]] = values[1];
            });

            if(list['ac'] === '-1' && !!list['prf[btid_size]']) {
                var code = '<script src="'+requestUrl+'"></script>';
                return {b: [{c: code, w: list['prf[btid_size]'].split('x')[0], h: list['prf[btid_size]'].split('x')[1]}]};
            }
            if(list['ac'] === '-1') { baseUrl = 'https://uim-adwebfe.server.lan/generic/s.php?'; }
            var learningTag = list.lt.slice(0,-1);

            ['lt', 'wpt'].forEach(function(param){
                delete list[param];
            });

            var urlParams = ['t='+slot, 'v=1'],
                profileParams = [];

            Object.keys(list).forEach(function(key){
                if(key.indexOf('prf[tagid]') !== -1) { return; }
                if(key.indexOf('prf[') === -1) {
                    handleParam(urlParams, key, list[key], '=', true);
                } else {
                    handleParam(profileParams, (/(prf\[)(\w+)(\])/g.exec(key))[2], list[key], '(', false);
                }
            });

            var paramString = urlParams.join('&') + '&p=' + profileParams.join(')'),
                tagid = 'tagid('+list['prf[tagid]']+'!tagid('+list['prf[tagid]'];

            return baseUrl + paramString + '&lt=' + learningTag + '&s=' + tagid;
        })
        .extendBaseObject('singleRequestAdition', function(params) {
            if (typeof params === 'undefined') { return; }
            if (typeof params !== 'object' || params === null) {
                var tmp = {
                    'slots':{}
                };
                tmp.slots[arguments[0]] = (typeof arguments[1] !== 'undefined') ? arguments[1] : true;
                params = tmp;
            }
            AdService.Module('adition-asp-single-request').loadAds(params);
        })
    ;
} catch (e) {
    AdService.Module.logError(e);
}

(function(self) {
function getOs(n) {
         if (n.search(/xbox\sseries/) !== -1) { return 31; }
    else if (n.search(/xbox\ssone/) !== -1) { return 30; }
    else if (n.search(/playstation\s5/) !== -1) { return 29; }
    else if (n.search(/playstation\s4/) !== -1) { return 28; }
    else if (n.search(/windows\sphone\s10\.0/) !== -1) { return 25; }
    else if (n.search(/windows\sphone\s8\.1/) !== -1) { return 24; }
    else if (n.search(/windows\sphone\s8\.0/) !== -1) { return 23; }
    else if (n.search(/xbox/) !== -1) { return 22; }
    else if (n.search(/symbian/) !== -1) { return 13; }
    else if (n.search(/windows\snt\s6\.2;\sarm/) !== -1) { return 18; }
    else if (n.search(/cros/) !== -1) { return 19; }
    else if (n.search(/windows\snt\s6\.3/) !== -1) { return 16; }
    else if (n.search(/windows\snt\s6\.2/) !== -1) { return 15; }
    else if (n.search(/iphone|ipad/) !== -1) { return 14; }
    else if (n.search(/android/) !== -1) { return 12; }
    else if (n.search(/windows\sce/) !== -1) { return 11; }
    else if (n.search(/windows\snt\s10\.0/) !== -1) { return 17; }
    else if (n.search(/playstation/) !== -1) { return 20; }
    else if (n.search(/nintendo/) !== -1) { return 21; }
    else if (n.search(/blackberry/) !== -1) { return 26; }
    else if (n.search(/nokia/) !== -1) { return 27; }
    else if (n.search(/windows\snt\s6\.1/) !== -1) { return 10; }
    else if (n.search(/unix/) !== -1) { return 7; }
    else if (n.search(/linux/) !== -1) { return 6; }
    else if (n.search(/mac\sos\sx|macintosh|mac\x5fpowerpc/) !== -1) { return 5; }
    else if (n.search(/windows\snt\s6\.0/) !== -1) { return 9; }
    else if (n.search(/windows\snt\s5\.2/) !== -1) { return 8; }
    else if (n.search(/windows\snt\s5\.1/) !== -1) { return 3; }
    else if (n.search(/windows\snt\s5\.0/) !== -1) { return 2; }
    else if (n.search(/windows\snt\s4\.0/) !== -1) { return 4; }
    else if (n.search(/windows\s95|windows\sme|win98|windows\s98/) !== -1) { return 1; }
    return -1;
};
function getBrowser(n) {
         if (n.search(/spotify/) !== -1) { return 31; }
    else if (n.search(/fban|fb_iab/) !== -1) { return 30; }
    else if (n.search(/ucbrowser|ucweb/) !== -1) { return 16; }
    else if (n.search(/silk/) !== -1) { return 28; }
    else if (n.search(/chromium/) !== -1) { return 17; }
    else if (n.search(/yabrowser/) !== -1) { return 20; }
    else if (n.search(/edge|edg/) !== -1) { return 15; }
    else if (n.search(/vivaldi/) !== -1) { return 23; }
    else if (n.search(/qqbrowser/) !== -1) { return 26; }
    else if (n.search(/maxthon|myie/) !== -1) { return 24; }
    else if (n.search(/360se|360ee/) !== -1) { return 25; }
    else if (n.search(/iron/) !== -1) { return 21; }
    else if (n.search(/iceweasel/) !== -1) { return 19; }
    else if (n.search(/metasr/) !== -1) { return 27; }
    else if (n.search(/palemoon/) !== -1) { return 22; }
    else if (n.search(/seamonkey/) !== -1) { return 18; }
    else if (n.search(/trident\/(7\.0)/) !== -1) { return 14; }
    else if (n.search(/nokia/) !== -1) { return 29; }
    else if (n.search(/msie\s10/) !== -1) { return 13; }
    else if (n.search(/msie\s9/) !== -1) { return 12; }
    else if (n.search(/chrome\//) !== -1) { return 11; }
    else if (n.search(/msie\s8/) !== -1) { return 10; }
    else if (n.search(/gecko\//) !== -1) { return 6; }
    else if (n.search(/opera|OPR/) !== -1) { return 7; }
    else if (n.search(/konqueror|safari/) !== -1) { return 8; }
    else if (n.search(/msie\s7/) !== -1) { return 9; }
    else if (n.search(/msie\s6/) !== -1) { return 3; }
    else if (n.search(/msie\s5/) !== -1) { return 2; }
    else if (n.search(/netscape4/) !== -1) { return 4; }
    else if (n.search(/netscape6|netscape\/(7\.\d*)/) !== -1) { return 5; }
    else if (n.search(/msie\s4/) !== -1) { return 1; }
    return -1;
};

function getResolution() {
    var size = screen.width+'x'+screen.height;
    switch (size) {
        case  '360x740':   return 464;
        case  '640x480':   return 1;
        case  '720x400':   return 153;
        case  '768x1024':  return 199;
        case  '800x240':   return 465;
        case  '800x352':   return 466;
        case  '800x480':   return 154;
        case  '800x600':   return 2;
        case  '832x624':   return 159;
        case  '848x480':   return 155;
        case  '852x480':   return 156;
        case  '854x480':   return 467;
        case  '858x484':   return 158;
        case  '864x480':   return 157;
        case  '960x540':   return 160;
        case  '960x544':   return 468;
        case  '960x640':   return 162;
        case  '960x720':   return 163;
        case  '964x544':   return 161;
        case '1024x576':   return 164;
        case '1024x600':   return 165;
        case '1024x640':   return 469;
        case '1024x768':   return 3;
        case '1024x800':   return 472;
        case '1024x476':   return 476;
        case '1072x600':   return 166;
        case '1080x1200':  return 477;
        case '1120x832':   return 474;
        case '1138x640':   return 470;
        case '1152x720':   return 473;
        case '1152x768':   return 167;
        case '1152x864':   return 4;
        case '1152x870':   return 168;
        case '1152x900':   return 169;
        case '1200x800':   return 170;
        case '1200x900':   return 171;
        case '1280x720':   return 172;
        case '1280x768':   return 9;
        case '1280x800':   return 10;
        case '1280x854':   return 173;
        case '1280x960':   return 7;
        case '1280x1024':  return 5;
        case '1334x750':   return 475;
        case '1360x768':   return 174;
        case '1360x1024':  return 179;
        case '1366x768':   return 175;
        case '1366x1024':  return 180;
        case '1376x768':   return 176;
        case '1400x900':   return 177;
        case '1400x1050':  return 8;
        case '1440x900':   return 11;
        case '1440x960':   return 178;
        case '1440x1024':  return 478;
        case '1440x1080':  return 479;
        case '1440x1440':  return 482;
        case '1600x768':   return 181;
        case '1600x900':   return 182;
        case '1600x1024':  return 183;
        case '1600x1200':  return 6;
        case '1600x1280':  return 481;
        case '1680x1050':  return 12;
        case '1776x1000':  return 480;
        case '1792x1344':  return 483;
        case '1800x1440':  return 487;
        case '1856x1392':  return 486;
        case '1920x1080':  return 184;
        case '1920x1200':  return 13;
        case '1920x1280':  return 484;
        case '1920x1400':  return 185;
        case '1920x1440':  return 186;
        case '2048x1152':  return 187;
        case '2048x1280':  return 490;
        case '2048x1536':  return 188;
        case '2160x1200':  return 489;
        case '2160x1440':  return 494;
        case '2256x1504':  return 496;
        case '2280x1080':  return 485;
        case '2304x1440':  return 495;
        case '2304x1728':  return 497;
        case '2436x1125':  return 491;
        case '2538x1080':  return 492;
        case '2560x1080':  return 493;
        case '2560x1440':  return 190;
        case '2560x1600':  return 191;
        case '2560x1700':  return 500;
        case '2560x1800':  return 501;
        case '2560x1920':  return 503;
        case '2560x2048':  return 192;
        case '2732x2048':  return 507;
        case '2736x1824':  return 505;
        case '2800x2100':  return 193;
        case '2880x900':   return 488;
        case '2880x1440':  return 498;
        case '2880x1620':  return 502;
        case '2880x1800':  return 506;
        case '2960x1440':  return 499;
        case '3000x2000':  return 509;
        case '3200x1800':  return 508;
        case '3200x2048':  return 511;
        case '3200x2400':  return 513;
        case '3240x2160':  return 512;
        case '3440x1440':  return 504;
        case '3840x1600':  return 510;
        case '3840x2160':  return 514;
        case '3840x2400':  return 515;
        case '4096x2304':  return 516;
        case '4096x3072':  return 519;
        case '4480x2520':  return 518;
        case '4500x3000':  return 520;
        case '5120x2160':  return 517;
        case '5120x2880':  return 521;
        case '5120x3200':  return 522;
        case '5120x4096':  return 523;
        case '6016x3384':  return 524;
        case '6400x4096':  return 525;
        case '6400x4800':  return 526;
        case '6480x3240':  return 527;
        case '7680x4320':  return 528;
        case '7680x4800':  return 529;
        case '8192x4320':  return 530;
        case '8192x4608':  return 531;
        case '8192x8192':  return 533;
        case '10240x4320': return 532;
        case '15360x8640': return 534;
        case 'Sonstige':   return 0;
    }
    return -1;
};

function analyzeMobile() {
    var o = {ua: navigator.userAgent.toLowerCase(), info: {}},
        x = 'browser',
        v = 'version',
        w = window,
        result = {},
        i;
    o.ua.replace(/[\(\)]/g, ';')
        .replace(/\s*(\w*?\ ?\w+[\:\s]?[^\d\s;]*?)[\/\ ;](\d[.\w]*|)/g, function(f, k, v) { o.info[k] = o.info[k] || v || !0; });
    'edge1msie1opr1firefox1seamonkey1aurora1iron1chrome1mobile safari1safari1opera1windows0windows nt0windows phone0windows rt0mac os0os x0android0iphone0ipad0ipod0blackberry0rim0linux0'.replace(/(\D+)(\d)/g, function(n, c, d) { n = +d ? x : 'os'; o.info[c] && (o[n] = o[n] || { name: c == 'opr' ? 'opera' : (c == 'safari' && o.info.android || c == 'chrome' && +o.info[v] == 1) || (o.info.android && c == 'mobile safari') ? 'native' : c == 'os x' ? 'mac os' : c, version: (+d ? o.info[v] : 0) || (o.info[c] === true && o.info.os ? o.info.os.replace(/_/g, '.') : o.info[c]) }, o[n][o[n].name] = parseFloat(o[n][v]) || o[n][v]) });
    (i = +o.info.trident + 4) && (o[x] = {name: 'msie', msie: i, version: i});
    o[x] = o[x] || {name: '', version: ''};
    o.os = o.os || {name: '', version: ''};
    o.retina = 'matchMedia' in w && (w.matchMedia('(-webkit-min-device-pixel-ratio: 2)') || 0).matches;
    o.connection = ['unknown', 'eth', 'wifi', '2g', '3g', '4g'][(navigator.connection || 0).type || 0] || 'unknown';
    o.format = /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(o.ua) ? 'tab' : /mobi|windows phone|iphone|blackberry/.test(o.ua) ? 'mobile' : 'desktop';
    result.cl   = o.browser.name.slice(0, 3);
    result.clv  = 0 | parseFloat(o.browser.version);
    result.sys  = (o.os.name).slice(0, 3);
    result.sysv = o.os.version || '?';
    result.vpw  = document.documentElement.offsetWidth;
    result.r    = o.retina ? '1' : undefined;
    result.net  = o.connection;
    result.ff   = (({'tab':'m', 'mobile':'s'})[o.format] || 'b');
    result.deviceclass = ({'b':'desktop', 'm':'desktop', 's':'mobile'})[result.ff];
    return result;
};
    var dom = self.gimme('dom'),
        each = self.gimme('each'),
        parseUrl = self.gimme('parseUrl'),
        sizetable = {
            '450x300': 'maxiad',
            '640x360': 'maxiad',
            '640x480': 'maxiad',
            '640x481': 'maxiadcontent',
            '800x450': 'maxiad',
            '800x600': 'maxiad',
            '1260x690': 'maxiad',
            '300x250': 'rectangle',
            '300x115': 'uniteaser',
            '728x90': 'superbanner',
            '120x600': 'skyright',
            '160x600': 'skyright',
            '200x600': 'skyright',
            '320x600': 'skyright',
            '800x250': 'billboard',
            '970x250': 'billboard',
            '994x250': 'billboard',
            '220x600': 'sitebar',
            '300x600': 'halfpage',
            '750x200': 'floor',
            '300x250_630x350': 'content',
            '300x280': 'content_responsive',
            '600x250': 'widecontent',
            '940x300': 'pushdown',
            '960x300': 'pushdown',
            '770x250': 'banderole',
            '848x600': 'tandem_singleton',
            '888x600': 'tandem_singleton',
            '928x600': 'tandem_singleton',
            '1028x600': 'tandem_singleton',
            '1x1': 'ambient',
            '3x3': 'lounge',
        _:0},
        uaString = navigator.userAgent.toLowerCase(),
        nextTagId = {},
        tempNextTagId = {},
    _;
    function getDeviceClass() {
        var ua = uaString.replace(/[\(\)]/g, ';');
        var format = /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(ua) ? 'tab' : /mobi|windows phone|iphone|blackberry/.test(ua) ? 'mobile' : 'desktop',
            ff = (({'tab':'m', 'mobile':'s'})[format] || 'b');
        return ff;
    };
    function getNewPageId() {
        return (Math.random().toString().substr(2, 9));
    };
    function getToolbarInfo() {
        var ua = navigator.userAgent,
            info = {};
        if (/Edge\/|Trident\/|MSIE /.test(ua)) {
            var data = ua.match(/tb-([a-z]+)\/([0-9\.]+)(; \([a-z]+\/[0-9\.]+\))?/i);
            if (data) {
                info.brand = data[1];
                info.version = data[2];
                info.bbrowser = data[3] ? true : false;
            }
        } else {
            var $html = document.getElementsByTagName('html')[0];
            info.kid = $html.getAttribute('united-toolbar-campaignid');
            info.mode = $html.getAttribute('united-toolbar-mode');
            info.variant = $html.getAttribute('united-toolbar-variant');
            info.brand = $html.getAttribute('united-toolbar-brand');
            info.bbrowser = $html.getAttribute('united-toolbar-branded-browser');
            info.version = $html.getAttribute('united-toolbar-version');
        }
        info.hasToolbar = !!info.version;
        return info;
    };
    function getNgUserId() {
        return (document.cookie.match(/(?:^|; )NGUserID=([^;]*)/) || [0, ''])[1];
    };
    function getAutUserId(optout) {
        if (optout) {
            document.cookie = '_autuserid2=; SameSite=None; Secure; expires=Thu, 01 Jan 1970 00:00:00 GMT';
            return false;
        }
        var value = (document.cookie.match(/(?:^|; )_autuserid2=([^;]*)/) || [0, ''])[1];
        if (!value) {
            var ajax = new XMLHttpRequest();
            ajax.onreadystatechange = function() {
                if (this.readyState !== 4 || this.status !== 200) { return; }
                if (ajax.responseText === '0') { return; }
                aditionUserId = ajax.responseText;
                setAutUserIdCookie(ajax.responseText);
            };
            ajax.withCredentials = true;
            self.on('adblock.detected', function() {
                ajax.open('GET', 'https://united-infos.net/i?raw=1&ts='+(new Date().getTime()), true);
                ajax.send();
            });
            self.on('adblock.notdetected', function() {
                ajax.open('GET', 'https://ad11.adfarm1.adition.com/i?raw=1&ts='+(new Date().getTime()), true);
                ajax.send();
            });
        } else {
            setAutUserIdCookie(value);
        }
        return value;
    };
    function setAutUserIdCookie(value) {
        var domain = location.host.split('.').splice(-2).join('.');
        var expires = new Date();
        expires.setTime(expires.getTime() + 2*365*24*60*60*1000);
        document.cookie = '_autuserid2=' + value
                        + '; domain=.' + domain
                        + '; path=/'
                        + '; SameSite=None'
                        + '; Secure'
                        + '; expires=' + expires.toGMTString()
        ;
    };
    var nguserid = getNgUserId();
    var aditionUserId;
    self.on('server.setparam', function(evt) {
        if (evt.data.params.hasOwnProperty('userid') && typeof evt.data.params.userid !== 'function') {
            aditionUserId = evt.data.params.userid;
        }
    });
    function getIframe() {
        var iframe = 0;
        try {
            if (top.location !== window.location) { iframe = 1; }
            if (window.frameElement)              { iframe = 1; }
        } catch (e) {
            iframe = 1;
        }
        return ''+iframe;
    };

    function setSecuredParam(name, value) {
        self.getDefaultAdServer()[securedSymbol].setSecuredParam(name, value);
    }

    var mobileParams = analyzeMobile(),
        createAdServer = function(id, config, params) {
            var tagidListForPrf = {};
            var posCount = {};
            var ac = 1;
            var server = new AdService.AdServer(id, AdService.Helper.extend({
                probableDefault: true,
                host: 'ad11.adfarm1.adition.com',
                path: 'lt',
                paramOrder: {
                    begin: [
                        'wpt', 'nw', 'lt', 'ac', 'portal', 'category', 'section', 'tagid', 'layoutclass',
                        'posIndex', 'posCount', 'wi', 'ref',
                        'os', 'browser', 'screen_res', 'iframe', 'fvers',
                        'external_uid', 'uid_stable', 'optout', 'userid', 'gdpr', 'gdpr_consent', 'shb',
                        'prf[slot]', 'prf[portal]', 'prf[category]', 'prf[section]', 'prf[tagid]', 'prf[layoutclass]',
                        'prf[deviceclass]', 'prf[deviceclient]',
                        'prf[sectionlong]', 'prf[categorytype]',
                        'prf[os]', 'prf[browser]', 'prf[screen_res]', 'prf[iframe]', 'prf[fvers]',
                        'prf[sys]', 'prf[sysv]', 'prf[cl]', 'prf[clv]', 'prf[vpw]', 'prf[vph]', 'prf[net]',
                        'prf[external_uid]', 'prf[hid]', 'prf[nguserid]', 'prf[uids]', 'prf[optout]', 'prf[shb]',
                        'prf[pp]', 'prf[pa]', 'prf[pg]'
                    ],
                    end:    ['prf[pageview]', 'debug'],
                    ignore: ['posName', 'ff']
                },
                evenIfEmpty: ['ref', 'iframe', 'fvers', 'external_uid', 'uid_stable', 'prf[nguserid]', 'prf[uids]', 'prf[hid]'],
                paramTypes: {
                    direct: ['lt', 'ac', 'nw', 'uid_stable', 'userid', 'wpt', 'sid', 'bid', 'kid', 'ref', 'gdpr', 'gdpr_consent', 'debug'],
                    both:   ['wi', 'os', 'browser', 'iframe', 'screen_res', 'fvers', 'optout', 'external_uid', 'hid', 'ipt', 'consentLevel', 'shb'],
                    ignore: ['ff']
                },
                nonContentElements: ['uim:ad'],
                init: function() {
                    var info = getToolbarInfo();
                    this.setParam({
                        toolbar: info.hasToolbar ? '1' : '0',
                        brandedbrowser: !!info.bbrowser ? '1' : '0'
                    });
                    this.setParam({
                        uid_stable: '0',
                        uids: '0',
                        external_uid: nguserid,
                        nguserid: nguserid,
                        optout: nguserid==='TGP-OPT-OUT' ? '1' : '0',
                        consentlevel: this.getParam('consentLevel') || (document.cookie.match(/(?:^|; )consentLevel=([^;]*)/) || [0, ''])[1] || undefined,
                        google_ac: '0',
                    });
                    var dnt = window.doNotTrack == '1' || navigator.doNotTrack == 'yes' || navigator.doNotTrack == '1' || navigator.msDoNotTrack == '1';
                    this.setParam({
                        dnt: dnt ? '1' : '0'
                    });
                    this.setParam({
                        os: getOs(uaString),
                        browser: getBrowser(uaString)
                    });
                }
            }, config), AdService.Helper.extend({
                ac: function() {
                    return ac;
                },
                nw: 42,
                deviceclient: 'browser',
                wpt: function(slot) {
                    if (slot instanceof AdService.AdSlot) {
                        switch (slot.type) {
                            case 'iframe':
                                return 'h';
                                break;
                            case 'javascript':
                            default:
                                return 'j';
                                break;
                        }
                    }
                },
                deviceclass:  getDeviceClass(),
                external_uid: '',
                uid_stable:   0,
                wi:           getNewPageId(),
                fvers:        self.info.flash().major,
                ref:          location.origin + location.pathname || '',
                iframe:       getIframe(),
                screen_res:   getResolution(),
                cl:           mobileParams.cl,
                clv:          mobileParams.clv,
                sys:          mobileParams.sys,
                sysv:         mobileParams.sysv,
                vpw:          mobileParams.vpw,
                vph:          window.innerHeight,
                r:            mobileParams.r,
                net:          mobileParams.net,
                ff:           mobileParams.ff,
                tagid: function(slot) {
                    if (slot instanceof AdService.AdSlot) {
                        return slot.id;
                    }
                },
                slot: function(slot) {
                    if (slot instanceof AdService.AdSlot) {
                        return slot.id;
                    }
                },
                userid: function(slot) {
                    return aditionUserId;
                }
            }, params)
        );

        server.isAditionServer = true;

        server._specialParams = {
            _order: ['tagid_x', 'lt', 'maxwidth', 'bannerid', 'btid'],
            tagid_x: function(params, slot) {
                var rawTagid = (''+(nextTagId[slot.id]||params.tagid)).replace(/_x/g, '');
                if (params.tagid in tagidListForPrf && (params.tagid.indexOf('_x') === -1)) {
                    params.tagid += '_x';
                }
                if (nextTagId[slot.id]) {
                    params.tagid = nextTagId[slot.id];
                    tempNextTagId[slot.id] = nextTagId[slot.id];
                    delete nextTagId[slot.id];
                }
                posCount[rawTagid] = (posCount[rawTagid] || 0) + 1;
                params.pos = posCount[rawTagid];
                tagidListForPrf[params.tagid] = true;
            },
            lt: function(params, slot) {
                this.config.sepNameValue = '(';
                this.config.sepParams = ')';
                var lt = this._getParamString({
                    portal: params.portal,
                    category: params.category,
                    section: params.section,
                    tagid: params.tagid,
                    layoutclass: params.layoutclass
                }, slot);
                this.config.sepNameValue = '=';
                this.config.sepParams = '&';
                params.lt = lt + ')';
            },
            maxwidth: function(params, slot) {
                if (!params.hasOwnProperty('maxwidth')) {
                    params.maxwidth = slot.getContainerWidth();
                }
            },
            bannerid: function(params, slot) {
                if (params.bannerid && !tempNextTagId[slot.id]) {
                    var ids = params.bannerid.split(';');
                    each(ids, function(i, id) {
                        var parts = id.split(',');
                        if (parts[1] === slot.id) {
                            params.bid = parts[0];
                            params.ac = -1;
                        }
                    });
                    delete tempNextTagId[slot.id]
                    delete params.bannerid;
                }
            },
            btid: function(params, slot) {
                if (params.btid && !tempNextTagId[slot.id]) {
                    var ids = params.btid.split(';');
                    each(ids, function(i, id) {
                        var parts = id.split(',');
                        if (parts[1] === params.tagid) {
                            params.bid = parts[0];
                            params.ac = -1;
                        }
                    });
                    delete tempNextTagId[slot.id]
                    delete params.btid;
                }
            },
        };

        server.prepareParamsForUrl = function(params, slot) {
            var server = this;
            slot = self._getAdSlot(slot);
            each(server._specialParams._order, function(i, name) {
                server._specialParams[name].call(server, params, slot);
            });
            each(params, function(key, value) {
                if (server.config.paramTypes.direct.indexOf(key) === -1 && server.config.paramTypes.ignore.indexOf(key) === -1) {
                    if (key.indexOf('prf[') === 0) {
                        params[key] = value;
                    } else if (!params.hasOwnProperty('prf['+key+']')) {
                        params['prf['+key+']'] = value;
                    }
                }
            });
            each(params, function(key, value) {
                if (key.indexOf('prf[') === -1 && server.config.paramTypes.direct.indexOf(key) === -1 && server.config.paramTypes.both.indexOf(key) === -1) {
                    delete params[key];
                }
                if (server.config.paramTypes.ignore.indexOf(key) >= 0) {
                    delete params[key];
                }
            });
            params = AdService.Helper.extend(params || {}, server.directParams);
            params = AdService.Helper.extend(params || {}, slot.directParams);
            return params;
        };

        server.getUrl = function(slot, requestMethod) {
            slot = self._getAdSlot(slot);
            var url = this.config.protocol + this.config.host + '/' + this.config.path + this.config.sepQuery,
                params = this.getUrlParams(slot),
            _;
            if (requestMethod===AdService.Const.REQUEST_METHOD.FRIENDLY_IFRAME || requestMethod===AdService.Const.REQUEST_METHOD.NONFRIENDLY_IFRAME) {
                params.iframe = params['prf[iframe]'] = '1';
            }
            url += this._getParamString(AdService.Helper.extend(
                {wpt: requestMethod===AdService.Const.REQUEST_METHOD.NONFRIENDLY_IFRAME ? 'h' : 'j'},
                params
            ), slot);
            return url;
        };

        server.renderMeta = function(html, meta) {
            var metaHtml = '<uim:ad xmlns:uim="urn:publicid:-:UIM:adinfo" ';
            each(meta, function(name, value) {
                metaHtml += name+'="'+value+'" ';
            });
            metaHtml += '></uim:ad>\n';
            return metaHtml + html;
        };
        server.exportMetaData = function() {
            var html = (document.getElementsByTagName('uim:ad')[0] || {outerHTML:''}).outerHTML;
            self.sendMessage(top, 'importMetaData', html);
            return this;
        };
        server.importMetaData = function(data) {
            var uimAdTags = data.iframe.parentNode.getElementsByTagName('uim:ad');
            if (uimAdTags) {
                for (var i=uimAdTags.length-1; i>=0; i--) {
                    data.iframe.parentNode.removeChild(uimAdTags[i]);
                }
            }
            data.iframe.insertAdjacentHTML('beforebegin', data.message.data);
        };

        server.newPageContext = function() {
            this.setParam('wi', getNewPageId());
            return this;
        };
        server.getAdSize = function(domNode) {
            try {
                var adSize = domNode.getElementsByTagName('uim\:ad')[0].getAttribute('adsize');
                var dimensions = adSize.split('x');
                return {
                    width: dimensions[0],
                    height: dimensions[1]
                }
            } catch (e) { }
            return {};
        };
        server.getAdFormByMetaData = function(meta, fallbackAllowed) {
            return meta ? (sizetable[meta.adsize] || (fallbackAllowed ? meta.adsize : undefined)) : undefined;
        };
        server.getEventsByMetaData = function(meta) {
            return {
                form: server.getAdFormByMetaData(meta),
                size: meta.adsize,
            _:0};
        };

        server.splitMultiResponse = function(domNode) {
            var parts = [];
            each(domNode.childNodes, function(i, node) {
                if (node.nodeName.toLowerCase() === 'div') {
                    parts.push(node);
                }
            });
            return parts;
        };

        server.increaseRequestCount = function(newAc) {
            if (typeof newAc === typeof 42) {
                ac = newAc;
            } else {
                ac++;
            }
        };

        server.checkUrlValidity = function(url) {
            url = parseUrl(url);
            return (server.config.validHosts || [server.config.host]).indexOf(url.hostname) >= 0;
        };

        self.on('ad.urlReady', function(evt) {
            if (evt.slot && !evt.slot.hasQueuedAdHtml() && evt.slot.getAdServer().isAditionServer && evt.slot.getAdServer().id === server.id) {
                server.increaseRequestCount();
            }
        });

        return server;
    };

    self.on('server.setparam', function(evt) {
        if (evt.data.params.hid) {
            evt.data.params.external_uid = evt.data.params.hid;
            evt.data.params.uid_stable = 1;
            evt.data.params.uids = 1;
        }
    });

    self.on('server.setconfig', function(evt) {
        if (evt.data.config.type === 'iframe') {
            evt.slot.setParam('wpt', 'j');
            evt.data.config.requestType = Const.REQUEST_TYPE.ASYNC;
            evt.data.config.secure = true;
        }
    });

    self.on('adblock.detectionfinished', function(evt) {
        var abdResult = AdService.info.abd();
        if (!abdResult.isBlocked || abdResult.details.type.request === false) { return; }   
        var isDirectBlocker = Object.keys(abdResult.details.type).reduce(function(isDirectBlocker, name) {
            if (['async', 'request'].indexOf(name) >= 0) { return isDirectBlocker; }
            return isDirectBlocker || abdResult.details.type[name];
        }, false);
        if (isDirectBlocker) {
            self.setParam('acceptableads', abdResult.details.fyi.acceptable ? 1 : 0);
        }
    });

    self.on('ad.property.nextTagId', function(evt) {
        nextTagId[evt.slot.id] = evt.data.nextTagId;
    });

    self.getDeviceClass = self.getDeviceClass || function() {
        return self.getParam('deviceclass');
    };

    var here = location.host.split('.').slice(-2).join('.'),
        host = 'united-infos.net';
    switch (here) {
        case 'gmx.at':
        case 'gmx.ch':
        case 'gmx.net':
            host = 'info.gmx.net';
            break;
        case '1und1.de':
        case 'web.de':
            host = 'info.'+here;
            break;
    }
    var AditionAspAdServer = createAdServer('adition-asp');
    var AditionAspInfoServer = createAdServer('adition-asp-info', {
        host: host,
        validHosts: ['united-infos.net', 'info.1und1.de', 'info.gmx.net', 'info.web.de'],
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    }, {
        tagid: function(slot) {
            return (slot instanceof AdService.AdSlot && slot.getConfig('fallbackTagid')) || (slot.id + '_info');
        }
    });
    var AditionAspInfoServer = createAdServer('adition-asp-united-infos', {
        host: 'united-infos.net',
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    }, {
        tagid: function(slot) {
            return (slot instanceof AdService.AdSlot && slot.getConfig('fallbackTagid')) || (slot.id + '_united');
        }
    });
    var AditionAspInfoServer = createAdServer('adition-asp-united-uimserv', {
        host: 'united.uimserv.net',
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    }, {
        tagid: function(slot) {
            return (slot instanceof AdService.AdSlot && slot.getConfig('fallbackTagid')) || (slot.id + '');
        }
    });
    var AditionAspInfoServer = createAdServer('adition-asp-consent-uimserv', {
        host: 'united.uimserv.net',
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    });

    if (self._isConnector) {
        self.adMeta = function(meta) {
            self._adMeta = meta;
            self.sendMessage(top, 'adMeta', arguments, function(evt) {
                self.trigger('answer.adMeta', evt);
            });
            return self;
        };
    } else {
        self.adMeta = function(meta) { 
            self._getCurrentAdSlot().addMetaData(meta);
            return self;
        };
    }

    if (self._isConnector) {
        self.on('ad.finished', function(evt) {
            if (!self._adMeta) {
                var uimAd = document.getElementsByTagName('uim\:ad')[0],
                    attr = uimAd ? uimAd.getAttribute : function() { return undefined; },
                    meta = {
                        contentunitid: attr.call(uimAd, 'contentunitid'),
                        campaignid: attr.call(uimAd, 'campaignid'),
                        bannerid: attr.call(uimAd, 'bannerid'),
                        portal: attr.call(uimAd, 'portal'),
                        category: attr.call(uimAd, 'category'),
                        section: attr.call(uimAd, 'section'),
                        tagid: attr.call(uimAd, 'tagid'),
                        layoutclass: attr.call(uimAd, 'layoutclass'),
                        width: attr.call(uimAd, 'width'),
                        height: attr.call(uimAd, 'height'),
                        adsize: attr.call(uimAd, 'adsize'),
                        ovkid: attr.call(uimAd, 'ovkid')
                    },
                _;
                self.adMeta(meta);
            }
        });
    }

self.on('initialize.end', function() {
    var uiConsent = {
        permissionFeature: [],
        publisher: [],
        purpose: [],
        specialFeature: []
    };

    try {
        window.__tcfapi('getTCData', 2, function(response) {
            function createConsentArray(data) {
                if (!data) { return []; }
                if (data.consents) { data = data.consents; }
                return Object.keys(data).filter(function(i) { return data[i]; }).map(function(i) { return parseInt(i); });
            }
            if (response.tcString !== '') {
                uiConsent.tcString = response.tcString;
                uiConsent.publisher = createConsentArray(response.publisher);
                uiConsent.purpose = createConsentArray(response.purpose);
                uiConsent.specialFeature = createConsentArray(response.specialFeatureOptins);
                uiConsent.vendorConsent = Object.keys(obj = response.vendor && response.vendor.consents ? response.vendor.consents : {}).reduce(function(x, y) { return x || obj[y]; }, false);
                window.__tcfapi('getPermission', 2, function(response) {
                    uiConsent.google = response;
                    if (response) {
                        window.__tcfapi('getACString', 2, function(acString) {
                            uiConsent.acString = acString;
                        });
                    } else {
                        delete uiConsent.acString;
                    }
                }, 'googleAc');
                window.__tcfapi('getPermission', 2, function(response) {
                    if (response) { uiConsent.permissionFeature = ['fullConsent']; }
                }, 'fullConsent');
                window.__tcfapi('getTCFVersion', 2, function(response) {
                	uiConsent.version = parseFloat(response);
                }, null);
            }
        });
    } catch (e) {
        uiConsent.tcString = (document.cookie.match(/(?:^|; )euconsent-v2=([^;]*)/) || [0, ''])[1];
        try {
            uiConsent.google = false;
            uiConsent.permissionFeature = JSON.parse(decodeURIComponent((document.cookie.match(/(?:^|; )uiconsent=([^;]*)/) || [0, '{"permissionFeature":[]}'])[1])).permissionFeature;
        } catch (e) {
        }
    }

    uiConsent.fullConsent = uiConsent.permissionFeature instanceof Array && uiConsent.permissionFeature.indexOf('fullConsent') >= 0;

    if (uiConsent.fullConsent) {
        uiConsent.acString = true;
        uiConsent.vendorConsent = true;
        uiConsent.version = 2;
        uiConsent.publisher = [1,2,3,4,5,6,7,8,9,10];
        uiConsent.purpose = [1,2,3,4,5,6,7,8,9,10];
        uiConsent.specialFeature = [1,2];
    }

    function hasConsent(obj, list) {
        if (uiConsent.fullConsent) { return true; }
        return list.reduce(function(result, i) {
            return result && obj.indexOf(i) !== -1;
        }, true);
    }
    function hasPublishers() {
        return hasConsent(uiConsent.publisher, Array.prototype.slice.call(arguments));
    }
    function hasPurposes() {
        return hasConsent(uiConsent.purpose, Array.prototype.slice.call(arguments));
    }
    function hasSpecialFeatures() {
        return hasConsent(uiConsent.specialFeature, Array.prototype.slice.call(arguments));
    }

    if (uiConsent.tcString) {
        setSecuredParam('gdpr', 1);
        setSecuredParam('gdpr_consent', uiConsent.tcString);
        setSecuredParam('prf[optout]', self.getParam('optout'));
        setSecuredParam('optout', undefined);
    } else {
        setSecuredParam('prf[optout]', 1);
        setSecuredParam('optout', 1);
    }
    setSecuredParam('tcf_ven', uiConsent.vendorConsent ? '1' : '0');
    setSecuredParam('tcf_version', uiConsent.version ? uiConsent.version : '1.1');
    setSecuredParam('google_ac', (uiConsent.acString && uiConsent.acString !== '1~') ? '1' : '0');
    setSecuredParam('consentlevel', undefined);

    if (!hasPublishers(1, 2) && self.getParam('deviceclient')==='browser' && !(!!self.info.abd().isBlocked)) {
        self.setDefaultAdServer('adition-asp-consent-uimserv');
    }

    if (hasPublishers(1)) {
        aditionUserId = getAutUserId(nguserid==='TGP-OPT-OUT') || undefined;
    } else {
    	setSecuredParam('userid', undefined);
    }

    if (!hasPublishers(2)) {
        [
            'deviceclass', 'cl', 'clv', 'sys', 'sysv', 'os', 'browser', 'screen_res',
            'vpw', 'vph', 'toolbar', 'brandedbrowser', 'weather_temp', 'weather_condition', 'clktype',
            'view', 'camera', 'hw', 'hwversion', 'appvers', 'd', 'retina', 'orient',
            'net', 'apilevel', 'interstitial', 'screensizewidth', 'screensizeheight', 'maxsize', 'fvers'
        ].forEach(function(item) {
            setSecuredParam(item, undefined);
        });
    }

    if (!hasPublishers(1, 3)) {
        ['prf[hid]', 'prf[nguserid]', 'prf[external_uid]', 'prf[idfa]', 'prf[device-idfa]'].forEach(function(item) {
            setSecuredParam(item, undefined);
        });
    }

    if (!hasPublishers(1, 3, 4)) {
        self.setParam('prf[external_uid]', self.getParam('external_uid'));
        setSecuredParam('external_uid', undefined);
    }

    if (!hasPublishers(3, 4)) {
        ['pa', 'pp', 'pg', 'userlevel'].forEach(function(item) {
            setSecuredParam(item, undefined);
        });
    }

    var idcc = (document.cookie.match(/(?:^|; )idcc=([^;]*)/) || [0, ''])[1]
    if(idcc && /^([a-zA-Z0-9])+$/.test(idcc)) {
        if (hasPublishers(1)) {
            setSecuredParam('idcc',idcc);
        }
    }

    setSecuredParam('tcf_pub', ','+uiConsent.publisher.join()+',');
    setSecuredParam('tcf_pur', ','+uiConsent.purpose.join()+',');
    setSecuredParam('tcf_spe', ','+uiConsent.specialFeature.join()+',');
});
}).apply(self, [AdService]);
(function(self) {
    var adformats = { 
        '450x300': 'maxiad',
        '640x360': 'maxiad',
        '640x480': 'maxiad',
        '640x481': 'maxiadcontent',
        '800x450': 'maxiad',
        '800x600': 'maxiad',
        '1260x690': 'maxiad',
        '300x250': 'rectangle',
        '300x115': 'uniteaser',
        '728x90': 'superbanner',
        '120x600': 'skyright',
        '160x600': 'skyright',
        '200x600': 'skyright',
        '320x600': 'skyright',
        '800x250': 'billboard',
        '970x250': 'billboard',
        '994x250': 'billboard',
        '220x600': 'sitebar',
        '300x600': 'halfpage',
        '750x200': 'floor',
        '300x250_630x350': 'content',
        '300x280': 'content_responsive',
        '600x250': 'widecontent',
        '940x300': 'pushdown',
        '960x300': 'pushdown',
        '770x250': 'banderole',
        '848x600': 'tandem_singleton',
        '888x600': 'tandem_singleton',
        '928x600': 'tandem_singleton',
        '1028x600': 'tandem_singleton',
        '1x1': 'ambient',
        '3x3': 'lounge',
    _:0},
    singleRequestEnabled = false,
    googleSlots = {},
    requestedGoogleSlots = {};

    var globalParamsBlacklist = ['tcf_pub', 'tcf_pur', 'tcf_spe', 'tcf_ven', 'tcf_version', 'google_ac', 'gdpr', 'gdpr_consent', 'prf[optout]', 'optout', 'hasConsent', 'skv'],
        slotParamsBlacklist = ['sizes', 'isRefresh'],
        serverParamsSet = false;

    /**
     * The cookie is set via the generics within the mailer. It contains a base64 encoded stringified JSON
     * @return {object} representation of global params
     */
    function getCookieParams() {
        var params = {},
            cookieParamsEncoded,
            cookieParamsDecoded;

        try {
            cookieParamsEncoded = (document.cookie.match(/(?:^|; )adtrgtng=([^;]*)/) || [0, ''])[1];
            cookieParamsDecoded = window.atob(cookieParamsEncoded);
            params = JSON.parse(cookieParamsDecoded);
        } catch (e) {
            self.log.error('[Google] - getCookieParams: ', 'cookieParamsEncoded', cookieParamsEncoded, 'cookieParamsDecoded', cookieParamsDecoded, 'params', params);
        }
        self.log('[Google] - getCookieParams: ', 'cookieParamsEncoded', cookieParamsEncoded, 'cookieParamsDecoded', cookieParamsDecoded, 'params', params);
        return params;
    }
    /**
     * checks if a user has given publisher consent (1-4 & 7) + consent on vendor Google (id 755)
     * if the tcfapi is not available it falls back to the uiconsent cookie which has to hold fullConsent
     * @return {boolean} has the user given consent
     */
    function getConsent() {
        if(typeof (document.cookie.match(/(?:^|; )gdna=([^;]*)/i) || [0, false])[1] == 'string') { return true; }

        var hasConsent,
            googleVendorId = 755;

        try {
            window.__tcfapi('getPermission', 2, function(response) {
              hasConsent = response;
            }, 'publisher', [1,2,3,4,7]);

            window.__tcfapi('getPermission', 2, function(response) {
              if(hasConsent) { hasConsent = response;}
            }, 'vendor', googleVendorId);
        } catch (e) {
            self.log.error('[Google] - getCookieParams: __tcfapi not available', e);
            try {
                var permissionFeature = JSON.parse(decodeURIComponent((document.cookie.match(/(?:^|; )uiconsent=([^;]*)/) || [0, '{"permissionFeature":[]}'])[1])).permissionFeature;
                hasConsent = permissionFeature.includes('fullConsent');
            } catch (e) {
                self.log.error('[Google] - getCookieParams: cookie could not be parsed', e);
            }
        }

        return hasConsent || false;
    }

    function setSecuredParam(name, value) {
        self.getDefaultAdServer()[securedSymbol].setSecuredParam(name, value);
    }

    /**
     * kvs=key,value,rectangle;key2,value,right
     * @param {[type]} values [description]
     * @TODO comments and rename function
     */
    function setSlotKeyValues(values) {
        var keyValueSlot = values.split(';');
        each(keyValueSlot, function(i, value) {
            var kvs = value.split(',');
            self.AdSlot(kvs[2]).setParam(kvs[0], kvs[1]);
        });
    }

    /**
     * Adds GPT Library into the head, initializes googletag cmd and triggers an event if it could be loaded
     * If gpt.notloaded is fired the listener disables the server
     */
    function createGoogleScript() {
        var script = document.createElement('script');

        script.onload = function() {
            self.triggerOnce('gpt.loaded');
        };
        script.onerror = function() {
            self.triggerOnce('gpt.notloaded');
        };

        script.src = 'https://www.googletagservices.com/tag/js/gpt.js';
        script.async = true;

        window.googletag = { cmd: [] };

        document.head.appendChild(script);
    }

    function setGoogleDebug() {
        if (/[?&]google-debug=(true|false)(&|$)/.test(location.search)) {
            debugMode = RegExp.$1 === 'true';
            googletag.cmd.push(function(debugMode) {
                debugMode ? googletag.openConsole() : googletag.disablePublisherConsole();
            }(debugMode));
        }
    }

    /**
     * listener on server.setconfig due to some sever specific configurations
     * @param  {object} evt data
     */
    self.on('server.setconfig', function(evt){
        var secure = AdService.getConfig('secure');
        if(secure) {
            googletag.cmd.push(function () {
                var forcedSafe = googletag.pubads().setForceSafeFrame(secure);
                self.log('[Google] - server.setconfig secure: ', forcedSafe);
                googletag.pubads().setSafeFrameConfig(evt.data.config.safeFrameConfig);
            });
        }
        if(evt.data.config.singleRequest) {
            googletag.cmd.push(function() {
                var singleRequest = googletag.pubads().enableSingleRequest();
                self.log('[Google] - server.setconfig singlerequest: ', singleRequest);
                singleRequestEnabled = singleRequest;
            });
        }
    });

    /**
    * disable the adserver on detected adblocker or if script could not be loaded
    * @param  {object} evt data
    */
    self.on('adblock.detected', function(evt) {
        server.disable();
    });
    self.on('gpt.notloaded', function(evt) {
        self.log('[Google] - gpt script not loaded', evt);
        server.disable();
    });

    var server = new AdService.AdServer('google', {
        probableDefault: true,
        init: function() {
            createGoogleScript();
            googletag.cmd.push(function() {
                googletag.pubads().set('page_url', location.origin);
            });

            var cookieParams = getCookieParams();
            this.setParam(cookieParams);
            each(cookieParams, function(key, value) {
                googletag.cmd.push(function() {
                    googletag.pubads().setTargeting(key, value);
                });
            });

            googletag.cmd.push(function() {
                googletag.pubads().setTargeting('connector', self.getConfig('adservice-iframe-script-url'));
                googletag.pubads().setTargeting('server', 'google');
            });

            var hasConsent = getConsent();
            this.setParam('hasConsent', hasConsent);
            self.log('[Google] - getConsent: ', hasConsent);
            if(!hasConsent) {
                this.setConfig('enabled', false);
                self.trigger('server.disabled', self._getCurrentAdSlot(), {server:this});
            }

            if(this.getParams().kvs) {
                self.log('[Google] - set kvs: ', this.getParams().kvs);
                setSlotKeyValues(this.getParams().kvs);
            }

        }
    }, {

    });

    /**
     * Generates a new pagecontext, known as correlator in GPT terms, see
     *  https://developers.google.com/publisher-tag/reference#googletag.pubadsservice-updatecorrelator
     * @return {server} server object
     */
    server.newPageContext = function() {
        googletag.cmd.push(function() {
            googletag.pubads().updateCorrelator();
        });
        return this;
    };

    /**
     * GPT creates a div element within the slot div which holds the adsize via style width/height
     * @param  {node} domNode   domNode of the AdSlot itself
     * @return {object}         object containing width & height
     */
    server.getAdSize = function(domNode) {
        try {
            var child = domNode.querySelector('div');
            return {
                width: child.style.width.replace('px',''),
                height: child.style.height.replace('px','')
            };
        } catch (e) {
            self.log.error('[Google] - getAdSize', 'domNode', domNode, 'first div element', domNode.querySelector('div'));
        }
        return {};
    };

    function adsizeToString(adsize) {
        return adsize.width && adsize.height ? adsize.width + 'x' + adsize.height : undefined;
    }

    server.splitMultiResponse = function(domNode) { return []; };
    server.getAdFormByMetaData = function(meta, fallbackAllowed) {
        return meta ? (adformats[meta.adsize] || (fallbackAllowed ? meta.adsize : undefined)) : undefined;
    };
    server.getEventsByMetaData = function(meta) {
        return {
            form: server.getAdFormByMetaData(meta),
            size: meta.adsize,
        _:0};
    };

    server.getMetaData = function(slot) {
        var googleSlot = this.getGoogleSlot(slot.id),
            responseInformation = googleSlot.getResponseInformation();
            adMeta = {
                adsize: adsizeToString(server.getAdSize(slot.getDomNode())),
                tagid: slot.id,
                portal: this.params.portal,
                category: this.params.category,
                section: this.params.section,
                network: this.params.network,
                sectionlong: this.params.sectionlong
            };

        return extend({}, adMeta, responseInformation);
    };

    server.renderMeta = function(domNode) {
        var slot = self._getAdSlot(domNode);
        var metaHtml = '<uim:ad xmlns:uim="urn:publicid:-:UIM:adinfo" ';
        each(this.getMetaData(slot), function(name, value) {
            metaHtml += name+'="'+value+'" ';
        });
        metaHtml += '></uim:ad>\n';
        slot.getTarget().insertAdjacentHTML('afterbegin', metaHtml);
    };

    server.setSizes = function(sizeTable) {
        each(sizeTable, function(slot, sizes) {
            self.AdSlot(slot).setParam('sizes', sizes);
        });
    };

    server.isAlive = function() { return true; };
    server.isSingleRequestEnabled = function() { return singleRequestEnabled; };

    server.getGoogleSlots = function() {
        return googleSlots;
    };
    server.getGoogleSlot = function(slot) {
        return googleSlots[slot];
    };

    server.getAdUnitPath = function(slot) {
        return ['', server.params.network, server.params.portal, server.params.category, server.params.section, slot.id].join('/');
    };

    /**
     * initialize the google adslots with its adpath, sizes and dom id (adslot.generateDomId)
     * initialized slots are saved into googleSlots
     * @param  {string} slot
     */
    server._global.slotDomNodeInit = function(slot) {
        if (!slot.getAdServer().isEnabled()) {
            var data = {
              'slot': slot,
              'cancelReason' : 'server.disabled'
            };
            self.trigger('ad.cancel', slot, data);
            return self;
        }

        var containerWidth = slot.getParam('maxwidth') || slot.getContainerWidth();
        self.log('[Google] slot getContainerWidth ', slot, containerWidth);

        var sizes = slot.getParam('sizes' ,[]).sizes || [];

        var filteredSizes = sizes.filter(function(size) {
            if(containerWidth >= size[0] || size === 'fluid') {
                return size;
            }
        });
        self.log('[Google] filtered sizes ', slot, filteredSizes);


        if(filteredSizes.length === 0) {
            delete googleSlots[slot];
            slot.disable();
            self.log('[Google] slot.disabled', slot);
            var data = {
              'slot': slot,
              'cancelReason' : 'slot.disabled'
            };
            self.trigger('ad.cancel', slot, data);
            return;
        }

        googletag.cmd.push(function() {
            var slotSizes = slot.getParam('sizes');
self.log('[Google] - slotDomNodeInit', slot.domId, server.getAdUnitPath(slot), slotSizes, slot);
            var response = googletag.defineSlot(server.getAdUnitPath(slot), filteredSizes || [], slot.domId).addService(googletag.pubads()); 

            if(slotSizes.mappingSizes) {
                var mapping = googletag.sizeMapping();
                slotSizes.mappingSizes.forEach(function(size){
                    mapping = mapping.addSize(size[0],size[1]);
                });
                mapping = mapping.build();
                self.log('[Google] mapping', mapping);
                response = response.defineSizeMapping(mapping);
            }

            googleSlots[slot] = response;
self.log('[Google] - slotDomNodeInit response', slot, response);
        });
    };

    server._global.ad = function(slot, isRefresh) {
        slot = self._getAdSlot(slot);
        var data = {
            slot: slot,
            target: slot.getTarget(),
            deferred: false,
            isRefresh: !!isRefresh || !!slot.getParam('isRefresh'),
        _:0};

        if (!slot.isEnabled()) {
            data.cancelReason = 'slot.disabled';
            self.trigger('ad.cancel', slot, data);
            return self;
        }
        if (!slot.getAdServer().isEnabled()) {
            data.cancelReason = 'server.disabled';
            self.trigger('ad.cancel', slot, data);
            return self;
        }
        var checkEnabled = slot.getConfig('checkEnabled', slot.getAdServer().getConfig('checkEnabled', self.getConfig('checkEnabled', true)));
        if (typeof checkEnabled === 'function') {
            try {
                checkEnabled = checkEnabled(slot, data);
            } catch (e) {
                self.log.error('Error in function supplied for AdService.AdSlot('+slot.id+').setConfig(\'checkEnabled\', func)', e, arguments, data, this);
            }
        }
        if (!checkEnabled) {
            data.cancelReason = 'checked.disabled';
            self.trigger('ad.cancel', slot, data);
            return self;
        }

        self.trigger('ad.begin', slot, data);

        if (data.deferred && !slot.isIndependent) {
            self.trigger('ad.deferred', slot, data);
            return self;
        }

        googletag.cmd.push(function() {
            self.log('[Google] - ad', slot, slot.getDomNode().id);

            var secure = self.AdSlot(slot).getConfig('secure');
            if(typeof secure !== 'undefined') {
                self.log('[Google] - ad setForceSafeFrame', slot, secure);
                googleSlots[slot].setForceSafeFrame(secure);
            }
            var safeFrameConfig = self.AdSlot(slot).getConfig('safeFrameConfig');
            if(typeof safeFrameConfig !== 'undefined') {
                self.log('[Google] - ad setSafeFrameConfig', slot, safeFrameConfig);
                googleSlots[slot].setSafeFrameConfig(safeFrameConfig);
            }

            serverParams = server.getParams();
            serverParamsSet = true;
            each(serverParams, function(key, value) {
                if(!globalParamsBlacklist.includes(key)) {
                    googletag.pubads().setTargeting(key, value);
                }
            });

            slotParams = server.getParamsForSlot(slot);
            each(serverParams, function(key, value) {
                if(slotParams.hasOwnProperty(key)) {
                    delete slotParams[key];
                }
            });

            each(slotParams, function(key, value) {
                if(!slotParamsBlacklist.includes(key)) {
                  googleSlots[slot].setTargeting(key, value);
                }
            });
            googleSlots[slot].setTargeting('tagid', slot);

            requestedGoogleSlots[slot] = googleSlots[slot];

            googletag.enableServices();

            if(data.isRefresh) {
                self.log('[Google] ad refresh', slot, data.isRefresh);
                googletag.pubads().refresh([server.getGoogleSlot(slot)]);
            }

            if(!singleRequestEnabled && !data.isRefresh) {
                self.log('[Google] normal display', slot);
                googletag.display(slot.getDomNode().id);
                self._getAdSlot(slot).clearOnetimeParams();
            }

            var singleRequestReady = isSingleRequestReady(server.getConfig('singleRequestSlots'), Object.keys(requestedGoogleSlots));

            if(singleRequestEnabled && singleRequestReady) {
                self.log('[Google] singleRequest display', Object.keys(googleSlots));
                each(googleSlots, function(slot) {
                    googletag.display(self._getAdSlot(slot).getDomNode().id);
                    self._getAdSlot(slot).clearOnetimeParams();
                });
            }

        });
    };

    function isSingleRequestReady(singleRequestSlots, googleSlots) {
        each(googleSlots, function(i, googleSlot) {
            var index = singleRequestSlots.indexOf(googleSlot);
            if (index > -1) {
                singleRequestSlots.splice(index, 1);
            }
        });
        return singleRequestSlots.length === 0;
    }

    server._global.refresh = function() {
        var slots = arguments.length ? (arguments[0] instanceof Array ? arguments[0] : [arguments[0]]) : Object.keys(googleSlots);
        var refreshSlots = slots.filter(function(e) { return googleSlots[e]; }).map(function(e) { return googleSlots[e]; });

        each(slots, function(i, slot) {
            self.AdSlot(slot).setOnetimeParam('isRefresh',true);
            self.ad(slot, true);
        });

    };

    server._global.auctionResultHtml = function(data) {
        self.log('[Google] - auctionResultHtml');
        var iframeSrc = 'about:blank',
        width = data.size.width,
        height = data.size.height,
        iframeAttrs = {width: width, height: height, frameborder: 0, border: 0, scrolling: 'no', marginwidth: 0, marginheight: 0, sandbox: 'allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts'};

        var iframe = self.createElement('iframe', iframeAttrs, {src: iframeSrc});
        document.body.appendChild(iframe);

        var iframeWindow = iframe.contentWindow,
        iframeDocument = iframeWindow.document;
        iframeDocument.open();

        iframeDocument.write(data.html);

        self.adInserted();
        return true;
    };

    if(typeof googletag !== "undefined" && typeof googletag.cmd !== "undefined") {
        googletag.cmd.push(function () {
            googletag.pubads().addEventListener('slotRenderEnded', function(e) {
                self.log('[Google] - slotRenderEnded',e);
                setGoogleDebug();
                try {
                  server.renderMeta(document.getElementById(e.slot.getSlotElementId())); 
                } catch (err) { }
            });
        });
    }

    self.on('ad.cancel', function(data) {
        if(self.getDefaultAdServer().id !== 'google') { return; }
        var slots = server.getConfig('singleRequestSlots');
        slots.splice(slots.indexOf(data.slot.id),1);
    });

    server.activate();
}).apply(self, [AdService]);

    AdService._initialize();

})();


